define(["underscore","@bingads-webui-clientcenter/window-interface","urijs","@bingads-webui-clientcenter/common-utils","@bingads-webui-clientcenter/address"], function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__37__, __WEBPACK_EXTERNAL_MODULE__116__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 88);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__37__;

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(89);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserUtils = exports.UserRoleUtils = exports.UKFCAVerificationUtils = exports.TaxUtils = exports.PermissionUtils = exports.PaymentUtils = exports.LanguageUtils = exports.InsertionOrderUtils = exports.FraudAppealUtils = exports.CustomerUtils = exports.CurrencyUtils = exports.CouponUtils = exports.CountryUtils = exports.ConsolidatedBillingUtils = exports.BillingUtils = exports.AdjustmentReasonUtils = exports.AccountUtils = exports.AccountIdentityVerificationUtils = exports.ABLUtils = exports.Constants = void 0;

var Constants = _interopRequireWildcard(__webpack_require__(90));

exports.Constants = Constants;

var ABLUtils = _interopRequireWildcard(__webpack_require__(115));

exports.ABLUtils = ABLUtils;

var AccountIdentityVerificationUtils = _interopRequireWildcard(__webpack_require__(117));

exports.AccountIdentityVerificationUtils = AccountIdentityVerificationUtils;

var AccountUtils = _interopRequireWildcard(__webpack_require__(118));

exports.AccountUtils = AccountUtils;

var AdjustmentReasonUtils = _interopRequireWildcard(__webpack_require__(122));

exports.AdjustmentReasonUtils = AdjustmentReasonUtils;

var BillingUtils = _interopRequireWildcard(__webpack_require__(123));

exports.BillingUtils = BillingUtils;

var ConsolidatedBillingUtils = _interopRequireWildcard(__webpack_require__(124));

exports.ConsolidatedBillingUtils = ConsolidatedBillingUtils;

var CountryUtils = _interopRequireWildcard(__webpack_require__(119));

exports.CountryUtils = CountryUtils;

var CouponUtils = _interopRequireWildcard(__webpack_require__(125));

exports.CouponUtils = CouponUtils;

var CurrencyUtils = _interopRequireWildcard(__webpack_require__(120));

exports.CurrencyUtils = CurrencyUtils;

var CustomerUtils = _interopRequireWildcard(__webpack_require__(127));

exports.CustomerUtils = CustomerUtils;

var FraudAppealUtils = _interopRequireWildcard(__webpack_require__(128));

exports.FraudAppealUtils = FraudAppealUtils;

var InsertionOrderUtils = _interopRequireWildcard(__webpack_require__(129));

exports.InsertionOrderUtils = InsertionOrderUtils;

var LanguageUtils = _interopRequireWildcard(__webpack_require__(130));

exports.LanguageUtils = LanguageUtils;

var PaymentUtils = _interopRequireWildcard(__webpack_require__(131));

exports.PaymentUtils = PaymentUtils;

var PermissionUtils = _interopRequireWildcard(__webpack_require__(132));

exports.PermissionUtils = PermissionUtils;

var TaxUtils = _interopRequireWildcard(__webpack_require__(126));

exports.TaxUtils = TaxUtils;

var UKFCAVerificationUtils = _interopRequireWildcard(__webpack_require__(133));

exports.UKFCAVerificationUtils = UKFCAVerificationUtils;

var UserRoleUtils = _interopRequireWildcard(__webpack_require__(134));

exports.UserRoleUtils = UserRoleUtils;

var UserUtils = _interopRequireWildcard(__webpack_require__(135));

exports.UserUtils = UserUtils;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _accountIdentityVerification = __webpack_require__(91);

Object.keys(_accountIdentityVerification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _accountIdentityVerification[key];
    }
  });
});

var _account = __webpack_require__(92);

Object.keys(_account).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _account[key];
    }
  });
});

var _accountVerifications = __webpack_require__(93);

Object.keys(_accountVerifications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _accountVerifications[key];
    }
  });
});

var _adjustmentReason = __webpack_require__(94);

Object.keys(_adjustmentReason).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _adjustmentReason[key];
    }
  });
});

var _billing = __webpack_require__(95);

Object.keys(_billing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _billing[key];
    }
  });
});

var _budgetCenter = __webpack_require__(96);

Object.keys(_budgetCenter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _budgetCenter[key];
    }
  });
});

var _campaign = __webpack_require__(97);

Object.keys(_campaign).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _campaign[key];
    }
  });
});

var _common = __webpack_require__(98);

Object.keys(_common).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _common[key];
    }
  });
});

var _consolidatedBilling = __webpack_require__(99);

Object.keys(_consolidatedBilling).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _consolidatedBilling[key];
    }
  });
});

var _country = __webpack_require__(101);

Object.keys(_country).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _country[key];
    }
  });
});

var _coupon = __webpack_require__(102);

Object.keys(_coupon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _coupon[key];
    }
  });
});

var _currency = __webpack_require__(103);

Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _currency[key];
    }
  });
});

var _customer = __webpack_require__(104);

Object.keys(_customer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _customer[key];
    }
  });
});

var _insertionOrder = __webpack_require__(105);

Object.keys(_insertionOrder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _insertionOrder[key];
    }
  });
});

var _linking = __webpack_require__(106);

Object.keys(_linking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _linking[key];
    }
  });
});

var _notification = __webpack_require__(107);

Object.keys(_notification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _notification[key];
    }
  });
});

var _payment = __webpack_require__(108);

Object.keys(_payment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _payment[key];
    }
  });
});

var _permission = __webpack_require__(109);

Object.keys(_permission).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _permission[key];
    }
  });
});

var _recommendation = __webpack_require__(110);

Object.keys(_recommendation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _recommendation[key];
    }
  });
});

var _regularExpression = __webpack_require__(111);

Object.keys(_regularExpression).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _regularExpression[key];
    }
  });
});

var _tax = __webpack_require__(100);

Object.keys(_tax).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tax[key];
    }
  });
});

var _ukFcaVerification = __webpack_require__(112);

Object.keys(_ukFcaVerification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ukFcaVerification[key];
    }
  });
});

var _tradeScreeningTransformation = __webpack_require__(113);

Object.keys(_tradeScreeningTransformation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tradeScreeningTransformation[key];
    }
  });
});

var _dsaEnforcement = __webpack_require__(114);

Object.keys(_dsaEnforcement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dsaEnforcement[key];
    }
  });
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AivAblValidationRuleName = exports.AivFailureReasons = exports.OrderedUnableTriggerAivReasons = exports.UnableTriggerAivReason = exports.DocumentVerifiedStatus = exports.VerificationType = exports.AccountVerificationStatusIconMapping = exports.AccountToAblVerificationStatusRelation = exports.AccountVerificationVerifiedStatusList = exports.AccountVerificationFailedStatusList = exports.ChinaAIVStatusToGlobalAIVStatusMapping = exports.ChinaAccountVerificationStatus = exports.AccountVerificationStatus = exports.ABLVerificationVerifiedStatusList = exports.ABLVerificationFailedStatusList = exports.ABLVerificationStatus = void 0;
const ABLVerificationStatus = {
  Failed: 1,
  OverrideFailed: 2,
  ActionRequired: 3,
  NotVerified: 4,
  InPending: 5,
  Verified: 6,
  OverrideVerified: 7,
  VerifiedLimited: 9
};
exports.ABLVerificationStatus = ABLVerificationStatus;
const ABLVerificationFailedStatusList = [ABLVerificationStatus.Failed, ABLVerificationStatus.OverrideFailed];
exports.ABLVerificationFailedStatusList = ABLVerificationFailedStatusList;
const ABLVerificationVerifiedStatusList = [ABLVerificationStatus.Verified, ABLVerificationStatus.OverrideVerified, ABLVerificationStatus.VerifiedLimited];
exports.ABLVerificationVerifiedStatusList = ABLVerificationVerifiedStatusList;
const AccountVerificationStatus = {
  Failed: 1,
  OverrideFailed: 2,
  ActionRequired: 3,
  NeedVerified: 4,
  InPending: 5,
  Verified: 6,
  OverrideVerified: 7,
  NoNeedVerified: 8,
  VerifiedLimited: 9
};
exports.AccountVerificationStatus = AccountVerificationStatus;
const ChinaAccountVerificationStatus = {
  Failed: 61,
  ActionRequired: 62,
  NeedVerified: 63,
  InPending: 64,
  Verified: 65,
  LicenseExpired: 66
};
exports.ChinaAccountVerificationStatus = ChinaAccountVerificationStatus;
const ChinaAIVStatusToGlobalAIVStatusMapping = {
  [ChinaAccountVerificationStatus.Failed]: AccountVerificationStatus.Failed,
  [ChinaAccountVerificationStatus.ActionRequired]: AccountVerificationStatus.ActionRequired,
  [ChinaAccountVerificationStatus.NeedVerified]: AccountVerificationStatus.NeedVerified,
  [ChinaAccountVerificationStatus.InPending]: AccountVerificationStatus.InPending,
  [ChinaAccountVerificationStatus.Verified]: AccountVerificationStatus.Verified,
  [ChinaAccountVerificationStatus.LicenseExpired]: AccountVerificationStatus.Failed
};
exports.ChinaAIVStatusToGlobalAIVStatusMapping = ChinaAIVStatusToGlobalAIVStatusMapping;
const AccountVerificationFailedStatusList = [AccountVerificationStatus.Failed, AccountVerificationStatus.OverrideFailed];
exports.AccountVerificationFailedStatusList = AccountVerificationFailedStatusList;
const AccountVerificationVerifiedStatusList = [AccountVerificationStatus.Verified, AccountVerificationStatus.OverrideVerified, AccountVerificationStatus.VerifiedLimited];
exports.AccountVerificationVerifiedStatusList = AccountVerificationVerifiedStatusList;
const AccountToAblVerificationStatusRelation = {
  [AccountVerificationStatus.Failed]: ABLVerificationFailedStatusList,
  [AccountVerificationStatus.OverrideFailed]: ABLVerificationFailedStatusList,
  [AccountVerificationStatus.ActionRequired]: [ABLVerificationStatus.ActionRequired],
  [AccountVerificationStatus.NeedVerified]: [ABLVerificationStatus.NotVerified],
  [AccountVerificationStatus.InPending]: [ABLVerificationStatus.InPending],
  [AccountVerificationStatus.Verified]: ABLVerificationVerifiedStatusList,
  [AccountVerificationStatus.OverrideVerified]: ABLVerificationVerifiedStatusList,
  [AccountVerificationStatus.NoNeedVerified]: null,
  // This value indicates that any ABLVerificationStatus is OK. Choosing nul arbitrary, can be changed later per need.
  [AccountVerificationStatus.VerifiedLimited]: ABLVerificationVerifiedStatusList
};
exports.AccountToAblVerificationStatusRelation = AccountToAblVerificationStatusRelation;
const AccountVerificationStatusIconMapping = {
  Failed: {
    glyph: 'ba-Error',
    iconStyle: 'error',
    textStyle: 'error'
  },
  OverrideFailed: {
    glyph: 'ba-Error',
    iconStyle: 'error',
    textStyle: 'error'
  },
  ActionRequired: {
    glyph: 'ba-Warning',
    iconStyle: 'error',
    textStyle: 'error'
  },
  NeedVerified: {
    glyph: 'ba-Warning',
    iconStyle: 'warning',
    textStyle: 'warning'
  },
  InPending: {
    glyph: 'ba-HourGlass',
    iconStyle: 'default',
    textStyle: 'default'
  },
  Verified: {
    glyph: 'ba-VerifiedBrandSolid',
    iconStyle: 'primary'
  },
  OverrideVerified: {
    glyph: 'ba-VerifiedBrandSolid',
    iconStyle: 'primary'
  },
  NoNeedVerified: {
    glyph: 'ba-Info',
    iconStyle: 'default',
    textStyle: 'default'
  },
  VerifiedLimited: {
    glyph: 'ba-VerifiedBrandSolid',
    iconStyle: 'primary'
  }
};
exports.AccountVerificationStatusIconMapping = AccountVerificationStatusIconMapping;
const VerificationType = {
  Individual: '1',
  Business: '2'
};
exports.VerificationType = VerificationType;
const DocumentVerifiedStatus = {
  NotVerified: 1,
  Verified: 2,
  Failed: 3
};
exports.DocumentVerifiedStatus = DocumentVerifiedStatus;
const UnableTriggerAivReason = {
  InternalUser: 1,
  NoRemainingRetryCount: 2,
  UserRoleMismatch: 3,
  NotAccountOwner: 4,
  InitializeInProgress: 5,
  OverrideFailed: 6
};
exports.UnableTriggerAivReason = UnableTriggerAivReason;
const OrderedUnableTriggerAivReasons = [UnableTriggerAivReason.InternalUser, UnableTriggerAivReason.NotAccountOwner, UnableTriggerAivReason.UserRoleMismatch, UnableTriggerAivReason.OverrideFailed, UnableTriggerAivReason.NoRemainingRetryCount, UnableTriggerAivReason.InitializeInProgress];
exports.OrderedUnableTriggerAivReasons = OrderedUnableTriggerAivReasons;
const AivFailureReasons = {
  Onfido_Rejected_ImageIntegrity_ImageQuality: 101,
  Onfido_Rejected_ImageIntegrity_SupportedDocument: 102,
  Onfido_Rejected_ImageIntegrity_ColourPicture: 103,
  Onfido_Caution_DataConsistency_MultipleDataSourcesPresent: 104,
  Onfido_Caution_VisualAuthenticity_OriginalDocumentPresent: 105,
  Onfido_Caution_FaceComparison_FaceMatch: 106,
  Onfido_Caution_DataValidation_DocumentExpiration: 107,
  Onfido_Caution_DataComparison_FirstName: 108,
  Onfido_Caution_DataComparison_LastName: 109,
  Onfido_Caution_ImageIntegrity_ConclusiveDocumentQuality: 110,
  Onfido_Caution_ImageIntegrity_ColorPicture: 111,
  Onfido_Caution_ImageIntegrity_PictureUnavailableInDocument: 112,
  OneVet_Email_Verification_Failure: 201,
  OneVet_Business_Verification_Failure: 202,
  OneVet_Domain_Verification_Failure: 203,
  // China Aiv Reject Reason, from 1000000 -> 1000032
  SUBJECT_QUALIFICATION_THE_QUALIFICATION_PICTURE_IS_NOT_CLEAR: 1000000,
  SUBJECT_QUALIFICATION_QUALIFICATION_EXPIRED: 1000001,
  SUBJECT_QUALIFICATION_DISCREPANCY_IN_BUSINESS_SCOPE: 1000002,
  SUBJECT_QUALIFICATION_THE_ACCOUNT_OPENING_ENTITY_IS_OPERATING_ABNORMALLY: 1000003,
  SUBJECT_QUALIFICATION_THE_UNIFIED_SOCIAL_CREDIT_CODE_WAS_FILLED_IN_INCORRECTLY: 1000004,
  SUBJECT_QUALIFICATION_FALSE_QUALIFICATION: 1000005,
  SUBJECT_QUALIFICATION_QUALIFICATION_PICTURE_UPLOAD_ERROR: 1000006,
  SUBJECT_QUALIFICATION_THE_QUALIFICATION_FILE_HAS_A_RESTRICTED_WATERMARK: 1000007,
  SUBJECT_QUALIFICATION_THE_COMPANY_NAME_IS_INCORRECT: 1000008,
  SUBJECT_QUALIFICATION_THE_QUALIFICATION_DOCUMENTS_ARE_INCOMPLETE: 1000009,
  SUBJECT_QUALIFICATION_PLEASE_CONTACT_YOUR_SALES_AGENT_FOR_ADVICE: 1000010,
  INDUSTRY_QUALIFICATION_THE_QUALIFICATION_PICTURE_IS_NOT_CLEAR: 1000011,
  INDUSTRY_QUALIFICATION_QUALIFICATION_EXPIRED: 1000012,
  INDUSTRY_QUALIFICATION_DISCREPANCY_IN_BUSINESS_SCOPE: 1000013,
  INDUSTRY_QUALIFICATION_THE_ACCOUNT_OPENING_ENTITY_IS_OPERATING_ABNORMALLY: 1000014,
  INDUSTRY_QUALIFICATION_THE_UNIFIED_SOCIAL_CREDIT_CODE_WAS_FILLED_IN_INCORRECTLY: 1000015,
  INDUSTRY_QUALIFICATION_FALSE_QUALIFICATION: 1000016,
  INDUSTRY_QUALIFICATION_QUALIFICATION_PICTURE_UPLOAD_ERROR: 1000017,
  INDUSTRY_QUALIFICATION_THE_QUALIFICATION_FILE_HAS_A_RESTRICTED_WATERMARK: 1000018,
  INDUSTRY_QUALIFICATION_THE_COMPANY_NAME_IS_INCORRECT: 1000019,
  INDUSTRY_QUALIFICATION_THE_QUALIFICATION_DOCUMENTS_ARE_INCOMPLETE: 1000020,
  INDUSTRY_QUALIFICATION_PLEASE_CONTACT_YOUR_SALES_AGENT_FOR_ADVICE: 1000021,
  OTHERS_THE_QUALIFICATION_PICTURE_IS_NOT_CLEAR: 1000022,
  OTHERS_QUALIFICATION_EXPIRED: 1000023,
  OTHERS_DISCREPANCY_IN_BUSINESS_SCOPE: 1000024,
  OTHERS_THE_ACCOUNT_OPENING_ENTITY_IS_OPERATING_ABNORMALLY: 1000025,
  OTHERS_THE_UNIFIED_SOCIAL_CREDIT_CODE_WAS_FILLED_IN_INCORRECTLY: 1000026,
  OTHERS_FALSE_QUALIFICATION: 1000027,
  OTHERS_QUALIFICATION_PICTURE_UPLOAD_ERROR: 1000028,
  OTHERS_THE_QUALIFICATION_FILE_HAS_A_RESTRICTED_WATERMARK: 1000029,
  OTHERS_THE_COMPANY_NAME_IS_INCORRECT: 1000030,
  OTHERS_THE_QUALIFICATION_DOCUMENTS_ARE_INCOMPLETE: 1000031,
  OTHERS_PLEASE_CONTACT_YOUR_SALES_AGENT_FOR_ADVICE: 1000032
};
exports.AivFailureReasons = AivFailureReasons;
const AivAblValidationRuleName = 'AccountIdentityVerification';
exports.AivAblValidationRuleName = AivAblValidationRuleName;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountFeaturePilots = exports.AccountAutoTaggingType = exports.AccountCustomerRelationLifecycleStatus = exports.AccountEditMode = exports.AccountMode = exports.AccountActivityStatus = exports.AccountInactiveCauseValue = exports.AccountInactiveCauseCode = exports.AccountInactiveReasonValue = exports.AccountInactiveReasonCode = exports.AccountLifecycleStatus = exports.AccountFinancialStatusBit = exports.AccountAssociationType = exports.AccountFinancialStatus = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AccountFinancialStatus = Object.freeze({
  Active: 31,
  Inactive: 32,
  Proposed: 34,
  PendingCreditCheck: 35,
  NoHold: 36,
  SoldToOnly: 37,
  CreditWarning: 38,
  Hold: 39,
  WriteOff: 223,
  TaxOnHold: 253,
  UserHold: 254
});
exports.AccountFinancialStatus = AccountFinancialStatus;
const AccountAssociationType = Object.freeze({
  Primary: 1,
  Backup: 2,
  None: 3
});
exports.AccountAssociationType = AccountAssociationType;
const AccountFinancialStatusBit = Object.freeze({
  CreditHold: 1,
  CLEHold: 2,
  PIHold: 4,
  ManualHold: 8
});
exports.AccountFinancialStatusBit = AccountFinancialStatusBit;
const AccountLifecycleStatus = Object.freeze({
  Blocked: 28,
  Pending: 29,
  Draft: 30,
  Active: 31,
  Inactive: 32,
  Deleted: 33,
  // deprecated
  Pause: 42,
  Suspended: 43
});
exports.AccountLifecycleStatus = AccountLifecycleStatus;
const AccountInactiveReasonCode = Object.freeze({
  NotSet: 0,
  PausedDueToSystemIssue: 1,
  PausedZeroBalance: 2,
  PausedNoValidIO: 3,
  Processing: 4,
  PendingPaymentMethod: 5,
  PendingNewCustomer: 6,
  Inactive: 7,
  Hold: 8,
  Deleted: 9
});
exports.AccountInactiveReasonCode = AccountInactiveReasonCode;

const AccountInactiveReasonValue = _underscore.default.mapObject(AccountInactiveReasonCode, (value, key) => key);

exports.AccountInactiveReasonValue = AccountInactiveReasonValue;
const AccountInactiveCauseCode = Object.freeze({
  NotSet: 0,
  PausedDueToSystemIssue: 1,
  PausedZeroBalance: 2,
  PausedNoValidIO: 3,
  Processing: 4,
  PendingPaymentMethod: 5,
  PendingNewCustomer: 6,
  Inactive: 7,
  Hold: 8,
  AccountLifecycleStatusSuspended: 9,
  AccountLifecycleStatusDraft: 10,
  AccountLifecycleStatusDeleted: 11,
  AccountLifecycleStatusUserPause: 12,
  AccountFinancialStatusProposed: 13,
  AccountFinancialStatusWriteOff: 14,
  AccountFinancialStatusTaxOnHold: 15,
  AccountFinancialStatusUserHold: 16,
  AccountFinancialStatusPendingCreditCheck: 17,
  AccountFinancialStatusSoldToOnly: 18,
  AdvertiserCustomerLifecycleStatusDraft: 19,
  AdvertiserCustomerLifecycleStatusInactive: 20,
  AdvertiserCustomerLifecycleStatusDeleted: 21,
  AdvertiserCustomerFraudStatusFraud: 22,
  BillToCustomerLifecycleStatusDraft: 23,
  BillToCustomerLifecycleStatusInactive: 24,
  BillToCustomerLifecycleStatusDeleted: 25,
  BillToCustomerFinancialStatusProposalsOnly: 26,
  BillToCustomerFinancialStatusSoldToOnly: 27,
  BillToCustomerFraudStatusFraud: 28,
  AccountLifecycleStatusNotSet: 29,
  AccountFinancialStatusNotSet: 30,
  AdvertiserCustomerLifecycleStatusNotSet: 31,
  AdvertiserCustomerFraudStatusNotSet: 32,
  BillToCustomerLifecycleStatusNotSet: 33,
  BillToCustomerFinancialStatusNotSet: 34,
  BillToCustomerFraudStatusNotSet: 35,
  UserDeleted: 36,
  SystemNoSpendDeactivated: 37,
  AccountVerificationHold: 39
});
exports.AccountInactiveCauseCode = AccountInactiveCauseCode;

const AccountInactiveCauseValue = _underscore.default.mapObject(AccountInactiveCauseCode, (value, key) => key);

exports.AccountInactiveCauseValue = AccountInactiveCauseValue;
const AccountActivityStatus = Object.freeze({
  Enabled: 'Enabled',
  Deleted: 'Deleted',
  Errors: 'Errors'
});
exports.AccountActivityStatus = AccountActivityStatus;
const AccountMode = Object.freeze({
  Legacy: null,
  Expert: 0,
  Smart: 1,
  UnifiedSmart: 2,
  UnifiedExpert: 3
});
exports.AccountMode = AccountMode;
const AccountEditMode = Object.freeze({
  FixIndiaTax: 1
});
exports.AccountEditMode = AccountEditMode;
const AccountCustomerRelationLifecycleStatus = Object.freeze({
  Pending: 160,
  Active: 168,
  Deleted: 169
});
exports.AccountCustomerRelationLifecycleStatus = AccountCustomerRelationLifecycleStatus;
const AccountAutoTaggingType = Object.freeze({
  Off: 'Off',
  CustomerOverride: 'CustomerOverride',
  BingAdsOverride: 'BingAdsOverride'
});
exports.AccountAutoTaggingType = AccountAutoTaggingType;
const AccountFeaturePilots = Object.freeze({
  SingleAccountIdentityVerification: 888
});
exports.AccountFeaturePilots = AccountFeaturePilots;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderedCNQualificationUnableCreateReason = exports.CNQualificationUnableCreateReason = exports.CNQualificationStatus = exports.CNQualificationType = exports.TokenVerificationScenario = void 0;
const TokenVerificationScenario = {
  AIV: 1,
  FCA: 2,
  CN: 3
}; // China qualification type

exports.TokenVerificationScenario = TokenVerificationScenario;
const CNQualificationType = {
  Industry: 0,
  Supplementary: 1
}; // China qualification verification status

exports.CNQualificationType = CNQualificationType;
const CNQualificationStatus = {
  Failed: 71,
  ActionRequired: 72,
  NotVerified: 73,
  Pending: 74,
  Verified: 75,
  LicenseExpired: 76
};
exports.CNQualificationStatus = CNQualificationStatus;
const CNQualificationUnableCreateReason = {
  InternalUser: 1,
  UserRoleMismatch: 3,
  InitializeInProgress: 5
};
exports.CNQualificationUnableCreateReason = CNQualificationUnableCreateReason;
const OrderedCNQualificationUnableCreateReason = [CNQualificationUnableCreateReason.InitializeInProgress, CNQualificationUnableCreateReason.InternalUser, CNQualificationUnableCreateReason.UserRoleMismatch];
exports.OrderedCNQualificationUnableCreateReason = OrderedCNQualificationUnableCreateReason;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentReason = void 0;
const AdjustmentReason = {
  None: 0,
  CustomerRetention: 41,
  CreditAndRebill: 42,
  CreditAndRebillTaxIssue: 43,
  Fraud: 44,
  SystemIssues: 45,
  InternalUserError: 46,
  VolatileTrafficComplaint: 47,
  Broadmatch: 48,
  PrepayBalanceRefund: 50,
  AccountCompromised: 52,
  TravelSpecialProgram: 53
};
exports.AdjustmentReason = AdjustmentReason;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndiaEMandateOfficialUrl = exports.AccountBillMeNowStatus = exports.DefaultMinBillingThreshold = exports.PaymodErrorCodes = exports.IndiaDualInvoiceType = exports.APContactMode = exports.APContactStatus = exports.ApContactType = exports.IndiaEInvoicingStatus = exports.BillingDocumentRenderingMethod = exports.CreditMemoDocumentType = exports.DocumentType = void 0;
const DocumentType = Object.freeze({
  CurrentActivity: 'CurrentActivity',
  PrePaidInvoices: 'PrePaidInvoices',
  PrePaidStatement: 'PrePaidStatement',
  SelfServeInvoice: 'SelfServeInvoice',
  Invoice: 'Invoice',
  Pending: 'pending',
  // small case from MT, but i18n string still camelCase
  Invoices: 'Invoices',
  CreditMemoInvoice: 'CreditMemoInvoice',
  PostPaidStatement: 'PostPaidStatement',
  PrepaidCreditMemoInvoice: 'PrepaidCreditMemoInvoice',
  PrepaidChargebackInvoice: 'PrepaidChargebackInvoice',
  PrepaidRefundReversalInvoice: 'PrepaidRefundReversalInvoice',
  WriteOffCreditMemo: 'WriteOffCreditMemo',
  MonthlyStatement: 'MonthlyStatement'
});
exports.DocumentType = DocumentType;
const CreditMemoDocumentType = [DocumentType.CreditMemoInvoice, DocumentType.PrepaidCreditMemoInvoice, DocumentType.PrepaidChargebackInvoice, DocumentType.WriteOffCreditMemo];
exports.CreditMemoDocumentType = CreditMemoDocumentType;
const BillingDocumentRenderingMethod = Object.freeze({
  Account: 0,
  Billing: 1,
  Adjustment: 2
});
exports.BillingDocumentRenderingMethod = BillingDocumentRenderingMethod;
const IndiaEInvoicingStatus = Object.freeze({
  NotStarted: 0,
  Available: 1,
  Failed: 2,
  PendingSupport: 3,
  PendingIRNGeneration: 4,
  PendingCustomerAction: 5,
  PendingCreditAndRebill: 7
});
exports.IndiaEInvoicingStatus = IndiaEInvoicingStatus;
const ApContactType = Object.freeze({
  SAPLevel: 0,
  AccountLevel: 1
});
exports.ApContactType = ApContactType;
const APContactStatus = Object.freeze({
  PendingUserValidation: 0,
  Active: 1,
  Deleted: 2,
  Inactive: 3,
  PendingSystemValidation: 4,
  SystemValidationFailure: 5,
  Unknown: 6
});
exports.APContactStatus = APContactStatus;
const APContactMode = Object.freeze({
  Static: 'static',
  Edit: 'edit',
  Create: 'create'
});
exports.APContactMode = APContactMode;
const IndiaDualInvoiceType = Object.freeze({
  Default: 0,
  RecipientCopy: 1,
  SupplierCopy: 2
});
exports.IndiaDualInvoiceType = IndiaDualInvoiceType;
const PaymodErrorCodes = Object.freeze({
  AuthorizationExpired: 'authorization_expired',
  ProcessorDeclined: 'processor_declined',
  ExpiredPaymentInstrument: 'expired_payment_instrument',
  ProcessorRiskcheckDeclined: 'processor_riskcheck_declined',
  AmountLimitExceeded: 'amount_limit_exceeded',
  InvalidPaymentInstrument: 'invalid_payment_instrument',
  InsufficientFund: 'insufficient_fund',
  MissingFundingSource: 'missing_funding_source',
  IncorrectPinOrPasscode: 'incorrect_pin_or_passcode',
  TransactionNotAllowed: 'transaction_not_allowed',
  MissingSessionData: 'missing_session_data',
  InvalidTransactionData: 'invalid_transaction_data',
  InvalidTransactionDataPrepay: 'invalid_transaction_data_12',
  InvalidTransactionDataThreshold: 'invalid_transaction_data_1',
  RiskReject: 'risk_evaluation_declined',
  AuthRequired: 'authentication_required',
  CVVValueMismatch: 'cvv_value_mismatch'
});
exports.PaymodErrorCodes = PaymodErrorCodes;
const DefaultMinBillingThreshold = 50;
exports.DefaultMinBillingThreshold = DefaultMinBillingThreshold;
const AccountBillMeNowStatus = Object.freeze({
  None: 0,
  ForceBill: 1,
  Refund: 2
});
exports.AccountBillMeNowStatus = AccountBillMeNowStatus;
const IndiaEMandateOfficialUrl = 'https://www.rbi.org.in/Scripts/BS_PressReleaseDisplay.aspx?prid=51353';
exports.IndiaEMandateOfficialUrl = IndiaEMandateOfficialUrl;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BudgetChangeType = exports.BudgetEventType = exports.BudgetRecommendationItemType = exports.CbtReportTimePeriodTLString = exports.CbtReportTimePeriod = void 0;
const CbtReportTimePeriod = Object.freeze({
  Today: 0,
  Yesterday: 1
});
exports.CbtReportTimePeriod = CbtReportTimePeriod;
const CbtReportTimePeriodTLString = Object.freeze({
  [CbtReportTimePeriod.Today]: _TL_('Today'),
  [CbtReportTimePeriod.Yesterday]: _TL_('Yesterday')
});
exports.CbtReportTimePeriodTLString = CbtReportTimePeriodTLString;
const BudgetRecommendationItemType = Object.freeze({
  Suggested: 0,
  MaxValue: 1,
  Current: 2,
  Other: 3
});
exports.BudgetRecommendationItemType = BudgetRecommendationItemType;
const BudgetEventType = Object.freeze({
  // campaign level
  CampaignOutOfBudget: 50,
  CampaignLimitedByBudget: 1001,
  // prepay account level
  PrepayAccountBalanceLow: 69,
  PrepayAccountBalanceZero: 70,
  // monthly invoice account level
  InsertionOrderBalanceDepleted: 119,
  InsertionOrderExpired: 125,
  InsertionOrderExhaustingUrgent: 354,
  InsertionOrderExpiringUrgent: 355,
  // threshold account level
  AccountHold: 7
});
exports.BudgetEventType = BudgetEventType;
const BudgetChangeType = Object.freeze({
  PrepayBalanceRecharge: 1,
  ThresholdPaymentChange: 2,
  InsertionOrderChange: 3,
  CampaignDailyBudgetChange: 4
});
exports.BudgetChangeType = BudgetChangeType;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeliveryStatus = void 0;
const DeliveryStatus = Object.freeze({
  CampaignBudgetPaused: 50,
  BudgetSuggestions: 1001
});
exports.DeliveryStatus = DeliveryStatus;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityType = void 0;
const EntityType = Object.freeze({
  Customer: 1,
  Account: 2,
  User: 6,
  PaymentInstrument: 10,
  TaxDocument: 160,
  Person: 170
});
exports.EntityType = EntityType;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyCodeCompanyNameMapping = exports.CompanyCode = exports.GroupingPrerequisites = exports.GroupingCriteria = exports.CampaignDetailsForUnconsolidatedInvoiceValueToLabel = exports.IncludeCampaignDetailsValueToLabel = void 0;

var _tax = __webpack_require__(100);

const IncludeCampaignDetailsValueToLabel = {
  [_tax.AttestationValue.True]: _TL_('Show amount due for each campaign'),
  [_tax.AttestationValue.False]: _TL_('Don’t show amount due for each campaign')
};
exports.IncludeCampaignDetailsValueToLabel = IncludeCampaignDetailsValueToLabel;
const CampaignDetailsForUnconsolidatedInvoiceValueToLabel = {
  [_tax.AttestationValue.True]: _TL_('Show amount due for each campaign on unconsolidated invoice'),
  [_tax.AttestationValue.False]: _TL_('Don’t show amount due for each campaign on unconsolidated invoice')
};
exports.CampaignDetailsForUnconsolidatedInvoiceValueToLabel = CampaignDetailsForUnconsolidatedInvoiceValueToLabel;
const GroupingCriteria = {
  BilltoSAPId: 'BilltoSAPId',
  BusinessAddress: 'BusinessAddress',
  CompanyCode: 'CompanyCode',
  CurrencyType: 'CurrencyType',
  TaxInformation: 'TaxInformation',
  BillingGroupId: 'BillingGroupId'
};
exports.GroupingCriteria = GroupingCriteria;
const GroupingPrerequisites = {
  PaymentOption: 'PaymentOption'
};
exports.GroupingPrerequisites = GroupingPrerequisites;
const CompanyCode = Object.freeze({
  MIOL: 1062,
  // Ireland
  MOI: 1548,
  // US
  India: 1098,
  Brazil: 1639,
  Taiwan: 1058
});
exports.CompanyCode = CompanyCode;
const CompanyCodeCompanyNameMapping = Object.freeze({
  [CompanyCode.MIOL]: 'Microsoft Ireland Operations Limited',
  [CompanyCode.MOI]: 'Microsoft Online, Inc.',
  [CompanyCode.India]: 'Microsoft Corporation (India) Private Limited',
  [CompanyCode.Brazil]: 'Microsoft do Brasil Importação e Comércio de Software e Games LTDA',
  [CompanyCode.Taiwan]: '台灣微軟股份有限公司'
});
exports.CompanyCodeCompanyNameMapping = CompanyCodeCompanyNameMapping;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttestationValues = exports.TaxCertLabel = exports.TaxLabelFormat = exports.TaxExemptionCertVerifiedResult = exports.TaxCertificateDeclineReasonType = exports.TaxIdMaxLength = exports.VatStatusEnum = exports.TaxTypeEnumValue = exports.ReverseChargeDocumentAttestationValueToLabel = exports.ChileWHTConfirmValueToLabel = exports.ChileIVAorVATConfirmValueToLabel = exports.AttestationValue = exports.TaxOptionType = exports.TaxInfo = exports.TaxType = void 0;
const TaxType = Object.freeze({
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  GSTINNumber: 'GSTINNumber',
  PANNumber: 'PANNumber',
  VatNumber: 'VatNumber',
  NZGSTNumber: 'NZGSTNumber',
  AUGSTNumber: 'AUGSTNumber',
  CCM: 'CCM',
  GSTNumber: 'GSTNumber',
  LegalIdentifier: 'LegalIdentifier'
});
exports.TaxType = TaxType;
const TaxInfo = Object.freeze({
  IsTaxExemptionCertVerified: 'IsTaxExemptionCertVerified',
  SkipVatIdValidation: 'SkipVatIdValidation',
  IsIVAOrVATTaxPayer: 'IsIVAOrVATTaxPayer',
  IsWithholdingTaxExempted: 'IsWithholdingTaxExempted',
  ReverseChargeDocumentAttestation: 'ReverseChargeDocumentAttestation'
});
exports.TaxInfo = TaxInfo;
const TaxOptionType = Object.freeze({
  Personal: 'TaxType_Personal',
  Business: 'TaxType_Business'
});
exports.TaxOptionType = TaxOptionType;
const AttestationValue = Object.freeze({
  True: 'True',
  False: 'False',
  NotSet: ''
});
exports.AttestationValue = AttestationValue;
const ChileIVAorVATConfirmValueToLabel = Object.freeze({
  [AttestationValue.True]: 'Account_ChileIVAorVATConfirmPositive',
  [AttestationValue.False]: 'Account_ChileIVAorVATConfirmNegative'
});
exports.ChileIVAorVATConfirmValueToLabel = ChileIVAorVATConfirmValueToLabel;
const ChileWHTConfirmValueToLabel = Object.freeze({
  [AttestationValue.True]: 'Account_ChileWHTConfirmPositive',
  [AttestationValue.False]: 'Account_ChileWHTConfirmNegative'
});
exports.ChileWHTConfirmValueToLabel = ChileWHTConfirmValueToLabel;
const ReverseChargeDocumentAttestationValueToLabel = Object.freeze({
  [AttestationValue.True]: 'Account_ReverseChargeDocumentAttestation_Positive',
  [AttestationValue.False]: 'Account_ReverseChargeDocumentAttestation_Negative'
}); // Microsoft.AdCenter.ClientCenter.MT.Service.TaxType

exports.ReverseChargeDocumentAttestationValueToLabel = ReverseChargeDocumentAttestationValueToLabel;
const TaxTypeEnumValue = Object.freeze({
  [TaxType.CPF]: 1,
  [TaxType.CNPJ]: 2,
  [TaxType.GSTINNumber]: 3,
  [TaxType.PANNumber]: 4,
  [TaxType.VatNumber]: 5,
  [TaxType.NZGSTNumber]: 6,
  [TaxType.AUGSTNumber]: 8,
  [TaxType.CCM]: 9,
  [TaxType.GSTNumber]: 10
});
exports.TaxTypeEnumValue = TaxTypeEnumValue;
const VatStatusEnum = Object.freeze({
  Valid: 174,
  Invalid: 175,
  Pending: 176,
  PastDue: 177
});
exports.VatStatusEnum = VatStatusEnum;
const TaxIdMaxLength = Object.freeze({
  [TaxType.CPF]: 11,
  [TaxType.CNPJ]: 14,
  [TaxType.CCM]: 8,
  [TaxType.LegalIdentifier]: 50
});
exports.TaxIdMaxLength = TaxIdMaxLength;
const TaxCertificateDeclineReasonType = Object.freeze({
  SubmittedDocumentInvalid: 1,
  CodigoSectionInvalid: 2,
  NITMissingOrIncomplete: 3,
  NITMismatch: 4
});
exports.TaxCertificateDeclineReasonType = TaxCertificateDeclineReasonType;
const TaxExemptionCertVerifiedResult = {
  Accept: 'True',
  Reject: 'False',
  NotSet: null
};
exports.TaxExemptionCertVerifiedResult = TaxExemptionCertVerifiedResult;
const TaxLabelFormat = {
  Optional: 'Optional',
  Required: 'Required',
  RequiredForAllTheEntities: 'RequiredForAllTheEntities',
  RequiredForBusiness: 'RequiredForBusiness',
  RequiredForVATRegisteredBusiness: 'RequiredForVATRegisteredBusiness',
  RequiredForValueAddedTaxIVARegistered: 'RequiredForValueAddedTaxIVARegistered',
  RequiredForIVAorVATTaxPayer: 'RequiredForIVAorVATTaxPayer',
  Default: 'Default'
};
exports.TaxLabelFormat = TaxLabelFormat;
const TaxCertLabel = {
  TaxCertificateOrEquivalentProof: 'Account_TaxCertificate_Or_EquivalentProof',
  TaxCertificate: 'Account_TaxCertificate'
};
exports.TaxCertLabel = TaxCertLabel;
const AttestationValues = [AttestationValue.True, AttestationValue.False];
exports.AttestationValues = AttestationValues;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsupportedBusinessLocations = exports.CustomerUnsupportedBusinessLocations = exports.YahooMarkets = exports.NonEMEAVatCountries = exports.CallingCodeBeforePhoneNumberRegExp = exports.CallingCode = exports.CountryCode = void 0;
const CountryCode = Object.freeze({
  US: 'US',
  UA: 'UA',
  AM: 'AM',
  AN: 'AN',
  AZ: 'AZ',
  BR: 'BR',
  CN: 'CN',
  IN: 'IN',
  IQ: 'IQ',
  KZ: 'KZ',
  KG: 'KG',
  MM: 'MM',
  MV: 'MV',
  FR: 'FR',
  HK: 'HK',
  TW: 'TW',
  HU: 'HU',
  PT: 'PT',
  PL: 'PL',
  CO: 'CO',
  CL: 'CL',
  AE: 'AE',
  IL: 'IL',
  VN: 'VN',
  VE: 'VE',
  NO: 'NO',
  TR: 'TR',
  FK: 'FK',
  VC: 'VC',
  GE: 'GE',
  TH: 'TH',
  TJ: 'TJ',
  BD: 'BD',
  BT: 'BT',
  ID: 'ID',
  BY: 'BY',
  NG: 'NG',
  IS: 'IS',
  SS: 'SS',
  MD: 'MD',
  ZW: 'ZW',
  ZA: 'ZA',
  BH: 'BH',
  KH: 'KH',
  KE: 'KE',
  SA: 'SA',
  OM: 'OM',
  GH: 'GH',
  CM: 'CM',
  UZ: 'UZ',
  FJ: 'FJ',
  GT: 'GT',
  BS: 'BS',
  PH: 'PH',
  PK: 'PK',
  RU: 'RU',
  LK: 'LK',
  MX: 'MX',
  NP: 'NP',
  LA: 'LA',
  BB: 'BB',
  NZ: 'NZ',
  RS: 'RS',
  SG: 'SG',
  KR: 'KR',
  AR: 'AR',
  BJ: 'BJ',
  CI: 'CI',
  JP: 'JP',
  MY: 'MY',
  SR: 'SR',
  ZM: 'ZM'
});
exports.CountryCode = CountryCode;
const CallingCode = Object.freeze({
  US: '1'
});
exports.CallingCode = CallingCode;
const CallingCodeBeforePhoneNumberRegExp = '^([0-9]+)-(.*)$'; // This should be in sync with excluded countries in AdsAppUI/private/UI/Common/Microsoft.ClientCenter.Repository/Dictionaries/CountryMapping.cs GetVatApplicableCountriesMapping

exports.CallingCodeBeforePhoneNumberRegExp = CallingCodeBeforePhoneNumberRegExp;
const NonEMEAVatCountries = [CountryCode.NZ, CountryCode.RS, CountryCode.SG];
exports.NonEMEAVatCountries = NonEMEAVatCountries;
const YahooMarkets = [CountryCode.HK, CountryCode.TW];
exports.YahooMarkets = YahooMarkets;
const CustomerUnsupportedBusinessLocations = [CountryCode.AN, CountryCode.FK, CountryCode.VC];
exports.CustomerUnsupportedBusinessLocations = CustomerUnsupportedBusinessLocations;
const UnsupportedBusinessLocations = [CountryCode.RU, CountryCode.BY];
exports.UnsupportedBusinessLocations = UnsupportedBusinessLocations;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CouponPurposeId = exports.FeatureAdoptionCouponFeatureId = exports.RecommendationAdoptionStatus = exports.CouponStatus = exports.CouponType = void 0;
const CouponType = Object.freeze({
  Unspecified: 0,
  Acquisition: 1,
  Retention: 2,
  Performance: 3
});
/**
 * Coupon Status
 * AssociatedCoupon - For UI usage only, this performance coupon is associated to the account, but not redeemed
 * PendingUpfrontSpending - For UI usage only, this performance coupon is in upfront spending status, and currently there is an active coupon, so this pbc should be in "Pending UpfrontSpending"
 * UpfrontSpending - For performance coupon only, this coupon is in upfront spending status, will be active afer meet upfront spending threshold
 * ActiveCoupon - This coupon is active, and for each account there should be only 1 active coupon at a time.
 * Completed - This coupon is completed
 * Expired - This coupon is expired
 * Pending - This coupon is in pending (paused) status. Pending can be switched to Active and vice versa
 */

exports.CouponType = CouponType;
const CouponStatus = Object.freeze({
  AssociatedCoupon: 247,
  PendingUpfrontSpending: 248,
  UpfrontSpending: 249,
  ActiveCoupon: 250,
  Completed: 251,
  Expired: 252,
  Pending: 253
});
/**
 * Feature Adoption Coupon Status
 * NotInProgess - Adoption of this feature has not started, but the account is qualified
 * Active - Adoption of this feature has started, but has not been completed
 * Adopted - Adoption has been completed from UI, but the coupon hasn't been redeemed yet
 * PickedUp - Intermediary step of the redemption process. Coupon should be redeemed momentarily
 * Redeemed - The coupon has been redeemed
 * DismissedBeforeStart - The user dismissed the coupon before they started the adoption process
 * DismissedAfterStart - The user dismissed the coupon after they started the adoption process
 * AdoptedAfterExpiration - The adoption has been completed from UI, but expiration date expired before it was done
 * FailedToRedeem - This status will be set if there are issues during the redemption flow on the CCMT side
 * Depleted - There are no longer enough coupons to give out
 * FailedAdoption - Feature Crew has deemed the adoption invalid
 */

exports.CouponStatus = CouponStatus;
const RecommendationAdoptionStatus = Object.freeze({
  NotInProgess: 0,
  Active: 1,
  Adopted: 2,
  PickedUp: 3,
  Redeemed: 4,
  DismissedBeforeStart: 5,
  DismissedAfterStart: 6,
  AdoptedAfterExpiration: 7,
  FailedToRedeem: 8,
  Depleted: 9,
  FailedAdoption: 10
});
/**
 * Feature Adoption Coupon Feature Id
 * Google Import - 206
 * FacebookImport - 207
 * ConversionTracking - 208
 * CalloutCard - 209
 */

exports.RecommendationAdoptionStatus = RecommendationAdoptionStatus;
const FeatureAdoptionCouponFeatureId = Object.freeze({
  GoogleImport: 206,
  FacebookImport: 207,
  ConversionTracking: 208,
  CalloutCard: 209,
  AutoBidMaxClicks: 212,
  AutoBidMaxConversions: 213,
  ShoppingCampaign: 214
});
exports.FeatureAdoptionCouponFeatureId = FeatureAdoptionCouponFeatureId;
const CouponPurposeId = Object.freeze({
  Signup: 0,
  Ongoing: 1,
  // Deprecated
  Multipurpose: 2,
  FeatureAdoption: 3,
  BingOnlyCampaign: 4,
  SyndicationFiltering: 5,
  MultiChannels: 6,
  MSANSignUp: 7,
  StoreAds: 8
});
exports.CouponPurposeId = CouponPurposeId;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VByVRequiredCurrencyCodes = exports.CurrencyCode = void 0;
const CurrencyCode = Object.freeze({
  USD: 'USD',
  INR: 'INR',
  BRL: 'BRL',
  EUR: 'EUR'
});
exports.CurrencyCode = CurrencyCode;
const VByVRequiredCurrencyCodes = Object.freeze([CurrencyCode.INR]);
exports.VByVRequiredCurrencyCodes = VByVRequiredCurrencyCodes;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerFinancialStatus = exports.ManagedByType = exports.AppScope = exports.IsOptedIn = exports.CustomerProfilePropertyType = void 0;
const CustomerProfilePropertyType = Object.freeze({
  LastLoginTime: 1,
  IpAddress: 2,
  AuthType: 3,
  ImpersonationEnabled: 4,
  IsOptedInForConsolidatedBilling: 5,
  IsOptedInForCampaignDetailsInInvoices: 6,
  IsCustomerOptedInForPostalMail: 7,
  IsCustomerOptedInPaperlessBilling: 8,
  IsEligibleForConsolidatedBilling: 9,
  NumberOfBillToInvoiceAccountsUnderCustomer: 10,
  NumberOfBillToPrepayAccountsUnderCustomer: 11,
  NumberOfBillToThresholdAccountsUnderCustomer: 12
});
exports.CustomerProfilePropertyType = CustomerProfilePropertyType;
const IsOptedIn = Object.freeze({
  on: '1',
  off: '0'
});
exports.IsOptedIn = IsOptedIn;
const AppScope = Object.freeze({
  None: 0,
  Adv: 1,
  Pub: 2,
  Aca: 4,
  MultiChannelAds: 8,
  All: 7
});
exports.AppScope = AppScope;
const ManagedByType = Object.freeze({
  Microsoft: 0,
  Yahoo: 1,
  ChinaJV: 2
});
exports.ManagedByType = ManagedByType;
const CustomerFinancialStatus = Object.freeze({
  ProposalsOnly: 14,
  PendingCreditCheck: 15,
  NoHold: 16,
  SoldToOnly: 17,
  CreditHold: 18,
  CreditWarning: 19
});
exports.CustomerFinancialStatus = CustomerFinancialStatus;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IOEntryPointLogMessage = exports.IOEntryPointAlias = exports.IOFilter = exports.RIOThruDateOptions = exports.IOFormInputSchema = exports.ImmediateDate = exports.EndlessDate = exports.UnlimitedBudget = exports.WarningSpendCapAmountIncreaseFactor = exports.InsertionOrdersGridFieldNames = exports.IOCreationSource = exports.IOMinValues = exports.IOMaxValues = exports.InsertionOrderLabel = exports.InsertionOrderStatus = void 0;

/**
 * Mapping to BillingMT proxy InsertionOrderStatus
 */
const InsertionOrderStatus = Object.freeze({
  PendingSystemReview: 0,
  PendingUserReview: 1,
  Active: 2,
  Declined: 3,
  Expired: 4,
  Canceled: 5,
  Pending: 6,
  Exhausted: 7,
  PendingBillToPartyChange: 8,
  PendingBillToPartyChangeAndUserReview: 9,
  Queued: 11
});
/**
 * Mapping to BillingMT proxy InsertionOrderLabel
 */

exports.InsertionOrderStatus = InsertionOrderStatus;
const InsertionOrderLabel = Object.freeze({
  None: 0,
  Expiring: 1,
  Exhausting: 2,
  Expired: 4,
  NoBudget: 8
});
/**
 * Max and min value about InsertionOrder fields
 * For io creation, max comment length is 100; While editing, comment length can be up to 500
 */

exports.InsertionOrderLabel = InsertionOrderLabel;
const IOMaxValues = Object.freeze({
  budgetValue: 1000000000,
  agencyIdOrPoLength: 50,
  nameLength: 100,
  commentLength: 100,
  editCommentLength: 500
});
exports.IOMaxValues = IOMaxValues;
const IOMinValues = Object.freeze({
  budgetValue: 0.01
});
exports.IOMinValues = IOMinValues;
const IOCreationSource = Object.freeze({
  UIInsertionOrder: 1,
  UIBatchInsertionOrder: 2,
  BulkIOImport: 3,
  RecurringInsertionOrder: 4,
  BillingTakeOver: 5,
  AgencyLinking: 6,
  Reparenting: 7,
  PaymentOptionSwitch: 8,
  CCAPIAddInsertionOrder: 9,
  IORecommendation: 10
});
exports.IOCreationSource = IOCreationSource;
const InsertionOrdersGridFieldNames = Object.freeze({
  AccountId: 'AccountId',
  AccountName: 'AccountName',
  AccountNumber: 'AccountNumber',
  Action: 'Action',
  AgencyIdOrPo: 'AgencyIdOrPo',
  BalanceAmount: 'BalanceAmount',
  BillToCustomerName: 'BillToCustomerName',
  BillToCustomerNumber: 'BillToCustomerNumber',
  BudgetPerOrder: 'BudgetPerOrder',
  Comment: 'Comment',
  CompanyName: 'CompanyName',
  CurrencyType: 'CurrencyType',
  DaysToEndDate: 'DaysToEndDate',
  DealPointId: 'DealPointId',
  EndDate: 'EndDate',
  EndDateText: 'EndDateText',
  EndOccurrences: 'EndOccurrences',
  EstDaysToExhaustion: 'EstDaysToExhaustion',
  Frequency: 'Frequency',
  FriendlyName: 'FriendlyName',
  FromDate: 'FromDate',
  InsertionOrderId: 'InsertionOrderId',
  InsertionOrderName: 'InsertionOrderName',
  InsertionOrderLabel: 'InsertionOrderLabel',
  IOCreationSource: 'IOCreationSource',
  IsAgencyIdOrPoEditable: 'IsAgencyIdOrPoEditable',
  IsCommentEditable: 'IsCommentEditable',
  IsDealPointIdEditable: 'IsDealPointIdEditable',
  IsEndDateEditable: 'IsEndDateEditable',
  IsInSeries: 'IsInSeries',
  IsInsertionOrderNameEditable: 'IsInsertionOrderNameEditable',
  IsRecordCenterIdEditable: 'IsRecordCenterIdEditable',
  IsSpendCapAmountEditable: 'IsSpendCapAmountEditable',
  IsStartDateEditable: 'IsStartDateEditable',
  LastModifiedDate: 'LastModifiedDate',
  ModifiedByUser: 'ModifiedByUser',
  Notes: 'Notes',
  OrderName: 'OrderName',
  OrderType: 'OrderType',
  PurchaseOrder: 'PurchaseOrder',
  RecommendationId: 'RecommendationId',
  RecommendationType: 'RecommendationType',
  RecordCenterId: 'RecordCenterId',
  RecurringIOId: 'RecurringIOId',
  RemainingIOBudgetPercent: 'RemainingIOBudgetPercent',
  SeriesEndDate: 'SeriesEndDate',
  SeriesEndDateString: 'SeriesEndDateString',
  SeriesEndOption: 'SeriesEndOption',
  SeriesFrequencyType: 'SeriesFrequencyType',
  SeriesName: 'SeriesName',
  SeriesStartDate: 'SeriesStartDate',
  SeriesStartDateString: 'SeriesStartDateString',
  SpendCapAmount: 'SpendCapAmount',
  SpentIOBudget: 'SpentIOBudget',
  SpentIOBudgetPercent: 'SpentIOBudgetPercent',
  StartDate: 'StartDate',
  StartDateText: 'StartDateText',
  Status: 'Status',
  StatusValue: 'StatusValue',
  ThruDate: 'ThruDate'
});
exports.InsertionOrdersGridFieldNames = InsertionOrdersGridFieldNames;
const MaxLengths = {
  FriendlyName: 100,
  RecordCenterId: 100,
  AgencyIdOrPo: 50,
  Comment: 500,
  Name: 60
};
const UpperBound = {
  SpendCapAmount: 1000000000,
  DealPointId: 2147483647,
  // int.Max
  Occurrences: 60,
  ExtendDays: 30
};
const LowerBound = {
  BackupSpendCapAmount: 0,
  ExtendDays: 0
};
const SpendCapAmountLowerBound = 0.01;
const WarningSpendCapAmountIncreaseFactor = 10;
exports.WarningSpendCapAmountIncreaseFactor = WarningSpendCapAmountIncreaseFactor;
const UnlimitedBudget = 1000000000000;
exports.UnlimitedBudget = UnlimitedBudget;
const EndlessDate = new Date(9999, 0, 1);
exports.EndlessDate = EndlessDate;
const ImmediateDate = new Date(1970, 0, 1);
exports.ImmediateDate = ImmediateDate;
const IOFormInputSchema = {
  properties: {
    SpendCapAmount: {
      type: 'number',
      required: true,
      minimum: SpendCapAmountLowerBound,
      maximum: UpperBound.SpendCapAmount
    },
    ExtendDays: {
      type: 'integer',
      required: true,
      minimum: LowerBound.ExtendDays,
      maximum: UpperBound.ExtendDays
    },
    BackupSpendCapAmount: {
      type: 'number',
      required: true,
      minimum: LowerBound.BackupSpendCapAmount,
      maximum: UpperBound.SpendCapAmount
    },
    AgencyIdOrPo: {
      type: 'string',
      nullable: true,
      maxLength: MaxLengths.AgencyIdOrPo
    },
    FriendlyName: {
      type: 'string',
      nullable: true,
      maxLength: MaxLengths.FriendlyName
    },
    Comment: {
      type: 'string',
      nullable: true,
      maxLength: MaxLengths.Comment
    },
    DealPointId: {
      type: 'integer',
      minimum: 0,
      nullable: true,
      maximum: UpperBound.DealPointId
    },
    RecordCenterId: {
      type: 'string',
      nullable: true,
      maxLength: MaxLengths.RecordCenterId
    },
    FromDate: {
      type: 'string',
      nullable: true,
      required: true
    },
    ThruDate: {
      type: 'string',
      nullable: true,
      required: true
    },
    Occurrences: {
      type: 'integer',
      minimum: 1,
      nullable: true,
      maximum: UpperBound.Occurrences,
      required: true
    },
    Name: {
      type: 'string',
      nullable: true,
      required: true,
      maxLength: MaxLengths.Name
    }
  }
};
exports.IOFormInputSchema = IOFormInputSchema;
const RIOThruDateOptions = {
  EndByDate: 'EndByDate',
  NoEndDate: 'NoEndDate',
  EndByOccurrences: 'EndByOccurrences'
};
exports.RIOThruDateOptions = RIOThruDateOptions;
const IOFilter = {
  AccountPaused: JSON.stringify([{
    Field: 'Status',
    Operator: '2',
    Values: '7,4'
  }]),
  Expiring: JSON.stringify([{
    Field: 'DaysToEndDate',
    Operator: '9',
    Values: '7'
  }]),
  Exhausting: JSON.stringify([{
    Field: 'EstDaysToExhaustion',
    Operator: '9',
    Values: '7'
  }])
};
exports.IOFilter = IOFilter;
const IOEntryPointAlias = {
  Default: 'default',
  RIONotificationQueue: 'rionq',
  UcmHealthCheck: 'ucmhc',
  ConBNotificationQueue: 'conbnq',
  NotificationEmail: 'noemail',
  IONotificationsEnhancement: 'IOARE',
  BudgetCenter: 'bgtct'
};
exports.IOEntryPointAlias = IOEntryPointAlias;
const IOEntryPointLogMessage = {
  [IOEntryPointAlias.Default]: 'defaultPage',
  [IOEntryPointAlias.RIONotificationQueue]: 'recurringIONotificationQueue',
  [IOEntryPointAlias.UcmHealthCheck]: 'ucmHealthCheck',
  [IOEntryPointAlias.ConBNotificationQueue]: 'consolidatedBudgetNotificationQueue',
  [IOEntryPointAlias.NotificationEmail]: 'notificationEmail',
  [IOEntryPointAlias.IONotificationsEnhancement]: 'IOARE',
  [IOEntryPointAlias.BudgetCenter]: 'budgetCenter'
};
exports.IOEntryPointLogMessage = IOEntryPointLogMessage;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HierarchyAccountType = exports.HierarchyAccountTypeValue = exports.LinkRequestType = exports.LinkPermissionType = exports.LinkType = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LinkType = Object.freeze({
  AdAccount: 1,
  ManagerAccount: 2,
  Reparenting: 3
});
exports.LinkType = LinkType;
const LinkPermissionType = Object.freeze({
  Administrative: 1,
  Standard: 2
});
exports.LinkPermissionType = LinkPermissionType;
const LinkRequestType = Object.freeze({
  Link: 1,
  Unlink: 2,
  BillingTakeover: 3,
  AccountTransfer: 4
});
exports.LinkRequestType = LinkRequestType;
const HierarchyAccountTypeValue = Object.freeze({
  Unknown: 1,
  AdAccount: 2,
  ManagerAccount: 3
});
exports.HierarchyAccountTypeValue = HierarchyAccountTypeValue;
const HierarchyAccountType = Object.freeze(_underscore.default.invert(HierarchyAccountTypeValue));
exports.HierarchyAccountType = HierarchyAccountType;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationType = void 0;
const NotificationType = Object.freeze({
  InsertionOrderBalanceDepletedEvent: 119,
  InsertionOrderExpiredEvent: 125,
  InsertionOrderExpiringUrgentEvent: 355,
  InsertionOrderExhaustingUrgentEvent: 354
});
exports.NotificationType = NotificationType;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RiskControlResponseTypes = exports.RiskControlEventTypes = exports.ESCPrepayUnsupportedPITypes = exports.AllowedAgencyPITypes = exports.SAPApplicationQualificationErrors = exports.SAPApplicationStatus = exports.SAPApplicationType = exports.PaymentTransactionStatus = exports.PaymentInstrLifecycleStatus = exports.PaymentInstrFinancialStatus = exports.CreditCardType = exports.CardCategory = exports.PaymentSettingsMap = exports.OrderedPaymentOptionEnum = exports.OrderedPaymentOptionId = exports.PaymentOptionId = exports.PaymentOption = exports.PaymentTypeId = exports.PaymentType = exports.PaymentInstrumentType = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PaymentInstrumentType = Object.freeze({
  Unset: 0,
  CreditCard: 1,
  Invoice: 2,
  Check: 3,
  ElectronicFundsTransfer: 4,
  PayPal: 5,
  ELV: 6,
  OfflinePaymentMethod: 7,
  VBA: 8,
  Boleto: 9,
  UPI: 10
});
exports.PaymentInstrumentType = PaymentInstrumentType;
const PaymentType = Object.freeze({
  Prepay: 'PrePay',
  Postpay: 'PostPay'
});
exports.PaymentType = PaymentType;
const PaymentTypeId = Object.freeze({
  Postpay: 0,
  Prepay: 1,
  Undefined: 2
});
exports.PaymentTypeId = PaymentTypeId;
const PaymentOption = Object.freeze({
  Threshold: 'Threshold',
  Invoice: 'Monthly Invoice',
  Prepay: 'Prepay'
});
exports.PaymentOption = PaymentOption;
const PaymentOptionId = Object.freeze({
  Threshold: 1,
  Invoice: 2,
  Prepay: 12
});
exports.PaymentOptionId = PaymentOptionId;
const OrderedPaymentOptionId = [PaymentOptionId.Prepay, PaymentOptionId.Threshold, PaymentOptionId.Invoice];
exports.OrderedPaymentOptionId = OrderedPaymentOptionId;

const OrderedPaymentOptionEnum = _underscore.default.chain(PaymentOptionId).keys().sortBy(val => _underscore.default.indexOf(OrderedPaymentOptionId, PaymentOptionId[val])).value();
/**
 * Map of payment settings (i.e. payment type) to payment options that fall under that
 * payment setting.
 * Note that going forward this should be used less frequently since
 * designers want to move toward a consolidate po-dropdown instead of separate inputs
 * for payment setting and payment option.
 */


exports.OrderedPaymentOptionEnum = OrderedPaymentOptionEnum;
const PaymentSettingsMap = {
  [PaymentType.Prepay]: [PaymentOptionId.Prepay],
  [PaymentType.Postpay]: [PaymentOptionId.Threshold, PaymentOptionId.Invoice]
};
exports.PaymentSettingsMap = PaymentSettingsMap;
const CardCategory = Object.freeze({
  Unknown: 0,
  Debit: 1,
  Credit: 2,
  Prepaid: 3
});
exports.CardCategory = CardCategory;
const CreditCardType = Object.freeze({
  VISA: 1,
  MC: 2,
  AMEX: 3,
  DISCOVER: 4,
  DINER: 5,
  JCB: 6,
  CB: 7,
  JAL: 8,
  INV: 9
});
exports.CreditCardType = CreditCardType;
const PaymentInstrFinancialStatus = Object.freeze({
  NoHold: 0,
  CreditHold: 1,
  ManualHold: 2,
  AllHold: 3
});
exports.PaymentInstrFinancialStatus = PaymentInstrFinancialStatus;
const PaymentInstrLifecycleStatus = Object.freeze({
  Active: 50,
  Inactive: 51,
  Deleted: 52,
  PendingValidation: 189
});
exports.PaymentInstrLifecycleStatus = PaymentInstrLifecycleStatus;
const PaymentTransactionStatus = Object.freeze({
  Unknown: 0,
  Processing: 1,
  Declined: 2,
  Success: 3,
  Chargeback: 4,
  RefundReversal: 5,
  ChargebackReversal: 6
});
exports.PaymentTransactionStatus = PaymentTransactionStatus;
const SAPApplicationType = Object.freeze({
  ApplyNewBilltoSAP: 0,
  UpdateSAPDetails: 1,
  AddingExistingSAP: 2,
  ApplyNewSoldtoSAP: 3
});
exports.SAPApplicationType = SAPApplicationType;
const SAPApplicationStatus = Object.freeze({
  UnderReview: 0,
  Approved: 1,
  Rejected: 2,
  ActionRequired: 3
});
exports.SAPApplicationStatus = SAPApplicationStatus;
const SAPApplicationQualificationErrors = Object.freeze({
  NoBillingDocumentAsBillto: 'NoBillingDocumentAsBillto',
  MinSpendBelowThreshold: 'MinSpendBelowThreshold'
});
exports.SAPApplicationQualificationErrors = SAPApplicationQualificationErrors;
const AllowedAgencyPITypes = Object.freeze([PaymentInstrumentType.CreditCard, PaymentInstrumentType.Invoice, PaymentInstrumentType.PayPal]);
exports.AllowedAgencyPITypes = AllowedAgencyPITypes;
const ESCPrepayUnsupportedPITypes = Object.freeze([PaymentInstrumentType.ELV, PaymentInstrumentType.Boleto, PaymentInstrumentType.OfflinePaymentMethod]);
exports.ESCPrepayUnsupportedPITypes = ESCPrepayUnsupportedPITypes;
const RiskControlEventTypes = Object.freeze({
  AddFunds: 0,
  Undefined: 1
});
exports.RiskControlEventTypes = RiskControlEventTypes;
const RiskControlResponseTypes = Object.freeze({
  RiskControlPassed: 0,
  BoletoHighRisk: 1,
  Undefined: 2
});
exports.RiskControlResponseTypes = RiskControlResponseTypes;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityAction = void 0;
const SecurityAction = {
  AccountAdd: 'AccountAdd',
  AccountBillingLoad: 'AccountBillingLoad',
  AccountCashBackFetch: 'AccountCashbackFetch',
  AccountCashBackUpdate: 'AccountCashbackUpdate',
  AccountDelete: 'AccountDelete',
  AccountFetch: 'AccountFetch',
  AccountLoad: 'AccountLoad',
  AccountReactivate: 'AccountReactivate',
  AccountSensitiveCategorySet: 'AccountSensitiveCategorySet',
  AccountSensitiveCategoryView: 'AccountSensitiveCategoryView',
  AccountUpdate: 'AccountUpdate',
  AccountUserResponsibilityLoad: 'AccountUserResponsibilityLoad',
  ActionLoad: 'ActionLoad',
  AgencyAndSalesHouseCommissionPctView: 'AgencyAndSalesHouseCommissionPctView',
  AgencyInviteLoad: 'AgencyInviteLoad',
  AgencyInvite: 'AgencyInvite',
  AgencyLinkJobAdd: 'AgencyLinkJobAdd',
  AgencyLinkJobAccept: 'AgencyLinkJobAccept',
  AgencyLinkJobDelete: 'AgencyLinkJobDelete',
  AgencyLinkJobUpdate: 'AgencyLinkJobUpdate',
  AgencyLinkJobLoad: 'AgencyLinkJobLoad',
  AgencyLinkJobFetch: 'AgencyLinkJobFetch',
  AgencyRelationshipLoad: 'AgencyRelationshipLoad',
  ApiCustomerFetch: 'APICustomerFetch',
  ApiCustomerUpdate: 'APICustomerUpdate',
  ApiTokenStatusUpdate: 'APITokenStatusUpdate',
  ApiUserFetch: 'APIUserFetch',
  ApiUserUpdate: 'APIUserUpdate',
  BalanceLoad: 'BalanceLoad',
  BalanceAdjustmentExecute: 'BalanceAdjustmentExecute',
  BIReportMetadataLoad: 'BIReportMetadataLoad',
  BusinessLocationLoad: 'BusinessLocationLoad',
  CampaignManagementFullControl: 'CampaignManagementFullControl',
  CampaignManagementLoad: 'CampaignManagementLoad',
  CardStatementLoad: 'CardStatementLoad',
  CashBackRebateUpdate: 'CashbackRebateUpdate',
  CashBackMinMaxRebateUpdate: 'CashbackMinMaxRebateUpdate',
  CashBackPropertiesView: 'CashbackPropertiesView',
  ConvertCustomerToAgency: 'ConvertCustomerToAgency',
  ConvertCustomerToAggregator: 'ConvertCustomerToAggregator',
  CsoEmailUpdate: 'CSOEmailUpdate',
  CustomerFetch: 'CustomerFetch',
  CustomerFinancialStatusUpdate: 'CustomerFinancialStatusUpdate',
  CustomerDelete: 'CustomerDelete',
  CustomerIdMappingFetch: 'CustomerIdMappingFetch',
  CustomerIdMappingUpdate: 'CustomerIdMappingUpdate',
  CustomerLoad: 'CustomerLoad',
  CustomerRetier: 'CustomerRetier',
  CustomerSignup: 'CustomerSignup',
  CustomerScrub: 'CustomerScrub',
  CustomerUpdate: 'CustomerUpdate',
  ForceBilling: 'ForceBilling',
  GetCustomerCreditCardMigrationStatus: 'GetCustomerCreditCardMigrationStatus',
  InternalUserLoad: 'InternalUserLoad',
  InterstitialUrlUpdate: 'InterstitalUrlUpdate',
  InsertionOrderAdd: 'InsertionOrderAdd',
  InsertionOrderLoad: 'InsertionOrderLoad',
  InsertionOrderUpdate: 'InsertionOrderUpdate',
  InvoiceAdd: 'InvoiceAdd',
  InvoiceDelete: 'InvoiceDelete',
  IsInternal: 'http://advertising.microsoft.com/ClientCenter/MT/RoleAttributes/IsInternal',
  IsAggregator: 'http://advertising.microsoft.com/ClientCenter/MT/RoleAttributes/IsAggregator',
  LoadBatch: 'LoadBatch',
  MarketUpdate: 'MarketUpdate',
  MySettingsUpdate: 'MySettingsUpdate',
  NewAdjustment: 'NewAdjustment',
  OrderLoad: 'OrderLoad',
  PaymentInstrumentAdd: 'PaymentInstrAdd',
  PaymentInstrumentDelete: 'PaymentInstrDelete',
  PaymentInstrumentFetch: 'PaymentInstrFetch',
  PaymentInstrumentLoad: 'PaymentInstrLoad',
  PaymentInstrumentUpdate: 'PaymentInstrUpdate',
  PasswordReset: 'PasswordReset',
  PilotBatchUpdate: 'PilotBatchUpdate',
  PilotFlagUpdate: 'PilotFlagUpdate',
  PssAdvertiserLoad: 'PSSAdvertiserLoad',
  Rebill: 'Rebill',
  RoleActionLoad: 'RoleActionLoad',
  SetCustomerConsentForCreditCardMigration: 'SetCustomerConsentForCreditCardMigration',
  StatementLoad: 'StatementLoad',
  SupportBillingTemplateAdd: 'PSSAdvertiserLoad',
  SupportBillingDocumentRenderExecute: 'PSSAdvertiserLoad',
  SupportBillingDocumentReRenderExecute: 'PSSAdvertiserLoad',
  SystemLimitUpdate: 'SystemLimitUpdate',
  TaxExemptionCertStatusGet: 'TaxExemptionCertStatusGet',
  TaxExemptionCertStatusSet: 'TaxExemptionCertStatusSet',
  TaxInfoUpdate: 'TaxInfoUpdate',
  UpdateBatch: 'UpdateBatch',
  UserAccountSecurityFetch: 'UserAccountSecurityFetch',
  UserAdd: 'UserAdd',
  UserCustomerSecurityFetch: 'UserCustomerSecurityFetch',
  UserDelete: 'UserDelete',
  UserFetch: 'UserFetch',
  UserForceDelete: 'ForceDeleteUser',
  UserLoad: 'UserLoad',
  UserRoleFetch: 'UserRoleFetch',
  UserSuspend: 'UserSuspend',
  UserUpdate: 'UserUpdate',
  ViewAgentWorkspace: 'ViewAgentWorkspace'
};
exports.SecurityAction = SecurityAction;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendationType = void 0;
const RecommendationType = Object.freeze({
  InsertionOrderCreation: 228,
  InsertionOrderUpdate: 229,
  AutoRecharge: 258,
  RecurringInsertionOrderAdd: 358
});
exports.RecommendationType = RecommendationType;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxZMVatNumberRegExp = exports.TaxVEVatNumberRegExp = exports.TaxUAVatNumberRegExp = exports.TaxTJVatNumberRegExp = exports.TaxSRVatNumberRegExp = exports.TaxMMVatNumberRegExp = exports.TaxMYVatNumberRegExp = exports.TaxJPVatNumberRegExp = exports.TaxCIVatNumberRegExp = exports.TaxCNVatNumberRegExp = exports.TaxBJVatNumberRegExp = exports.TaxAZVatNumberRegExp = exports.TaxARVatNumberRegExp = exports.UnifiedSocialCreditIdentifierRegExp = exports.TaxChileVATRegExp = exports.FCARegistrationNumberRegExp = exports.TaxNPVatNumberRegExp = exports.TaxLAVatNumberRegExp = exports.TaxZAVatNumberRegExp = exports.TaxMXVatNumberRegExp = exports.TaxKZVatNumberRegExp = exports.TaxBBVatNumberRegExp = exports.TaxAMVatNumberRegExp = exports.TaxCAGSTNumberRegExp = exports.TaxAUGSTNumberRegExp = exports.TaxNGVATRegExp = exports.TaxTHVATRegExp = exports.TaxPHVatNumberRegExp = exports.TaxBSVatNumberRegExp = exports.TaxGTVatNumberRegExp = exports.TaxFJVatNumberRegExp = exports.TaxUZVatNumberRegExp = exports.TaxCMVatNumberRegExp = exports.TaxGHVatNumberRegExp = exports.TaxOMVatNumberRegExp = exports.TaxKEVatNumberRegExp = exports.TaxKHVatNumberRegExp = exports.TaxBHVatNumberRegExp = exports.TaxSAVatNumberRegExp = exports.TaxZWVatNumberRegExp = exports.TaxMDVatNumberRegExp = exports.TaxISVatNumberRegExp = exports.TaxNGVatNumberRegExp = exports.TaxBYVatNumberRegExp = exports.TaxIDVatNumberRegExp = exports.TaxBDVatNumberRegExp = exports.TaxTHVatNumberRegExp = exports.TaxGEVatNumberRegExp = exports.TaxTRVatNumberRegExp = exports.TaxNOVatNumberRegExp = exports.TaxVNVatNumberRegExp = exports.TaxILVatNumberRegExp = exports.TaxAEVatNumberRegExp = exports.TaxCOCertificateExecutionDateRegExp = exports.TaxCOVatNumberRegExp = exports.TaxINGSTINRegExp = exports.TaxRSLegalNumberRegExp = exports.TaxRSPIBNumberRegExp = exports.TaxINPANNumberRegExp = exports.TaxSGGSTNumberRegExp = exports.RegGeneralInputBoxRegExp = exports.WebsiteRegExp = exports.DefaultPostalCodeRegExp = exports.PhoneNumberWithoutPrefixRegExp = exports.PhoneNumberRegExp = exports.UKGovEmailRegExp = exports.EmailRegExp = void 0;
const EmailRegExp = '^$|^[a-zA-Z0-9_\\.\\-\\+\']+\\@(?:[\\w\\-]+\\.)+[a-zA-Z0-9]+$';
exports.EmailRegExp = EmailRegExp;
const UKGovEmailRegExp = '^$|[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-.]+\\.)?(?:gov\\.uk|fca\\.org\\.uk)$';
exports.UKGovEmailRegExp = UKGovEmailRegExp;
const PhoneNumberRegExp = '^\\+?[\\d\\-\\s\\(\\)extX\\.]*$';
exports.PhoneNumberRegExp = PhoneNumberRegExp;
const PhoneNumberWithoutPrefixRegExp = '^[\\d\\-\\s\\(\\)extX\\.]*$';
exports.PhoneNumberWithoutPrefixRegExp = PhoneNumberWithoutPrefixRegExp;
const DefaultPostalCodeRegExp = '[0-9]{5}(\\-[0-9]{4})?';
exports.DefaultPostalCodeRegExp = DefaultPostalCodeRegExp;
const WebsiteRegExp = '^$|(?:https?:\\/\\/)?(?:[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\\.)+(?:[a-zA-Z0-9]+)+(?:\\/[A-Za-z0-9-\\._~:/?#[\\]@!$&\'()*+,;=%]*)*';
exports.WebsiteRegExp = WebsiteRegExp;
const RegGeneralInputBoxRegExp = '[^\x00-\x1F]*';
exports.RegGeneralInputBoxRegExp = RegGeneralInputBoxRegExp;
const TaxSGGSTNumberRegExp = '^\\w{2}-?\\d{7}-?\\w$|^\\d{8,9}\\w$|^[TS]\\d{2}[A-Z]\\w\\d{4}\\w$';
exports.TaxSGGSTNumberRegExp = TaxSGGSTNumberRegExp;
const TaxINPANNumberRegExp = '^[A-Za-z0-9]{10}$';
exports.TaxINPANNumberRegExp = TaxINPANNumberRegExp;
const TaxRSPIBNumberRegExp = '^[0-9]{9}$|^[0-9]{13}$';
exports.TaxRSPIBNumberRegExp = TaxRSPIBNumberRegExp;
const TaxRSLegalNumberRegExp = '^[0-9]{8}$';
exports.TaxRSLegalNumberRegExp = TaxRSLegalNumberRegExp;
const TaxINGSTINRegExp = '^$|^([0-9]{2}[0-9A-Z]{13})$';
exports.TaxINGSTINRegExp = TaxINGSTINRegExp;
const TaxCOVatNumberRegExp = '^\\d{9}\\-\\d{1}$';
exports.TaxCOVatNumberRegExp = TaxCOVatNumberRegExp;
const TaxCOCertificateExecutionDateRegExp = '^\\d{4}/\\d{2}/\\d{2}$';
exports.TaxCOCertificateExecutionDateRegExp = TaxCOCertificateExecutionDateRegExp;
const TaxAEVatNumberRegExp = '^\\d{15}$';
exports.TaxAEVatNumberRegExp = TaxAEVatNumberRegExp;
const TaxILVatNumberRegExp = '^\\d{9}$';
exports.TaxILVatNumberRegExp = TaxILVatNumberRegExp;
const TaxVNVatNumberRegExp = '^\\d{10}(-\\d{3})?$';
exports.TaxVNVatNumberRegExp = TaxVNVatNumberRegExp;
const TaxNOVatNumberRegExp = '^(NO)?\\s?\\d{3}\\s?\\d{3}\\s?\\d{3}\\s?MVA$';
exports.TaxNOVatNumberRegExp = TaxNOVatNumberRegExp;
const TaxTRVatNumberRegExp = '^\\d{10}$|^\\d{11}$';
exports.TaxTRVatNumberRegExp = TaxTRVatNumberRegExp;
const TaxGEVatNumberRegExp = '^\\d{9}$';
exports.TaxGEVatNumberRegExp = TaxGEVatNumberRegExp;
const TaxTHVatNumberRegExp = '^\\d{13}$|^\\d{1}-\\d{4}-\\d{5}-\\d{2}-\\d{1}$';
exports.TaxTHVatNumberRegExp = TaxTHVatNumberRegExp;
const TaxBDVatNumberRegExp = '^\\d{9}-\\d{4}$';
exports.TaxBDVatNumberRegExp = TaxBDVatNumberRegExp;
const TaxIDVatNumberRegExp = '^\\d{2}\\.\\d{3}\\.\\d{3}\\.\\d{1}-\\d{3}\\.\\d{3}$|^\\d{15}$';
exports.TaxIDVatNumberRegExp = TaxIDVatNumberRegExp;
const TaxBYVatNumberRegExp = '^\\d{9}$';
exports.TaxBYVatNumberRegExp = TaxBYVatNumberRegExp;
const TaxNGVatNumberRegExp = '^\\d{8}\\-0001$';
exports.TaxNGVatNumberRegExp = TaxNGVatNumberRegExp;
const TaxISVatNumberRegExp = '^\\d{5}$|^\\d{6}$';
exports.TaxISVatNumberRegExp = TaxISVatNumberRegExp;
const TaxMDVatNumberRegExp = '^\\d{7}$';
exports.TaxMDVatNumberRegExp = TaxMDVatNumberRegExp;
const TaxZWVatNumberRegExp = '^\\d{8}$';
exports.TaxZWVatNumberRegExp = TaxZWVatNumberRegExp;
const TaxSAVatNumberRegExp = '^\\d{15}$';
exports.TaxSAVatNumberRegExp = TaxSAVatNumberRegExp;
const TaxBHVatNumberRegExp = '^2\\d{14}$';
exports.TaxBHVatNumberRegExp = TaxBHVatNumberRegExp;
const TaxKHVatNumberRegExp = '^L001-\\d{9}$|^B0\\d{2}-\\d{9}$|^K0\\d{2}-\\d{9}$|^E0\\d{2}-\\d{10}$';
exports.TaxKHVatNumberRegExp = TaxKHVatNumberRegExp;
const TaxKEVatNumberRegExp = '^P\\d{9}[A-Za-z]$';
exports.TaxKEVatNumberRegExp = TaxKEVatNumberRegExp;
const TaxOMVatNumberRegExp = '^OM\\d{10}$';
exports.TaxOMVatNumberRegExp = TaxOMVatNumberRegExp;
const TaxGHVatNumberRegExp = '^[CP]\\d{10}$';
exports.TaxGHVatNumberRegExp = TaxGHVatNumberRegExp;
const TaxCMVatNumberRegExp = '^[A-Za-z]{1}\\d{12}[A-Za-z]{1}$';
exports.TaxCMVatNumberRegExp = TaxCMVatNumberRegExp;
const TaxUZVatNumberRegExp = '^\\d{12}$';
exports.TaxUZVatNumberRegExp = TaxUZVatNumberRegExp;
const TaxFJVatNumberRegExp = '^\\d{2}-\\d{5}-\\d{1}-\\d{1}$|^\\d{10}$';
exports.TaxFJVatNumberRegExp = TaxFJVatNumberRegExp;
const TaxGTVatNumberRegExp = '^\\d{7}-[0-9]$';
exports.TaxGTVatNumberRegExp = TaxGTVatNumberRegExp;
const TaxBSVatNumberRegExp = '^\\d{9}$';
exports.TaxBSVatNumberRegExp = TaxBSVatNumberRegExp;
const TaxPHVatNumberRegExp = '^\\d{3}(-\\d{3}){2,3}$';
exports.TaxPHVatNumberRegExp = TaxPHVatNumberRegExp;
const TaxTHVATRegExp = '^$|^\\d{13}$';
exports.TaxTHVATRegExp = TaxTHVATRegExp;
const TaxNGVATRegExp = '^$|^\\d{8}-0001$';
exports.TaxNGVATRegExp = TaxNGVATRegExp;
const TaxAUGSTNumberRegExp = '^$|\\d{11}$';
exports.TaxAUGSTNumberRegExp = TaxAUGSTNumberRegExp;
const TaxCAGSTNumberRegExp = '^$|^\\d{9}(\\s?RT\\d{4})?$';
exports.TaxCAGSTNumberRegExp = TaxCAGSTNumberRegExp;
const TaxAMVatNumberRegExp = '^\\d{8}\\/[0,1]$';
exports.TaxAMVatNumberRegExp = TaxAMVatNumberRegExp;
const TaxBBVatNumberRegExp = '^\\d{13}$';
exports.TaxBBVatNumberRegExp = TaxBBVatNumberRegExp;
const TaxKZVatNumberRegExp = '^\\d{12}$';
exports.TaxKZVatNumberRegExp = TaxKZVatNumberRegExp;
const TaxMXVatNumberRegExp = '^[A-Za-z]{4}\\d{6}[A-Za-z0-9]{3}$|^\\S{3}\\d{6}\\S{3}$';
exports.TaxMXVatNumberRegExp = TaxMXVatNumberRegExp;
const TaxZAVatNumberRegExp = '^\\d{10}$';
exports.TaxZAVatNumberRegExp = TaxZAVatNumberRegExp;
const TaxLAVatNumberRegExp = '^\\d{12}$';
exports.TaxLAVatNumberRegExp = TaxLAVatNumberRegExp;
const TaxNPVatNumberRegExp = '^\\d{9}$';
exports.TaxNPVatNumberRegExp = TaxNPVatNumberRegExp;
const FCARegistrationNumberRegExp = '^$|^[0-9]{6,7}$';
exports.FCARegistrationNumberRegExp = FCARegistrationNumberRegExp;
const TaxChileVATRegExp = '^$|^\\d{8}-(\\d{1}|K)$';
exports.TaxChileVATRegExp = TaxChileVATRegExp;
const UnifiedSocialCreditIdentifierRegExp = '^$|^[0-9A-Z]{18}$';
exports.UnifiedSocialCreditIdentifierRegExp = UnifiedSocialCreditIdentifierRegExp;
const TaxARVatNumberRegExp = '^30-\\d{8}-\\d{1}$';
exports.TaxARVatNumberRegExp = TaxARVatNumberRegExp;
const TaxAZVatNumberRegExp = '^AZ\\d{10}$';
exports.TaxAZVatNumberRegExp = TaxAZVatNumberRegExp;
const TaxBJVatNumberRegExp = '^\\d{13}$';
exports.TaxBJVatNumberRegExp = TaxBJVatNumberRegExp;
const TaxCNVatNumberRegExp = '^\\d{15}($|\\d{2}[A-Z]{1}$)';
exports.TaxCNVatNumberRegExp = TaxCNVatNumberRegExp;
const TaxCIVatNumberRegExp = '^\\d{7}[A-Za-z]{1}$';
exports.TaxCIVatNumberRegExp = TaxCIVatNumberRegExp;
const TaxJPVatNumberRegExp = '^\\d{13}$';
exports.TaxJPVatNumberRegExp = TaxJPVatNumberRegExp;
const TaxMYVatNumberRegExp = '^[\\dA-Za-z]{1}\\d{2}-\\d{2}(0[1-9]|1[012])-\\d{8}$';
exports.TaxMYVatNumberRegExp = TaxMYVatNumberRegExp;
const TaxMMVatNumberRegExp = '^\\d{9}$';
exports.TaxMMVatNumberRegExp = TaxMMVatNumberRegExp;
const TaxSRVatNumberRegExp = '^\\d{10}$';
exports.TaxSRVatNumberRegExp = TaxSRVatNumberRegExp;
const TaxTJVatNumberRegExp = '^\\d{9}$';
exports.TaxTJVatNumberRegExp = TaxTJVatNumberRegExp;
const TaxUAVatNumberRegExp = '^[\\dA-Za-z]{12}$';
exports.TaxUAVatNumberRegExp = TaxUAVatNumberRegExp;
const TaxVEVatNumberRegExp = '^[JGVE]-\\d{8}-?\\d{1}$';
exports.TaxVEVatNumberRegExp = TaxVEVatNumberRegExp;
const TaxZMVatNumberRegExp = '^100\\d{7}$';
exports.TaxZMVatNumberRegExp = TaxZMVatNumberRegExp;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnableTriggerFCAReason = exports.CanTriggerFCAScenario = exports.FCAVerificationAccountStatusLegacyString = exports.FCAVerificationAccountStatusString = exports.FCAVerificationTypeLegacyString = exports.FCAVerificationTypeString = exports.FCAAccountDomainStatus = exports.FCAAccountStatus = exports.FCAVerificationType = void 0;
const FCAVerificationType = {
  FS: 1,
  Gov: 2,
  NonFS: 3
};
exports.FCAVerificationType = FCAVerificationType;
const FCAAccountStatus = {
  Pending: 1,
  Verified: 2,
  VerifiedLimited: 3,
  Failed: 4,
  NotStarted: 5,
  NoNeed: 6
};
exports.FCAAccountStatus = FCAAccountStatus;
const FCAAccountDomainStatus = {
  Create: 1,
  NQPPending: 2,
  Verified: 3,
  Failed: 4,
  Deleted: 5
};
exports.FCAAccountDomainStatus = FCAAccountDomainStatus;
const FCAVerificationTypeString = {
  [FCAVerificationType.FS]: 'UK FCA authorized financial services advertiser',
  [FCAVerificationType.Gov]: 'Government entity',
  [FCAVerificationType.NonFS]: 'Non-financial services advertiser'
};
exports.FCAVerificationTypeString = FCAVerificationTypeString;
const FCAVerificationTypeLegacyString = {
  [FCAVerificationType.FS]: _TL_('UKFCA_internal_VerificationType_FS'),
  [FCAVerificationType.Gov]: _TL_('UKFCA_internal_VerificationType_GOV'),
  [FCAVerificationType.NonFS]: _TL_('UKFCA_internal_VerificationType_NONFS')
};
exports.FCAVerificationTypeLegacyString = FCAVerificationTypeLegacyString;
const FCAVerificationAccountStatusString = {
  [FCAAccountStatus.Pending]: 'Pending',
  [FCAAccountStatus.Verified]: 'Verified',
  [FCAAccountStatus.VerifiedLimited]: 'Partially verified',
  [FCAAccountStatus.Failed]: 'Failed',
  [FCAAccountStatus.NotStarted]: 'Not started',
  [FCAAccountStatus.NoNeed]: 'Not in pilot'
};
exports.FCAVerificationAccountStatusString = FCAVerificationAccountStatusString;
const FCAVerificationAccountStatusLegacyString = {
  [FCAAccountStatus.Pending]: _TL_('UKFCA_internal_AccountStatus_Pending'),
  [FCAAccountStatus.Verified]: _TL_('UKFCA_internal_AccountStatus_Verified'),
  [FCAAccountStatus.VerifiedLimited]: _TL_('UKFCA_internal_AccountStatus_VerifiedLimited'),
  [FCAAccountStatus.Failed]: _TL_('UKFCA_internal_AccountStatus_Failed'),
  [FCAAccountStatus.NotStarted]: _TL_('UKFCA_internal_AccountStatus_NotStarted'),
  [FCAAccountStatus.NoNeed]: _TL_('UKFCA_internal_AccountStatus_NoNeed')
};
exports.FCAVerificationAccountStatusLegacyString = FCAVerificationAccountStatusLegacyString;
const CanTriggerFCAScenario = {
  Create: 'CanTriggerFCACreate',
  Update: 'CanTriggerFCAUpdate'
};
exports.CanTriggerFCAScenario = CanTriggerFCAScenario;
const UnableTriggerFCAReason = {
  UserRoleMismatch: 1,
  NotAccountOwner: 2,
  FCAStatusMismatch: 3,
  Unauthorized: 4,
  NotInPilot: 5
};
exports.UnableTriggerFCAReason = UnableTriggerFCAReason;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeScreeningStatus = void 0;
const TradeScreeningStatus = Object.freeze({
  InValid: 0,
  HitInReview: 1,
  TrueMatch: 2,
  NoHit: 3,
  SSIF: 4,
  SSID: 5,
  SSIE: 6,
  LicR: 7,
  SSIF14: 8,
  SSID30: 9,
  SSIE60: 10,
  LicA: 11,
  DataIssue: 12,
  IngestionError: 13,
  Error: 14,
  NotScreened: 15,
  DataIssueOrg: 16,
  DataIssueName: 17,
  DataIssueAddress: 18,
  DataIssueLegalId: 19
});
exports.TradeScreeningStatus = TradeScreeningStatus;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerFraudStatus = exports.EnforcementActionType = void 0;
const EnforcementActionType = Object.freeze({
  Default: 0,
  SuspendAccountCreation: 1,
  ReadOnly: 2
});
exports.EnforcementActionType = EnforcementActionType;
const CustomerFraudStatus = Object.freeze({
  NonFraud: 6,
  FraudPending: 7,
  Fraud: 8
});
exports.CustomerFraudStatus = CustomerFraudStatus;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendABL = exports.isBusinessNameMatchFullName = exports.isValidABL = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _address = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const {
  isValid: isValidAddress,
  isValidBusinessName: _isValidBusinessName
} = _address.AddressUtils;
/**
 * @param {object} accountBusinessAddress The account business address object.
 * @returns {boolean} Returns true if given account business address object is valid.
 */

const _isValidABL = accountBusinessAddress => _isValidBusinessName(accountBusinessAddress) && isValidAddress(accountBusinessAddress);
/**
 * Verify if the business name passed in matches with the individual information of the user.
 * A match is considered valid independently of the order of firstname and lastname passed in, spaces and upper/lower case entered
 * @param {object} businessNameData The UI version of the businessName data, containing the business name (property starting with lowerCase)
 * @param {object} individualInfoData An object representing information of an individual user like firstName and lastName
 * @returns {boolean} Returns true if the businessName matches the fullName.
 */


exports.isValidABL = _isValidABL;

const isBusinessNameMatchFullName = (businessNameData, individualInfoData) => {
  const {
    businessName
  } = businessNameData || {};
  const {
    firstName,
    lastName
  } = individualInfoData || {};

  const trimValue = value => {
    if (!_underscore.default.isString(value) || _underscore.default.isEmpty(value)) {
      return null;
    }

    return value.replace(/\s/g, '').toLowerCase();
  };

  const businessNameTrimmed = trimValue(businessName);
  const firstNameTrimmed = trimValue(firstName);
  const lastNameTrimmed = trimValue(lastName);
  return _underscore.default.isEqual(businessNameTrimmed, "".concat(firstNameTrimmed).concat(lastNameTrimmed)) || _underscore.default.isEqual(businessNameTrimmed, "".concat(lastNameTrimmed).concat(firstNameTrimmed));
};
/**
 * Returns a copy of the given account business address object with additional utility methods.
 * @param {object} accountBusinessAddress The account business address object to be extended with additional utility methods.
 * @returns {object} Return a copy of the extended account business address object.
 */


exports.isBusinessNameMatchFullName = isBusinessNameMatchFullName;

const extendABL = function extendABL() {
  let accountBusinessAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.defaults({}, accountBusinessAddress, {
    isValidABL: () => _isValidABL(accountBusinessAddress),
    isValidBusinessName: () => _isValidBusinessName(accountBusinessAddress)
  });
};

exports.extendABL = extendABL;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__116__;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullName = exports.isUnableToRetriggerBusinessVerification = exports.isInitializeInProgress = exports.findUnableTriggerAivReason = exports.isUnableTriggerAivReasonExists = exports.isAivHold = exports.findABLVerificationStatus = exports.isABLVerificationStatusExists = exports.isInPilot = exports.isAccountVerificationRequestSubmitted = exports.isAccountVerificationStatusExists = exports.isAccountABLVerificationStatusMismatch = exports.getABLVerificationStatusForUI = exports.getABLVerificationStatusMappingForUI = exports.getAccountVerificationStatusForUI = exports.getAccountVerificationStatusMappingForUI = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _constants = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const getAccountVerificationStatusMappingForUI = _ref => {
  let {
    i18n,
    isInternal = false
  } = _ref;
  return _underscore.default.chain(_constants.AccountVerificationStatus).invert().mapObject((statusName, statusValue) => _objectSpread(_objectSpread({}, _constants.AccountVerificationStatusIconMapping[statusName]), {}, {
    label: isInternal ? i18n.getString("AccountVerificationStatus_".concat(statusValue, "_Internal")) : i18n.getString("AccountVerificationStatus_".concat(statusValue))
  })).value();
};

exports.getAccountVerificationStatusMappingForUI = getAccountVerificationStatusMappingForUI;

const getAccountVerificationStatusForUI = _ref2 => {
  let {
    i18n,
    accountVerificationStatus,
    isInternal = false
  } = _ref2;
  return getAccountVerificationStatusMappingForUI({
    i18n,
    isInternal
  })[accountVerificationStatus] || {
    label: i18n.getString('Global_NotApplicableText')
  };
};

exports.getAccountVerificationStatusForUI = getAccountVerificationStatusForUI;

const getABLVerificationStatusMappingForUI = _ref3 => {
  let {
    i18n
  } = _ref3;
  return _underscore.default.chain(_constants.ABLVerificationStatus).invert().mapObject((statusName, statusValue) => ({
    label: i18n.getString("ABLVerificationStatus_".concat(statusValue))
  })).value();
};

exports.getABLVerificationStatusMappingForUI = getABLVerificationStatusMappingForUI;

const getABLVerificationStatusForUI = _ref4 => {
  let {
    i18n,
    ablVerificationStatus
  } = _ref4;
  return getABLVerificationStatusMappingForUI({
    i18n
  })[ablVerificationStatus] || {
    label: i18n.getString('Global_NotApplicableText')
  };
};

exports.getABLVerificationStatusForUI = getABLVerificationStatusForUI;

const isAccountABLVerificationStatusMismatch = _ref5 => {
  let {
    accountVerificationStatus,
    ablVerificationStatus
  } = _ref5;
  const ablVerificationStatusMatchList = _constants.AccountToAblVerificationStatusRelation[accountVerificationStatus];
  return _underscore.default.values(_constants.ABLVerificationStatus).includes(ablVerificationStatus) && _underscore.default.isArray(ablVerificationStatusMatchList) && !ablVerificationStatusMatchList.includes(ablVerificationStatus);
};

exports.isAccountABLVerificationStatusMismatch = isAccountABLVerificationStatusMismatch;

const isAccountVerificationStatusExists = accountVerificationStatus => _underscore.default.contains(_underscore.default.values(_constants.AccountVerificationStatus), accountVerificationStatus);

exports.isAccountVerificationStatusExists = isAccountVerificationStatusExists;

const isAccountVerificationRequestSubmitted = accountVerificationStatus => isAccountVerificationStatusExists(accountVerificationStatus) && !_underscore.default.contains([_constants.AccountVerificationStatus.NoNeedVerified, _constants.AccountVerificationStatus.NeedVerified], accountVerificationStatus);

exports.isAccountVerificationRequestSubmitted = isAccountVerificationRequestSubmitted;

const isInPilot = _ref6 => {
  let {
    AccountVerificationStatus
  } = _ref6;
  return isAccountVerificationStatusExists(AccountVerificationStatus) && AccountVerificationStatus !== _constants.AccountVerificationStatus.NoNeedVerified;
};

exports.isInPilot = isInPilot;

const isABLVerificationStatusExists = ablVerificationStatus => _underscore.default.contains(_underscore.default.values(_constants.ABLVerificationStatus), ablVerificationStatus);

exports.isABLVerificationStatusExists = isABLVerificationStatusExists;

const findABLVerificationStatus = _ref7 => {
  let {
    addressList,
    businessName,
    countryCode
  } = _ref7;
  const {
    ABLVerificationStatus: ablVerificationStatus
  } = _underscore.default.findWhere(addressList, {
    BusinessName: businessName,
    Country: countryCode
  }) || {};
  return isABLVerificationStatusExists(ablVerificationStatus) ? ablVerificationStatus : _constants.ABLVerificationStatus.NotVerified;
};

exports.findABLVerificationStatus = findABLVerificationStatus;

const isAivHold = function isAivHold() {
  let {
    AccountInactiveReasonsV1
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !_underscore.default.isEmpty(AccountInactiveReasonsV1) && _underscore.default.contains(AccountInactiveReasonsV1.map(item => item.Causes[0]), _constants.AccountInactiveCauseCode.AccountVerificationHold);
};

exports.isAivHold = isAivHold;

const isUnableTriggerAivReasonExists = unableTriggerAivReason => _underscore.default.contains(_underscore.default.values(_constants.UnableTriggerAivReason), unableTriggerAivReason);

exports.isUnableTriggerAivReasonExists = isUnableTriggerAivReasonExists;

const findUnableTriggerAivReason = unableTriggerAivReasons => _underscore.default.find(_constants.OrderedUnableTriggerAivReasons, orderedReason => isUnableTriggerAivReasonExists(orderedReason) && _underscore.default.contains(unableTriggerAivReasons, orderedReason));

exports.findUnableTriggerAivReason = findUnableTriggerAivReason;

const isInitializeInProgress = unableTriggerAivReasons => _underscore.default.contains(unableTriggerAivReasons, _constants.UnableTriggerAivReason.InitializeInProgress);
/**
 * Check if the user is unable to trigger email verification. It should align with MT logic.
 * 1. User is internal; 2. User is not super admin; 3. User's parent customer id is not cid in url.
 * @param {object} userContext get from userContext(UserContext)
 * @param {cid} cid Customer id in Url
 * @returns {bool} if the user is unable to retrigger email verification
 */


exports.isInitializeInProgress = isInitializeInProgress;

const isUnableToRetriggerBusinessVerification = _ref8 => {
  let {
    userContext,
    cid
  } = _ref8;

  const currentUser = _underscore.default.get(userContext, 'CurrentUser');

  return !currentUser || currentUser.IsInternal || currentUser.ParentCustomerId !== cid || !currentUser.IsSuperAdmin;
};

exports.isUnableToRetriggerBusinessVerification = isUnableToRetriggerBusinessVerification;

const getFullName = individualDetailInfo => {
  const {
    firstName = '',
    lastName = ''
  } = individualDetailInfo || {};
  const separator = _underscore.default.isEmpty(firstName) || _underscore.default.isEmpty(lastName) ? '' : ' ';
  return "".concat(firstName).concat(separator).concat(lastName);
};

exports.getFullName = getFullName;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendAccount = exports.isTSTMissingMasterData = exports.isTSTDataIssueLegalId = exports.isTSTDataIssueAddress = exports.isTSTDataIssueName = exports.isTSTTrueMatch = exports.isTSTLicR = exports.isTSTInReview = exports.getAblInfoFormat = exports.isManagedByYahoo = exports.isIndiaEmandateFailedPIAccount = exports.isAccountAPContactMandatory = exports.hasManager = exports.managers = exports.hasOneOfPaymentOptions = exports.hasPaymentOption = exports.isWriteOff = exports.isUnifiedSmartAccount = exports.isSmartAccount = exports.isManualHold = exports.activityStatus = exports.isCreated = exports.isDeleted = exports.deletedReasonCodeMatcher = exports.deletedReasonValueMatcher = exports.isBillToAgencyCustomer = exports.isBillToCustomer = exports.getHierarchyAccount = exports.getDisplayName = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _commonUtils = __webpack_require__(37);

var _account = __webpack_require__(92);

var _customer = __webpack_require__(104);

var _payment = __webpack_require__(108);

var _country = __webpack_require__(101);

var _linking = __webpack_require__(106);

var _tradeScreeningTransformation = __webpack_require__(113);

var _countryUtils = __webpack_require__(119);

var _common = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the display string of an account in the format AccountName (AccountNumber)
 * @param {object} account the account object
 * @param {*} i18n the i18n object
 * @returns {string} the display string of an account
 */
const getDisplayName = (account, i18n) => {
  if (!_underscore.default.isObject(account)) {
    return '';
  }

  const name = account.Name || '';
  return account.Number ? i18n.getString('Account_DisplayName', {
    name,
    number: account.Number
  }) : name;
};
/**
 * Returns the hierarchy format of an account
 * @param {object} account the account object
 * @returns {string} the hierarchy format of an account
 */


exports.getDisplayName = getDisplayName;

const getHierarchyAccount = function getHierarchyAccount() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    id: account.id,
    name: account.Name,
    number: account.Number,
    type: _linking.HierarchyAccountTypeValue.AdAccount,
    managers: _underscore.default.map(account.Managers, function () {
      let manager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        name: manager.Name,
        number: manager.Number,
        id: manager.Id
      };
    })
  };
};
/**
 * Returns true if the target customer is bill-to of the account in parameter, false otherwise.
 * @param {object} account the account object.
 * @param {number} targetCustomerId the target customer id to decide if the account in param is bill-to of this cid.
 * @returns {boolean} true if the target customer is bill-to of the account in parameter, false otherwise
 */


exports.getHierarchyAccount = getHierarchyAccount;

const _isBillToCustomer = (account, targetCustomerId) => parseInt(targetCustomerId, 10) >= 0 && _underscore.default.isObject(account) && account.BillToCustomerId === targetCustomerId;
/**
 * Returns true if the target account is bill to agency customer, false otherwise.
 * @param {object} account the account object.
 * @returns {boolean} true if the target account is bill to agency customer, false otherwise.
 */


exports.isBillToCustomer = _isBillToCustomer;

const _isBillToAgencyCustomer = account => _underscore.default.isObject(account) && _underscore.default.isNumber(account.BillToCustomerId) && _underscore.default.isNumber(account.ParentCustomerId) && account.ParentCustomerId !== account.BillToCustomerId;
/**
 * Returns a predicate function that will tell you if a passed in object contains the Reason value "Deleted"
 * @returns {func} a predicate function that will tell you if a passed in object contains the Reason value "Deleted"
 */


exports.isBillToAgencyCustomer = _isBillToAgencyCustomer;

const deletedReasonValueMatcher = _underscore.default.matcher({
  Reason: _account.AccountInactiveReasonValue.Deleted
});
/**
 * Returns a predicate function that will tell you if a passed in object contains the Reason Code of Deleted
 * @returns {func} a predicate function that will tell you if a passed in object contains the Reason Code of Deleted
 */


exports.deletedReasonValueMatcher = deletedReasonValueMatcher;

const deletedReasonCodeMatcher = _underscore.default.matcher({
  Reason: _account.AccountInactiveReasonCode.Deleted
});
/**
 * Returns whether the account is deleted.
 * @param {object} account The account object.
 * @returns {bool} Return whether the account is deleted
 */


exports.deletedReasonCodeMatcher = deletedReasonCodeMatcher;

const _isDeleted = function isDeleted() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return account.LifecycleStatus === _account.AccountLifecycleStatus.Inactive || account.UILifecycleStatusLocId === _account.AccountFinancialStatus.Inactive || _underscore.default.some(account.AccountInactiveReasonsV1, deletedReasonCodeMatcher) || _underscore.default.some(account.AccountInactiveReasons, deletedReasonValueMatcher);
}; // In Campaign account object use the string values instead of the integer codes

/**
 * Returns whether the account is created.
 * @param {object} account The account object.
 * @returns {bool} Return whether the account is created
 */


exports.isDeleted = _isDeleted;

const _isCreated = function isCreated() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return account && account.LifecycleStatus !== _account.AccountLifecycleStatus.Draft;
};
/**
 * Returns an AccountActivityStatus indicating if the account is enabled or not.
 * In case the account is not enabled, it returns a specific status (like AccountActivityStatus.Deleted)
 * In case the account doesn't have a specific AccountActivityStatus, but still
 * contains unhandled AccountInactiveReasons, AccountActivityStatus.Errors is returned
 * @param {object} account The account object.
 * @returns {string} Return an AccountActivityStatus value indicating if the account is enabled, deleted, or has any others errors preventing it to be fully enabled
 */


exports.isCreated = _isCreated;

const _activityStatus = function activityStatus() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (_isDeleted(account)) {
    return _account.AccountActivityStatus.Deleted;
  }

  const handledAccountInactiveReasons = [_account.AccountInactiveReasonCode.NotSet, _account.AccountInactiveReasonCode.Deleted, _account.AccountInactiveReasonValue.NotSet, _account.AccountInactiveReasonValue.Deleted];

  const remainingAccountInactiveReasons = _underscore.default.reject(_underscore.default.union(account.AccountInactiveReasonsV1, account.AccountInactiveReasons), item => _underscore.default.contains(handledAccountInactiveReasons, item.Reason));

  return _underscore.default.isEmpty(remainingAccountInactiveReasons) ? _account.AccountActivityStatus.Enabled : _account.AccountActivityStatus.Errors;
};
/**
 * Returns true if the account is manual hold, false otherwise.
 * @param {object} account The account object.
 * @returns {boolean} true if the account is manual hold, false otherwise.
 */


exports.activityStatus = _activityStatus;

const _isManualHold = function isManualHold() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _commonUtils.NumberUtils.hasFlag(account.LastFinStatusUpdatedSourceBitMap, _account.AccountFinancialStatusBit.ManualHold);
};
/**
 * Returns true if the account is smart account, false otherwise.
 * @param {object} account The account object.
 * @returns {boolean} true if the account is smart account, false otherwise.
 */


exports.isManualHold = _isManualHold;

const isSmartAccount = account => account.AccountMode === _account.AccountMode.Smart;
/**
 * Returns true if the account is unified smart account, false otherwise.
 * @param {object} account The account object.
 * @returns {boolean} true if the account is unified smart account, false otherwise.
 */


exports.isSmartAccount = isSmartAccount;

const isUnifiedSmartAccount = account => account.AccountMode === _account.AccountMode.UnifiedSmart;
/**
 * Returns true if the account financial status is write off, false otherwise.
 * @param {object} account the account object.
 * @returns {boolean} true if the account financial status is write off, false otherwise.
 */


exports.isUnifiedSmartAccount = isUnifiedSmartAccount;

const _isWriteOff = account => account.FinancialStatus === _account.AccountFinancialStatus.WriteOff;
/**
 * Returns true if the given account object has known payment option set.
 * @param {object} account The account object.
 * @returns {bool} true if the given account object has known payment option set.
 */


exports.isWriteOff = _isWriteOff;

const _hasPaymentOption = account => _underscore.default.isObject(account) && _underscore.default.contains(_underscore.default.values(_payment.PaymentOption), account.PaymentOption);
/**
 * Returns true if the given account object has one of the payment options passed in paramaters
 * @param {object} account The account object
 * @param {int[]} paymentOptions The list of payment options to verify.
 * @returns {bool} true if the given account object has one of the payment option set passed in paramaters
 */


exports.hasPaymentOption = _hasPaymentOption;

const _hasOneOfPaymentOptions = (account, paymentOptions) => _hasPaymentOption(account) && _underscore.default.contains(paymentOptions, account.PaymentOption);
/**
 * @typedef {object} AccountManager
 * @property {number} Id Account manager id
 * @property {string} Name Account manager name
 * @property {string} Number Account manager number
 */

/**
 * Returns the given account's managers
 * @param {object} account The account object
 * @returns {Array.<AccountManager>} Account managers
 */


exports.hasOneOfPaymentOptions = _hasOneOfPaymentOptions;

const _managers = function managers() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.chain(account.AccountCustomerRelations).filter(_ref => {
    let {
      isManagingCustomer,
      LifecycleStatus
    } = _ref;
    return isManagingCustomer && LifecycleStatus === _account.AccountCustomerRelationLifecycleStatus.Active;
  }).map(_ref2 => {
    let {
      RelatedToCustomerId,
      RelatedToCustomerName,
      RelatedToCustomerNumber
    } = _ref2;
    return {
      Id: RelatedToCustomerId,
      Name: RelatedToCustomerName,
      Number: RelatedToCustomerNumber ? RelatedToCustomerNumber.trim() : null
    };
  }).value();
};
/**
 * Returns true if the given account has manager
 * @param {object} account The account object
 * @returns {bool} true if the given account has manager
 */


exports.managers = _managers;

const _hasManager = function hasManager() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _managers(account).length > 0;
};
/**
 * Returns true if the given account object is mandatory for account level ap contact
 * @param {object} account The account object
 * @returns {bool} true if the given account object is mandatory for account level ap contact
 */


exports.hasManager = _hasManager;

const _isAccountAPContactMandatory = account => {
  if (!_underscore.default.isObject(account) || !_underscore.default.isObject(account.BusinessAddress)) {
    return false;
  }

  const invoiceMandatoryCountries = [_country.CountryCode.US, _country.CountryCode.FR];
  const prepayThresholdMandatoryCountries = [_country.CountryCode.FR];

  const isInvoiceMandatory = _hasOneOfPaymentOptions(account, [_payment.PaymentOption.Invoice]) && _isBillToAgencyCustomer(account) && _underscore.default.contains(invoiceMandatoryCountries, account.BusinessAddress.Country);

  const isPrepayThresholdMandatory = _hasOneOfPaymentOptions(account, [_payment.PaymentOption.Prepay, _payment.PaymentOption.Threshold]) && _underscore.default.contains(prepayThresholdMandatoryCountries, account.BusinessAddress.Country);

  return isInvoiceMandatory || isPrepayThresholdMandatory;
};
/**
 * Returns true if the given account object has india emandate failed PI
 * @param {object} account The account object
 * @param {object} currentPI The PI object
 * @returns {bool} true if the given account object has india emandate failed PI
 */


exports.isAccountAPContactMandatory = _isAccountAPContactMandatory;

const _isIndiaEmandateFailedPIAccount = _ref3 => {
  let {
    account,
    currentPI
  } = _ref3;
  return _underscore.default.isObject(currentPI) && (0, _countryUtils.getAccountCountryCode)(account) === _country.CountryCode.IN && currentPI.SupportsRecurringPayment && new Date(currentPI.CreationDate) >= new Date(2021, 3, 1, 0, 0, 0);
};
/**
 * Returns true if the account's parent customer is managed by Yahoo
 * @function
 * @param {object} account the account object
 * @returns {bool} true if the account's parent customer is managed by Yahoo
 */


exports.isIndiaEmandateFailedPIAccount = _isIndiaEmandateFailedPIAccount;

const _isManagedByYahoo = account => _underscore.default.get(account, 'ManagedBy') === _customer.ManagedByType.Yahoo;
/**
 * transform account object into ablInfo object, made for loading the shared ABL with initial data
 * @param {object} account The account object.
 * @returns {object} ablInfo object that can be consumed directly by the ABL component
 */


exports.isManagedByYahoo = _isManagedByYahoo;

const getAblInfoFormat = _ref4 => {
  let {
    account
  } = _ref4;

  if (!account) {
    return {};
  }

  return {
    countryCode: _underscore.default.get(account.BusinessAddress, 'Country'),
    addressData: {
      address: account.BusinessAddress
    },
    businessNameData: {
      businessName: _underscore.default.get(account.BusinessAddress, 'BusinessName')
    },
    taxData: {
      data: account.TaxInformation,
      taxCertification: account.TaxCertification
    },
    prefillAddressId: _underscore.default.get(account.BusinessAddress, 'Id')
  };
};
/**
 * Check if account is in TST hit-in-review status
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether account is in TST hit-in-review status
 */


exports.getAblInfoFormat = getAblInfoFormat;

const _isTSTInReview = (account, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.HitInReview;
/**
 * Check if account is in TST LicR status
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether account is in TST licR status
 */


exports.isTSTInReview = _isTSTInReview;

const _isTSTLicR = (account, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.LicR;
/**
 * Check if account is in TST true-match status
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether account is in TST true-match status
 */


exports.isTSTLicR = _isTSTLicR;

const _isTSTTrueMatch = (account, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.TrueMatch;
/**
 * Check if account is in TST data issue missing name status
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether account is in TST data issue missing name status
 */


exports.isTSTTrueMatch = _isTSTTrueMatch;

const _isTSTDataIssueName = (account, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && (_underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueName || _underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueOrg);
/**
 * Check if account is in TST data issue missing address status
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether account is in TST data issue missing address status
 */


exports.isTSTDataIssueName = _isTSTDataIssueName;

const _isTSTDataIssueAddress = (account, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueAddress;
/**
 * Check if account is in TST data issue missing legal identifier status
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether account is in TST data issue missing legal identifier status
 */


exports.isTSTDataIssueAddress = _isTSTDataIssueAddress;

const _isTSTDataIssueLegalId = (account, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(account, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueLegalId;
/**
 * Check if account is missing master data
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {boolean} pilots.isTradeScreeningTransformationEnabled The TST UI pilot
 * @param {boolean} pilots.isTSTMasterDataMissingNotificationEnabled The TST DB pilot
 * @returns {boolean} Result of whether account is missing data
 */


exports.isTSTDataIssueLegalId = _isTSTDataIssueLegalId;

const _isTSTMissingMasterData = (account, _ref5) => {
  let {
    isTradeScreeningTransformationEnabled,
    isTSTMasterDataMissingNotificationEnabled
  } = _ref5;
  return isTradeScreeningTransformationEnabled && isTSTMasterDataMissingNotificationEnabled && ((0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(account, ['BusinessAddress', 'Country'])) || (0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(account, ['BusinessAddress', 'City'])) || (0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(account, ['BusinessAddress', 'Line1'])) || (0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(account, ['BusinessAddress', 'BusinessName'])));
};
/**
 * Returns a copy of the given account object with additional utility methods.
 * @param {object} account The account object to be extended with additional utility methods.
 * @param {*} i18n the i18n object
 * @returns {object} A copy of the extended account object.
 */


exports.isTSTMissingMasterData = _isTSTMissingMasterData;

const extendAccount = function extendAccount() {
  let account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let i18n = arguments.length > 1 ? arguments[1] : undefined;
  return _underscore.default.defaults({}, account, {
    activityStatus: () => _activityStatus(account),
    displayName: () => getDisplayName(account, i18n),
    isAccountAPContactMandatory: () => _isAccountAPContactMandatory(account),
    isBillToCustomer: targetCustomerId => _isBillToCustomer(account, targetCustomerId),
    isBillToAgencyCustomer: () => _isBillToAgencyCustomer(account),
    isDeleted: () => _isDeleted(account),
    isCreated: () => _isCreated(account),
    isManualHold: () => _isManualHold(account),
    isWriteOff: () => _isWriteOff(account),
    hasManager: () => _hasManager(account),
    hasOneOfPaymentOptions: paymentOptions => _hasOneOfPaymentOptions(account, paymentOptions),
    hasPaymentOption: () => _hasPaymentOption(account),
    hierarchyAccount: () => getHierarchyAccount(account),
    managers: () => _managers(account),
    toAblInfoFormat: () => getAblInfoFormat({
      account
    }),
    isIndiaEmandateFailedPIAccount: currentPI => _isIndiaEmandateFailedPIAccount({
      account,
      currentPI
    }),
    isManagedByYahoo: () => _isManagedByYahoo(account),
    isTSTDataIssueName: _ref6 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref6;
      return _isTSTDataIssueName(account, isTradeScreeningTransformationEnabled);
    },
    isTSTDataIssueLegalId: _ref7 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref7;
      return _isTSTDataIssueLegalId(account, isTradeScreeningTransformationEnabled);
    },
    isTSTDataIssueAddress: _ref8 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref8;
      return _isTSTDataIssueAddress(account, isTradeScreeningTransformationEnabled);
    },
    isTSTInReview: _ref9 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref9;
      return _isTSTInReview(account, isTradeScreeningTransformationEnabled);
    },
    isTSTLicR: _ref10 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref10;
      return _isTSTLicR(account, isTradeScreeningTransformationEnabled);
    },
    isTSTTrueMatch: _ref11 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref11;
      return _isTSTTrueMatch(account, isTradeScreeningTransformationEnabled);
    },
    isTSTMissingMasterData: _ref12 => {
      let {
        isTradeScreeningTransformationEnabled,
        isTSTMasterDataMissingNotificationEnabled
      } = _ref12;
      return _isTSTMissingMasterData(account, {
        isTradeScreeningTransformationEnabled,
        isTSTMasterDataMissingNotificationEnabled
      });
    }
  });
};

exports.extendAccount = extendAccount;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableCountriesByAccountMode = exports.getAvailableCountriesByCurrency = exports.getAvailableCountriesByCurrencyCountriesMapping = exports.getAvailableCountriesByControlledCurrency = exports.removeYahooMarkets = exports.getAccountCountryCode = exports.combineCallingCodeAndPhoneNumber = exports.getPhoneNumberMatchResult = exports.getCallingCodeDisplayByCallingCode = exports.groupCountriesByCallingCode = exports.sortCountries = exports.findCountry = exports.extendCountry = exports.getCallingCodeDisplayByCountry = exports.getRegion = exports.isPaperlessBillingEnforcement = exports.isPaperlessBillingAllowed = exports.isTaxableCountry = exports.isVatApplicable = exports.isAddressRequired = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _country = __webpack_require__(101);

var _currencyUtils = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const _isAddressRequired = function isAddressRequired() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return country.IsAddressRequired !== false;
};

exports.isAddressRequired = _isAddressRequired;

const _isVatApplicable = function isVatApplicable() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !!country.IsVatApplicable && !_underscore.default.contains(_country.NonEMEAVatCountries, country.Code.toUpperCase());
};

exports.isVatApplicable = _isVatApplicable;

const isTaxableCountry = function isTaxableCountry() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !!country.IsTaxableCountry;
};

exports.isTaxableCountry = isTaxableCountry;

const _isPaperlessBillingAllowed = function isPaperlessBillingAllowed() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !!country.IsPaperlessBillingAllowed;
};

exports.isPaperlessBillingAllowed = _isPaperlessBillingAllowed;

const _isPaperlessBillingEnforcement = function isPaperlessBillingEnforcement() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !!country.PaperlessBillingEnforced;
}; // TODO: add region property for Country from Domain Data MT Response


exports.isPaperlessBillingEnforcement = _isPaperlessBillingEnforcement;

const _getRegion = country => _isVatApplicable(country) ? 'EMEA' : '';
/**
 * Display format for country and calling code
 * @param {object} country Country object
 * @param {string} Name Country localized name
 * @param {string} CountryCallingCode Country calling code
 * @returns {string} The display format for given country and calling code
 */


exports.getRegion = _getRegion;

const getCallingCodeDisplayByCountry = function getCallingCodeDisplayByCountry() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const callingCodeString = _underscore.default.isEmpty(country.CountryCallingCode) ? '' : " (+".concat(country.CountryCallingCode, ")");
  return "".concat(country.Name || '').concat(callingCodeString);
};
/**
 * Returns a copy of the given country object with additional utility methods.
 * @param {object} country The country object to be extended with additional utility methods.
 * @returns {object} A copy of the extended country object.
 */


exports.getCallingCodeDisplayByCountry = getCallingCodeDisplayByCountry;

const extendCountry = function extendCountry() {
  let country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.defaults({}, country, {
    isAddressRequired: () => _isAddressRequired(country),
    isVatApplicable: () => _isVatApplicable(country),
    isPaperlessBillingAllowed: () => _isPaperlessBillingAllowed(country),
    isPaperlessBillingEnforcement: () => _isPaperlessBillingEnforcement(country),
    getRegion: () => _getRegion(country),
    callingCodeDisplay: () => getCallingCodeDisplayByCountry(country)
  });
};
/**
 * Looks through the list 'countries' and returns the first country found by code, with or without extension
 * if no match is found, undefined will be returned.
 * @param {object[]} countries the list of countries
 * @param {string} countryCode the country code
 * @param {bool} [withExtensions] Specifiy if we should add extensions to the country found
 * @returns {object} the first country found from the list 'countries', or undefined otherwise
 */


exports.extendCountry = extendCountry;

const findCountry = function findCountry() {
  let {
    countries,
    countryCode,
    withExtensions = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  const country = _underscore.default.findWhere(countries, {
    Code: countryCode
  });

  return country && withExtensions ? extendCountry(country) : country;
};
/**
 * Sort countries from MT domainData by localized country name
 * @param {object[]} countries List of countries returned by domain data
 * @param {string} countries[].Name Country localized name
 * @param {string} countries[].Code Country code
 * @param {string} countries[].CountryCallingCode Country calling code
 * @param {string} countries[].Currency Country currency
 * @param {number} countries[].Id Country id
 * @param {boolean} countries[].IsAddressRequired It indicates if country's address is required
 * @param {boolean} countries[].IsVatApplicable It indicates if country's VAT is applicable
 * @param {boolean} countries[].IsPaperlessBillingAllowed It indicates if country allow paperless billing
 * @returns {array} The sorted countries
 */


exports.findCountry = findCountry;

const sortCountries = countries => {
  if (!_underscore.default.isArray(countries)) {
    return [];
  }

  return countries.sort((item1, item2) => item1.Name.localeCompare(item2.Name, 'co', {
    sensitivity: 'base'
  }));
};
/**
 * Group countries by calling code because some countries share same calling code,
 * we should show one line in dropdown list. Also calling code for AN is not correct.
 * @param {object[]} countries List of countries returned by domain data
 * @param {string} countries[].Name Country localized name
 * @param {string} countries[].Code Country code
 * @param {string} countries[].CountryCallingCode Country calling code
 * @param {string} countries[].Currency Country currency
 * @param {number} countries[].Id Country id
 * @param {boolean} countries[].IsAddressRequired It indicates if country's address is required
 * @param {boolean} countries[].IsVatApplicable It indicates if country's VAT is applicable
 * @param {boolean} countries[].IsPaperlessBillingAllowed It indicates if country allow paperless billing
 * @returns {array} The countries grouped by calling code
 */


exports.sortCountries = sortCountries;

const groupCountriesByCallingCode = countries => {
  const CountryNameSeperator = ', ';

  const moveUsInFront = countryList => {
    const indexOfUS = _underscore.default.findIndex(countryList, {
      Code: _country.CountryCode.US
    });

    if (indexOfUS > 0) {
      const arrayWithCountryUS = countryList.splice(indexOfUS, 1);
      return arrayWithCountryUS.concat(countryList);
    }

    return countryList;
  };

  return _underscore.default.chain(countries).omit(country => country.Code === _country.CountryCode.AN) // omit calling code 599 since it's not accurate
  .groupBy('CountryCallingCode').map((_countryList, callingCode) => {
    const countryList = moveUsInFront(_countryList);
    return {
      CountryCallingCode: callingCode,
      Name: _underscore.default.pluck(countryList, 'Name').join(CountryNameSeperator)
    };
  }).value();
};
/**
 * Find country by calling code and get display format
 * @param {object[]} countries List of countries returned by domain data
 * @param {string} callingCode Calling code string
 * @param {string} countries[].Name Country localized name
 * @param {string} countries[].CountryCallingCode Country calling code
 * @returns {array} The display format of country and calling code for given calling code
 */


exports.groupCountriesByCallingCode = groupCountriesByCallingCode;

const getCallingCodeDisplayByCallingCode = (countries, callingCode) => {
  const country = _underscore.default.findWhere(countries, {
    CountryCallingCode: callingCode
  });

  return getCallingCodeDisplayByCountry(country);
};
/**
 * Get calling code and phone number from a phone string
 * @param {string} phone Phone string with calling code and phone number
 * @returns {object} Calling code and phone number
 */


exports.getCallingCodeDisplayByCallingCode = getCallingCodeDisplayByCallingCode;

const getPhoneNumberMatchResult = phone => {
  const phoneNumberWithCallingCodeMatchResult = new RegExp(_country.CallingCodeBeforePhoneNumberRegExp).exec(phone);
  return {
    phoneNumber: _underscore.default.result(phoneNumberWithCallingCodeMatchResult, 2, phone),
    callingCode: _underscore.default.result(phoneNumberWithCallingCodeMatchResult, 1)
  };
};
/**
 * Combine calling code and phone number to a phone string, refer to `CallingCodeBeforePhoneNumberRegExp`
 * @param {string} callingCode calling code
 * @param {string} phoneNumber phone number
 * @returns {string} phone string
 */


exports.getPhoneNumberMatchResult = getPhoneNumberMatchResult;

const combineCallingCodeAndPhoneNumber = (callingCode, phoneNumber) => {
  const callingCodeString = _underscore.default.isEmpty(callingCode) ? '' : "".concat(callingCode, "-");
  return "".concat(callingCodeString).concat(phoneNumber);
};
/**
 * Get country code of the indicated account
 * @param {object} account account to get country code
 * @returns {string} country code of the indicated account
 */


exports.combineCallingCodeAndPhoneNumber = combineCallingCodeAndPhoneNumber;

const getAccountCountryCode = account => _underscore.default.chain(account).result('BusinessAddress').result('Country').value();
/**
 * Remove Yahoo markets from country list
 * @function
 * @param {object[]} countries List of countries
 * @param {string} countries[].Code Country code
 * @param {array} options.countryCodeKeepList countryCodeKeepList special country codes that we want to keep, e.g. HK, only remove TW
 * @returns {array} The country list excluding Yahoo markets
 */


exports.getAccountCountryCode = getAccountCountryCode;

const removeYahooMarkets = function removeYahooMarkets(countries) {
  let {
    countryCodeKeepList
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _underscore.default.reject(countries, _ref => {
    let {
      Code
    } = _ref;
    return !_underscore.default.contains(countryCodeKeepList, Code) && _country.YahooMarkets.includes(Code);
  });
};
/**
 * Get available countries by controlled currency
 * @param {object[]} countries List of countries
 * @param {object[]} currencies List of currencies
 * @param {string} currencyType - The currency type
 * @returns {Array} country of the controlled currency, return null if not a controlled currency
 */


exports.removeYahooMarkets = removeYahooMarkets;

const getAvailableCountriesByControlledCurrency = _ref2 => {
  let {
    countries,
    currencies,
    currencyType
  } = _ref2;
  const controlledCurrency = (0, _currencyUtils.getControlledCurrency)({
    currencies,
    currencyType
  });
  return controlledCurrency ? countries.filter(country => country.Id === controlledCurrency.ControlledCurrencyCountryId) : null;
};
/**
 * Get available countries by currency countries mapping
 * @param {object[]} countries List of countries
 * @param {object[]} currencyCountriesMapping List of currency country mapping
 * @param {string} currencyType - The currency type
 * @returns {Array} country of the controlled currency, return null if not a controlled currency
 */


exports.getAvailableCountriesByControlledCurrency = getAvailableCountriesByControlledCurrency;

const getAvailableCountriesByCurrencyCountriesMapping = _ref3 => {
  let {
    countries,
    currencyCountriesMapping,
    currencyType
  } = _ref3;

  const availableCountryListByCurrency = _underscore.default.get(_underscore.default.find(currencyCountriesMapping, record => record.currency === currencyType), 'countries', []);

  return currencyType ? countries.filter(country => _underscore.default.contains(availableCountryListByCurrency, country.Code)) : countries;
};
/**
 * get available countries from currencyCountriesMapping
 * @param {object[]} countries List of countries
 * @param {object[]} currencyCountriesMapping - The currency countries mapping, each currency is mapping to a list of country code, optional
 * @param {object[]} currencies List of currencies, optional
 * @param {string} currencyType - The currency type, optional
 * @param {string} countryCode -  Country code, optional
 * @returns {Array.<string>} The available country code list filtered by currencyType, if no currencyType, return all countries
 */


exports.getAvailableCountriesByCurrencyCountriesMapping = getAvailableCountriesByCurrencyCountriesMapping;

const getAvailableCountriesByCurrency = _ref4 => {
  let {
    countries,
    currencyCountriesMapping = [],
    currencies = [],
    currencyType = '',
    countryCode = ''
  } = _ref4;
  const controlledCurrencyCountry = getAvailableCountriesByControlledCurrency({
    countries,
    currencies,
    currencyType
  });

  if (controlledCurrencyCountry) {
    return controlledCurrencyCountry;
  }

  const filteredCountries = getAvailableCountriesByCurrencyCountriesMapping({
    countries,
    currencyCountriesMapping,
    currencyType
  }); // we want to keep yahoo markets for existing accounts

  return removeYahooMarkets(filteredCountries, {
    countryCodeKeepList: [countryCode]
  });
};
/**
 * Get available countries for the account mode
 * @param {object[]} countries List of countries
 * @param {int} accountMode - The accountMode of the account
 * @param {object} allowedCountriesByAccountModeMapping - the allowed countries by accountMode mapping
 * @param {string} [countryCodePropertyKey] - The key to access the country code of the country object. Defaults to 'Code'
 * @returns {Array.<string>} The available country code list filtered by accountMode, if no accountMode, or no restrictions, return all countries
 */


exports.getAvailableCountriesByCurrency = getAvailableCountriesByCurrency;

const getAvailableCountriesByAccountMode = _ref5 => {
  let {
    countries,
    accountMode,
    allowedCountriesByAccountModeMapping,
    countryCodePropertyKey = 'Code'
  } = _ref5;
  const allowedcountryList = accountMode && _underscore.default.isObject(allowedCountriesByAccountModeMapping) && allowedCountriesByAccountModeMapping[accountMode];

  if (allowedcountryList) {
    return countries.filter(country => _underscore.default.contains(allowedcountryList, country[countryCodePropertyKey]));
  }

  return countries;
};

exports.getAvailableCountriesByAccountMode = getAvailableCountriesByAccountMode;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableCurrenciesByCountryCode = exports.isCurrencyRequiresVerifiedByVisa = exports.getControlledCurrency = exports.sortCurrencies = exports.findCurrency = exports.extendCurrency = exports.getCurrencyCode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _constants = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get currency code property
 * @param {object} currencyValue Value object of currency
 * @param {number} currencyValue.Id Id of currency
 * @param {string} currencyValue.Code Code of currency
 * @returns {object} currency code, and empty string if code is not found
 */
const getCurrencyCode = currencyValue => _underscore.default.result(currencyValue, 'Code', '');
/**
 * Get extendCurrency object
 * @param {object} currencyValue Value object of currency
 * @param {number} currencyValue.Id Id of currency
 * @param {string} currencyValue.Code Code of currency
 * @returns {object} extendCurrency object
 */


exports.getCurrencyCode = getCurrencyCode;

const extendCurrency = function extendCurrency() {
  let currencyValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.defaults({}, currencyValue, {
    code: getCurrencyCode(currencyValue)
  });
};
/**
 * Get currency value object by id
 * @param {number} id Id of currency
 * @param {bool} getExtendedObject It indicates if this function will return extended currency value object
 * @param {object[]} currencies List of currencies
 * @param {number} currencies[].id Id of currency
 * @param {object} currencies[].value Value object of currency
 * @param {number} currencies[].value.Id Id of currency
 * @param {string} currencies[].value.Code Code of currency
 * @returns {object} Currency value object, and null or default extendCurrency object if currency code is not found
 */


exports.extendCurrency = extendCurrency;

const findCurrency = _ref => {
  let {
    currencies,
    id,
    getExtendedObject = false
  } = _ref;

  const currency = _underscore.default.findWhere(currencies, {
    id
  });

  const currencyValue = _underscore.default.result(currency, 'value', {});

  return getExtendedObject ? extendCurrency(currencyValue) : currencyValue;
};
/**
 * Sort currencies from MT domainData by localized currency name
 * @param {object[]} currencies List of currencies returned by domain data
 * @param {number} currencies[].Id Currency id
 * @param {string} currencies[].Code Currency Code
 * @param {number} currencies[].ControlledCurrencyCountryId It indicates if the currency is a controlled currency
 * @param {boolean} currencies[].DisplayName Currency display name
 * @returns {array} The sorted currencies
 */


exports.findCurrency = findCurrency;

const sortCurrencies = currencies => {
  if (!_underscore.default.isArray(currencies)) {
    return [];
  }

  return currencies.sort((item1, item2) => item1.DisplayName.localeCompare(item2.DisplayName, 'co', {
    sensitivity: 'base'
  }));
};
/**
 * Get controlled currency
 * @param {object[]} currencies List of currencies
 * @param {string} currencyType Currency type
 * @returns {object} return the controlled currency
 */


exports.sortCurrencies = sortCurrencies;

const getControlledCurrency = _ref2 => {
  let {
    currencies,
    currencyType
  } = _ref2;
  return _underscore.default.find(currencies, curr => _underscore.default.isNumber(curr.ControlledCurrencyCountryId) && curr.Code === currencyType);
};
/**
 * Get whether the provided currency should be verified by Visa
 * @param {string} currencyCode Code of currency
 * @returns {bool} indicate whether the provided currency should be verified by Visa
 */


exports.getControlledCurrency = getControlledCurrency;

const isCurrencyRequiresVerifiedByVisa = currencyCode => _underscore.default.contains(_constants.VByVRequiredCurrencyCodes, currencyCode);
/**
 * Get available currencies based on countryCourrenciesMapping
 * @param {string} countryCode Code of country
 * @param {string} currencies List of currencies
 * @param {string} countryCurrenciesMapping List of country currencies mapping
 * @returns {array} return sorted currencies based on countryCurrenciesMapping
 */


exports.isCurrencyRequiresVerifiedByVisa = isCurrencyRequiresVerifiedByVisa;

const getAvailableCurrenciesByCountryCode = _ref3 => {
  let {
    countryCode,
    currencies,
    countryCurrenciesMapping
  } = _ref3;

  if (!countryCode || !countryCurrenciesMapping) {
    return currencies;
  }

  const allowedCurrencyCodes = _underscore.default.findWhere(countryCurrenciesMapping, {
    country: countryCode
  });

  const allowedCurrencies = _underscore.default.filter(currencies, currency => _underscore.default.contains(allowedCurrencyCodes ? allowedCurrencyCodes.currencies : [], currency.Code));

  return sortCurrencies(allowedCurrencies);
};

exports.getAvailableCurrenciesByCountryCode = getAvailableCurrenciesByCountryCode;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStringNullOrWhiteSpace = isStringNullOrWhiteSpace;

/**
 * Check if string is null, empty or only contains whitespaces
 * @param {string|null} str string to check
 * @returns {boolean} Result of whether string is null or whitespace
 */
function isStringNullOrWhiteSpace(str) {
  return str == null || typeof str === 'string' && str.replace(/\s/g, '') === '';
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNewAdjustmentReasons = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _adjustmentReason = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sort countries from MT domainData by localized country name
 * @param {object[]} reasons List of countries returned by domain data
 * @param {number} reasons[].id Adjustment reason id
 * @param {object} reasons[].value Adjustment reason value object
 * @param {number} reasons[].value.Id Adjustment reason id
 * @param {string} reasons[].value.Name Adjustment reason name
 * @param {object} i18n i18n
 * @returns {array} The mapped adjustment reason filtered by new adjustment ids
 */
const mapNewAdjustmentReasons = (reasons, i18n) => {
  const unselectedReason = {
    id: _adjustmentReason.AdjustmentReason.None,
    value: i18n.getString('AdjustmentReason_UnselectedItemText')
  };

  const newAdjustmentReasonsFormatted = _underscore.default.chain(reasons).filter(reason => _underscore.default.contains(_underscore.default.values(_adjustmentReason.AdjustmentReason), reason.id)).map(reason => ({
    id: reason.id,
    value: i18n.getString("AdjustmentReason_".concat(reason.id))
  })).value();

  return [unselectedReason, ...newAdjustmentReasonsFormatted];
};

exports.mapNewAdjustmentReasons = mapNewAdjustmentReasons;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBillingDocumentAccountInfo = exports.extendBillingSummary = exports.getCouponBillingSummary = exports.getInvoiceBillingSummary = exports.getThresholdBillingSummary = exports.getPrepayBillingSummary = exports.getDesignatedBillingSummary = exports.getDesignatedBillingSummaryFactory = exports.isCouponBillingSummary = exports.isInvoiceBillingSummary = exports.isThresholdBillingSummary = exports.isPrepayBillingSummary = exports.isDesignatedBillingSummary = exports.getPaymodErrorAlertModel = exports.extendBillingDocument = exports.getBillingDocumentUrl = exports.getPastDueInfo = exports.getDocumentTypeText = exports.isConsolidatedForBillingGroup = exports.isConsolidated = exports.getDocumentDateRangeFormatted = exports.isDocumentTypeMonthlyStatement = exports.isDocumentTypeCreditMemo = exports.isDocumentTypePostPaidStatement = exports.isDocumentTypePrePaidStatement = exports.isDocumentTypePrePaidInvoices = exports.isTypeCurrentActivity = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _commonUtils = __webpack_require__(37);

var _billing = __webpack_require__(95);

var _payment = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns true if documentType is CurrentActivity
 * @param {string} documentType the documentType string
 * @returns {string} true if documentType is CurrentActivity, false otherwise
 */
const isTypeCurrentActivity = documentType => documentType === _billing.DocumentType.CurrentActivity;
/**
 * Returns true if documentType is PrePaidInvoices
 * @param {string} documentType the documentType string
 * @returns {string} true if documentType is PrePaidInvoices, false otherwise
 */


exports.isTypeCurrentActivity = isTypeCurrentActivity;

const isDocumentTypePrePaidInvoices = documentType => documentType === _billing.DocumentType.PrePaidInvoices;
/**
 * Returns true if documentType is PrePaidStatement
 * @param {string} documentType the documentType string
 * @returns {string} true if documentType is PrePaidStatement, false otherwise
 */


exports.isDocumentTypePrePaidInvoices = isDocumentTypePrePaidInvoices;

const isDocumentTypePrePaidStatement = documentType => documentType === _billing.DocumentType.PrePaidStatement;
/**
 * Returns true if documentType is PostPaidStatement
 * @param {string} documentType the documentType string
 * @returns {string} true if documentType is PostPaidStatement, false otherwise
 */


exports.isDocumentTypePrePaidStatement = isDocumentTypePrePaidStatement;

const isDocumentTypePostPaidStatement = documentType => documentType === _billing.DocumentType.PostPaidStatement;
/**
 * Returns true if documentType is credit memo
 * @param {string} documentType the documentType string
 * @returns {string} true if documentType is credit memo, false otherwise
 */


exports.isDocumentTypePostPaidStatement = isDocumentTypePostPaidStatement;

const isDocumentTypeCreditMemo = documentType => _underscore.default.contains(_billing.CreditMemoDocumentType, documentType);
/**
 * Returns true if documentType is monthly statement
 * @param {string} documentType the documentType string
 * @returns {string} true if documentType is monthly statement, false otherwise
 */


exports.isDocumentTypeCreditMemo = isDocumentTypeCreditMemo;

const isDocumentTypeMonthlyStatement = documentType => documentType === _billing.DocumentType.MonthlyStatement;
/**
 * Returns the billing document date range
 * @param {object} billingDocument the billingDocument object
 * @param {object} options Some optional options for date formatting: pass i18n and dateFormat
 * @returns {string} the billing document date range in the following format: startDate-endDate if they both exists, or only one of them. Is no date, returns empty string
 */


exports.isDocumentTypeMonthlyStatement = isDocumentTypeMonthlyStatement;

const getDocumentDateRangeFormatted = function getDocumentDateRangeFormatted(_ref) {
  let {
    ActivityStartDate,
    ActivityEndDate,
    DocumentType
  } = _ref;
  let {
    i18n,
    dateFormat
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  const getDateFormatted = date => date && i18n && dateFormat ? i18n.formatDate(new Date(date), {
    format: dateFormat
  }) : date;

  const startDate = getDateFormatted(ActivityStartDate);
  const endDate = getDateFormatted(ActivityEndDate);
  const isCreditMemoSameDate = isDocumentTypeCreditMemo(DocumentType) && startDate === endDate;
  return isDocumentTypePrePaidInvoices(DocumentType) || isCreditMemoSameDate ? "".concat(startDate || '') : "".concat(startDate || '').concat(startDate && endDate ? ' - ' : '').concat(endDate || '');
};
/**
 * Returns true if billingDocument is consolidated, based on different backend logic
 * @param {object} billingDocument the billingDocument object
 * @returns {string} true if billingDocument is consolidated, false otherwise
 */


exports.getDocumentDateRangeFormatted = getDocumentDateRangeFormatted;

const _isConsolidated = billingDocument => _underscore.default.isObject(billingDocument) && (billingDocument.IsStatementConsolidated === 'True' || billingDocument.IsStatementConsolidated === true || billingDocument.IsConsolidatedBilling === true);
/**
 * Returns true if billingDocument is consolidated for billing group
 * @param {object} billingDocument the billingDocument object
 * @param {string} customerId the customerId
 * @returns {string} true if billingDocument is consolidated, false otherwise
 */


exports.isConsolidated = _isConsolidated;

const isConsolidatedForBillingGroup = (billingDocument, customerId) => _isConsolidated(billingDocument) && billingDocument.BillToCustomerId === customerId && !_underscore.default.isEmpty(billingDocument.BillingGroupName);
/**
 * Returns the billing document type text, or a noValue string if not a type to display
 * @param {object} billingDocument the billingDocument object
 * @param {object} options the options for type formatting: pass i18n and optional noValueStr (by default '-')
 * @returns {string} the billing document type text, or a noValueStr if not a type to display
 */


exports.isConsolidatedForBillingGroup = isConsolidatedForBillingGroup;

const getDocumentTypeText = (_ref2, _ref3) => {
  let {
    DocumentType
  } = _ref2;
  let {
    i18n,
    noValueStr = '-'
  } = _ref3;

  if (!DocumentType || isTypeCurrentActivity(DocumentType)) {
    return noValueStr;
  }

  const i18nSuffix = DocumentType === _billing.DocumentType.Pending ? 'Pending' : DocumentType;
  return i18n.getString("Billing_ColumnValue_DocumentType_".concat(i18nSuffix));
};
/**
 * Returns the past due information based on the input billing information
 * @param {number} paymentOptionId account's paymentOptionId
 * @param {number} amountBalance account's amount balance
 * @param {number} amountPaid account's paid amount
 * @param {date} dueDate due date
 * @param {boolean} isRebilled is rebilled
 * @param {object} i18n i18n
 * @returns {object} pastDueStatusText and the cssClass.
 */


exports.getDocumentTypeText = getDocumentTypeText;

const getPastDueInfo = _ref4 => {
  let {
    paymentOptionId,
    amountBalance,
    amountPaid,
    dueDate,
    isRebilled,
    i18n
  } = _ref4;
  let pastDueStatusText;
  let cssClass;
  const rebilledText = isRebilled && parseInt(paymentOptionId, 10) === _payment.PaymentOptionId.Invoice ? i18n.getString('Billing_ColumnValue_Rebilled') : undefined;

  if (parseInt(paymentOptionId, 10) === _payment.PaymentOptionId.Invoice && parseFloat(amountBalance) === 0 && amountPaid > 0) {
    pastDueStatusText = i18n.getString('Billing_ColumnValue_Paid');
    cssClass = 'paid';
  } else if (_underscore.default.isDate(dueDate) && amountBalance > 0) {
    const pstNowDate = _commonUtils.DateUtils.getPSTDateNow({
      i18n
    });

    const pastDueDay = _commonUtils.DateUtils.getDateDiffInDays({
      fromDate: pstNowDate,
      toDate: dueDate
    });

    if (pastDueDay > 0) {
      pastDueStatusText = i18n.getString('Billing_ColumnValue_PastDueTemplate').replace('{0}', pastDueDay);
      cssClass = 'pastdue';
    } else {
      pastDueStatusText = i18n.getString('Billing_ColumnValue_Open');
    }
  }

  return {
    pastDueStatusText,
    cssClass,
    rebilledText
  };
};
/**
 * @param {Uri} billingUrlBuilder the base billing Url Builder
 * @param {number} billingDocumentId the billing document Id to be rendered. If not valid will return null.
 * @param {number} advertiserCustomerId the advertisercustomerId of the target bd.
 * @param {number} accountId the accountId of the target bd.
 * @param {BillingDocumentRenderingMethod} methodId the method Id calling the BD rendering.
 * @param {string} documentType the type of the bd
 * @param {number} dualInvoiceType indicate whether get the dual invoice for IN
 * @param {bool} requireINTaxInvoice indicate whether require India tax invoice documemnt (with QRCode and IRN)
 * @returns {string} Gets the URL for rendering a billing document.
 */


exports.getPastDueInfo = getPastDueInfo;

const getBillingDocumentUrl = _ref5 => {
  let {
    billingUrlBuilder,
    billingDocumentId,
    advertiserCustomerId,
    billtoCustomerId,
    accountId,
    accountNumber,
    methodId,
    documentType,
    dualInvoiceType,
    requireINTaxInvoice
  } = _ref5;
  return _commonUtils.NumberUtils.isValidWholeNumber(billingDocumentId) ? billingUrlBuilder.action('RenderBillingDocument').params({
    id: billingDocumentId,
    advertiserCustomerId,
    billtoCustomerId,
    accountId,
    accountNumber,
    systemId: 1,
    methodId,
    documentType,
    dualInvoiceType,
    requireINTaxInvoice
  }).withoutAid().absoluteUrl : null;
};
/**
 * Returns a copy of the given billing document object with additional utility methods.
 * @param {object} billingDocument The billingDocument object to be extended with additional utility methods.
 * @param {object} options the i18n object
 * @returns {object} A copy of the extended account object.
 */


exports.getBillingDocumentUrl = getBillingDocumentUrl;

const extendBillingDocument = function extendBillingDocument() {
  let billingDocument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _underscore.default.defaults({}, billingDocument, {
    dateRangeFormatted: () => getDocumentDateRangeFormatted(billingDocument, options),
    isConsolidated: () => _isConsolidated(billingDocument),
    documentTypeText: () => getDocumentTypeText(billingDocument, options)
  });
};
/**
 * @typedef {object} PaymodErrorAlertModel
 * @property {string} heading The heading text
 * @property {string} description The description text
 * @property {Array} actions The actions
 * @property {object} helpAction The help action
 * @property {string} helpAction.text The help action text
 * @property {string} helpAction.helpQuery The help action helpQuery
 */

/**
 * Get paymod error alert model
 * @function
 * @param {object} arg function argument
 * @param {object} arg.i18n i18n model
 * @param {object} arg.urls urls from react-router
 * @param {string} arg.paymodErrorCode paymod error code
 * @param {number} arg.accountId account id
 * @returns {PaymodErrorAlertModel} paymod error alert model
 */


exports.extendBillingDocument = extendBillingDocument;

const getPaymodErrorAlertModel = _ref6 => {
  let {
    i18n,
    urls,
    paymodErrorCode,
    accountId
  } = _ref6;
  let heading = '';
  let description = '';
  const helpAction = {
    helpQuery: '50826',
    text: i18n.getString('LearnMore')
  };
  const actions = [];
  const paymentMethodUrl = urls.paymentMethods({
    aid: accountId
  });
  const payNowUrl = urls.payNow({
    aid: accountId
  });
  const prepayUrl = urls.addFunds({
    aid: accountId
  });
  const managePaymentMethodAction = {
    text: i18n.getString('PaymodError_ManagePaymentMethods'),
    url: paymentMethodUrl
  };
  const changePaymentMethodsAction = {
    text: i18n.getString('PaymodError_ChangePaymentMethods'),
    url: paymentMethodUrl
  };
  const makeManualPaymentAction = {
    text: i18n.getString('PaymodError_MakeManualPayment'),
    url: payNowUrl
  };
  const makeManualPaymentPrepayAction = {
    text: i18n.getString('PaymodError_MakeManualPayment'),
    url: prepayUrl
  };

  switch (paymodErrorCode) {
    case _billing.PaymodErrorCodes.ProcessorDeclined:
    case _billing.PaymodErrorCodes.ProcessorRiskcheckDeclined:
    case _billing.PaymodErrorCodes.TransactionNotAllowed:
    case _billing.PaymodErrorCodes.RiskReject:
      heading = i18n.getString('PaymodError_Title_BankDecline');
      description = i18n.getString('PaymodError_Description_BankDecline');
      break;

    case _billing.PaymodErrorCodes.ExpiredPaymentInstrument:
      heading = i18n.getString('PaymodError_Title_ExpiredCard');
      description = i18n.getString('PaymodError_Description_ExpiredCard');
      actions.unshift(managePaymentMethodAction);
      break;

    case _billing.PaymodErrorCodes.AmountLimitExceeded:
      heading = i18n.getString('PaymodError_Title_ExceedsTransactionLimit_ErrorFlyout');
      description = i18n.getString('PaymodError_Description_ExceedsTransactionLimit');
      actions.unshift(managePaymentMethodAction);
      break;

    case _billing.PaymodErrorCodes.InvalidPaymentInstrument:
      heading = i18n.getString('PaymodError_Title_InvalidPaymentInstrument');
      description = i18n.getString('PaymodError_Description_InvalidPaymentInstrument');
      actions.unshift(managePaymentMethodAction);
      break;

    case _billing.PaymodErrorCodes.CVVValueMismatch:
      heading = i18n.getString('PaymodError_Title_CVVValueMismatch');
      description = i18n.getString('PaymodError_Description_CVVValueMismatch');
      actions.unshift(managePaymentMethodAction);
      break;

    case _billing.PaymodErrorCodes.InsufficientFund:
      heading = i18n.getString('PaymodError_Title_InsufficientFunds');
      description = i18n.getString('PaymodError_Description_InsufficientFunds');
      actions.unshift(changePaymentMethodsAction);
      break;

    case _billing.PaymodErrorCodes.MissingFundingSource:
      heading = i18n.getString('PaymodError_Title_PaymentDeclined');
      description = i18n.getString('PaymodError_Description_MissingFundingSource');
      actions.unshift(changePaymentMethodsAction);
      break;

    case _billing.PaymodErrorCodes.AuthRequired:
      heading = i18n.getString('PaymodError_Title_PaymentDeclined');
      description = i18n.getString('PaymodError_Description_PSD2');
      actions.unshift(makeManualPaymentAction);
      break;

    case _billing.PaymodErrorCodes.InvalidTransactionDataPrepay:
      heading = i18n.getString('PaymodError_Title_SystemIssue_ErrorFlyout');
      description = i18n.getString('PaymodError_Description_InvalidTransactionData_Prepay');
      actions.unshift(makeManualPaymentPrepayAction);
      break;

    case _billing.PaymodErrorCodes.InvalidTransactionDataThreshold:
      heading = i18n.getString('PaymodError_Title_SystemIssue_ErrorFlyout');
      description = i18n.getString('PaymodError_Description_InvalidTransactionData_Threshold');
      actions.unshift(makeManualPaymentAction);
      break;

    case _billing.PaymodErrorCodes.AuthorizationExpired:
    case _billing.PaymodErrorCodes.IncorrectPinOrPasscode:
    case _billing.PaymodErrorCodes.MissingSessionData:
    case _billing.PaymodErrorCodes.InvalidTransactionData:
    default:
      heading = i18n.getString('PaymodError_Title_SystemIssue_ErrorFlyout');
      description = i18n.getString('PaymodError_Description_SystemIssue');
      break;
  }

  return {
    heading,
    description,
    actions,
    helpAction
  };
};
/**
 * @typedef {object} BillingSummary
 * @property {number} PaymentOptionId The paymentOptionId of the billingSummary
 */

/**
 * Is designated billing summary
 * @function
 * @param {BillingSummary} billingSummary - The billingSummary object
 * @param {number} paymentOptionId - The payment option id
 * @returns {bool} Whether the billingSummary is designated billing summary
 */


exports.getPaymodErrorAlertModel = getPaymodErrorAlertModel;

const isDesignatedBillingSummary = (billingSummary, paymentOptionId) => _underscore.default.result(billingSummary, 'PaymentOptionId') === paymentOptionId;
/**
 * Is prepay billing summary
 * @function
 * @param {BillingSummary} billingSummary - The billingSummary object
 * @returns {bool} Whether the billingSummary is prepay or not
 */


exports.isDesignatedBillingSummary = isDesignatedBillingSummary;

const _isPrepayBillingSummary = billingSummary => isDesignatedBillingSummary(billingSummary, _payment.PaymentOptionId.Prepay);
/**
 * Is threshold billing summary
 * @function
 * @param {BillingSummary} billingSummary - The billingSummary object
 * @returns {bool} Whether the billingSummary is threshold or not
 */


exports.isPrepayBillingSummary = _isPrepayBillingSummary;

const _isThresholdBillingSummary = billingSummary => isDesignatedBillingSummary(billingSummary, _payment.PaymentOptionId.Threshold);
/**
 * Is invoice billing summary
 * @function
 * @param {BillingSummary} billingSummary - The billingSummary object
 * @returns {bool} Whether the billingSummary is invoice or not
 */


exports.isThresholdBillingSummary = _isThresholdBillingSummary;

const _isInvoiceBillingSummary = billingSummary => isDesignatedBillingSummary(billingSummary, _payment.PaymentOptionId.Invoice);
/**
 * Is coupon billing summary
 * @function
 * @param {BillingSummary} billingSummary - The billingSummary object
 * @returns {bool} Whether the billingSummary is coupon or not
 */


exports.isInvoiceBillingSummary = _isInvoiceBillingSummary;

const _isCouponBillingSummary = billingSummary => !_underscore.default.result(billingSummary, 'PaymentOptionId');
/**
 * The getBillingSummary factory
 * @function
 * @param {Array.<BillingSummary>} [billingSummaries=[]] - The array of BillingSummaries
 * @param {function(BillingSummary):bool} filter - The designated billingSummary filter
 * @returns {function():BillingSummary} The function to find the billingSummary satisfying the filter
 */


exports.isCouponBillingSummary = _isCouponBillingSummary;

const getDesignatedBillingSummaryFactory = function getDesignatedBillingSummaryFactory() {
  let billingSummaries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let filter = arguments.length > 1 ? arguments[1] : undefined;
  return () => _underscore.default.find(billingSummaries, filter);
};
/**
 * Get designated billing summary
 * @function
 * @param {Array.<BillingSummary>} billingSummaries - The array of BillingSummaries
 * @param {number} paymentOptionId - The payment option id
 * @returns {BillingSummary} The designated BillingSummary found
 */


exports.getDesignatedBillingSummaryFactory = getDesignatedBillingSummaryFactory;

const getDesignatedBillingSummary = (billingSummaries, paymentOptionId) => getDesignatedBillingSummaryFactory(billingSummaries, billingSummary => isDesignatedBillingSummary(billingSummary, paymentOptionId))();
/**
 * Get prepay billing summary
 * @function
 * @param {Array.<BillingSummary>} billingSummaries - The array of BillingSummaries
 * @returns {BillingSummary} The prepay BillingSummary found
 */


exports.getDesignatedBillingSummary = getDesignatedBillingSummary;

const getPrepayBillingSummary = billingSummaries => getDesignatedBillingSummary(billingSummaries, _payment.PaymentOptionId.Prepay);
/**
 * Get threshold billing summary
 * @function
 * @param {Array.<BillingSummary>} billingSummaries - The array of BillingSummaries
 * @returns {BillingSummary} The threshold BillingSummary found
 */


exports.getPrepayBillingSummary = getPrepayBillingSummary;

const getThresholdBillingSummary = billingSummaries => getDesignatedBillingSummary(billingSummaries, _payment.PaymentOptionId.Threshold);
/**
 * Get invoice billing summary
 * @function
 * @param {Array.<BillingSummary>} billingSummaries - The array of BillingSummaries
 * @returns {BillingSummary} The invoice BillingSummary found
 */


exports.getThresholdBillingSummary = getThresholdBillingSummary;

const getInvoiceBillingSummary = billingSummaries => getDesignatedBillingSummary(billingSummaries, _payment.PaymentOptionId.Invoice);
/**
 * Get coupon billing summary
 * @function
 * @param {Array.<BillingSummary>} billingSummaries - The array of BillingSummaries
 * @returns {BillingSummary} The coupon BillingSummary found
 */


exports.getInvoiceBillingSummary = getInvoiceBillingSummary;

const getCouponBillingSummary = billingSummaries => getDesignatedBillingSummaryFactory(billingSummaries, _isCouponBillingSummary)();
/**
 * Extend billingSummary with some useful functions
 * @function
 * @param {BillingSummary} billingSummary - The billingSummary to extend
 * @returns {BillingSummary} The extended billingSummary
 */


exports.getCouponBillingSummary = getCouponBillingSummary;

const extendBillingSummary = billingSummary => _underscore.default.defaults({}, billingSummary, {
  isPrepayBillingSummary: () => _isPrepayBillingSummary(billingSummary),
  isThresholdBillingSummary: () => _isThresholdBillingSummary(billingSummary),
  isInvoiceBillingSummary: () => _isInvoiceBillingSummary(billingSummary),
  isCouponBillingSummary: () => _isCouponBillingSummary(billingSummary)
});
/**
 * @typedef {object} AccountInformation
 * @property {string} accountName The account name
 * @property {string} accountNumber The account number
 * @property {string} accountLink The link to the account billing documents page
 */

/**
 * Get the account info from billing document
 * @function
 * @param {object} param param
 * @property {object} param.billingDocument The billing document data from server
 * @property {object} param.i18n The i18n object
 * @property {number} param.cid The customer Id
 * @property {object} param.urls The urls parsed by react router
 * @property {bool} param.addBasename Whether to add basename into accountLink
 * @returns {AccountInformation} The account information
 */


exports.extendBillingSummary = extendBillingSummary;

const getBillingDocumentAccountInfo = function getBillingDocumentAccountInfo() {
  let {
    billingDocument,
    i18n,
    cid,
    urls = {},
    addBasename = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  const isConsolidatedBilling = _isConsolidated(billingDocument);

  const accountName = isConsolidatedBilling ? i18n.getString('Billing_ColumnValue_MultipleAccounts') : billingDocument.AccountName;
  const accountNumber = isConsolidatedBilling ? undefined : billingDocument.AccountNumber;
  const accountLink = _underscore.default.isFunction(urls && urls.current) && urls.current({
    cid,
    aid: billingDocument.AccountId
  }, {
    addBasename
  });
  return {
    accountName,
    accountNumber,
    accountLink: !isConsolidatedBilling && accountLink
  };
};

exports.getBillingDocumentAccountInfo = getBillingDocumentAccountInfo;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGroupingCriteria = exports.UIToMTBillingGroup = exports.MTToUIUngroupedAccounts = exports.MTToUIBillingGroups = exports.denormalizeIncludeCampaignDetailsValue = exports.normalizeIncludeCampaignDetailsValue = void 0;

var _constants = __webpack_require__(90);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const normalizeIncludeCampaignDetailsValue = value => {
  switch (value) {
    case true:
      return _constants.AttestationValue.True;

    case false:
      return _constants.AttestationValue.False;

    default:
      return _constants.AttestationValue.NotSet;
  }
};

exports.normalizeIncludeCampaignDetailsValue = normalizeIncludeCampaignDetailsValue;

const denormalizeIncludeCampaignDetailsValue = value => {
  switch (value) {
    case _constants.AttestationValue.True:
      return true;

    case _constants.AttestationValue.False:
      return false;

    default:
      return false;
  }
};

exports.denormalizeIncludeCampaignDetailsValue = denormalizeIncludeCampaignDetailsValue;

const MTToUIBillingGroups = billingGroups => billingGroups.map(b => ({
  billingGroupId: b.id,
  billtoCustomerId: b.BilltoCustomerId,
  name: b.Name,
  description: b.Description,
  sapId: b.SapId,
  address: b.Address,
  taxInformation: b.TaxInformation,
  currencyCode: b.CurrencyCode,
  languageId: b.LanguageId,
  companyCode: b.CompanyCode,
  includeCampaignDetails: normalizeIncludeCampaignDetailsValue(b.IncludeCampaignDetails),
  accounts: b.Accounts || []
}));

exports.MTToUIBillingGroups = MTToUIBillingGroups;

const MTToUIUngroupedAccounts = ungroupedAccounts => ungroupedAccounts.map(a => ({
  accountName: a.Name,
  accountId: a.id,
  accountNumber: a.Number,
  potentialBillingGroups: a.PotentialBillingGroups ? a.PotentialBillingGroups.map(g => ({
    id: g.Key,
    name: g.Value
  })) : []
}));

exports.MTToUIUngroupedAccounts = MTToUIUngroupedAccounts;

const UIToMTBillingGroup = billingGroupInfo => ({
  id: billingGroupInfo.billingGroupId,
  BilltoCustomerId: billingGroupInfo.billtoCustomerId,
  Name: billingGroupInfo.name,
  Description: billingGroupInfo.description,
  SapId: billingGroupInfo.sapId,
  Address: billingGroupInfo.address,
  TaxInformation: billingGroupInfo.taxInformation,
  CurrencyCode: billingGroupInfo.currencyCode,
  LanguageId: billingGroupInfo.languageId,
  CompanyCode: billingGroupInfo.companyCode,
  IncludeCampaignDetails: denormalizeIncludeCampaignDetailsValue(billingGroupInfo.includeCampaignDetails),
  Accounts: billingGroupInfo.accounts
});

exports.UIToMTBillingGroup = UIToMTBillingGroup;

const getGroupingCriteria = (_ref, isInWhiteList) => {
  let {
    billtoSapId,
    currencyType,
    billingGroupId,
    companyCode,
    businessAddress,
    taxInformation
  } = _ref;
  const sharedGroupingCriteria = {
    [_constants.GroupingCriteria.BilltoSAPId]: billtoSapId,
    [_constants.GroupingCriteria.CurrencyType]: currencyType,
    [_constants.GroupingCriteria.BillingGroupId]: billingGroupId
  };
  const whiteListGroupingCriteria = {
    [_constants.GroupingCriteria.CompanyCode]: companyCode
  };
  const nonWhiteListGroupingCriteria = {
    [_constants.GroupingCriteria.BusinessAddress]: businessAddress,
    [_constants.GroupingCriteria.TaxInformation]: taxInformation
  };
  return _objectSpread(_objectSpread({}, sharedGroupingCriteria), isInWhiteList ? whiteListGroupingCriteria : nonWhiteListGroupingCriteria);
};

exports.getGroupingCriteria = getGroupingCriteria;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPBCOfferDescription = exports.extendCoupon = exports.isExpired = exports.getAssociatedCouponExpirationDate = exports.getCouponUpfrontSpendThreshold = exports.getFirstAvailableCoupon = exports.getUpfrontSpendingCoupons = exports.getActiveCoupons = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _windowInterface = _interopRequireDefault(__webpack_require__(6));

var _coupon = __webpack_require__(102);

var _taxUtils = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Return the active coupons
 * @param {array} coupons an array of the coupons list
 * @returns {array} the list of active coupons
 */
const getActiveCoupons = function getActiveCoupons() {
  let coupons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _underscore.default.filter(coupons, coupon => coupon.StatusId === _coupon.CouponStatus.ActiveCoupon);
};
/**
 * Return the upfront spending coupons
 * @param {array} coupons an array of the coupons list
 * @returns {array} the list of upfront spending coupons
 */


exports.getActiveCoupons = getActiveCoupons;

const getUpfrontSpendingCoupons = function getUpfrontSpendingCoupons() {
  let coupons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _underscore.default.filter(coupons, coupon => coupon.StatusId === _coupon.CouponStatus.UpfrontSpending);
};
/**
 * Return the first available coupon
 * @param {array} coupons an array of the coupons list
 * @returns {array} the first available coupon, will return first active coupon. If no active coupons, return first upfront spending coupon
 */


exports.getUpfrontSpendingCoupons = getUpfrontSpendingCoupons;

const getFirstAvailableCoupon = function getFirstAvailableCoupon() {
  let coupons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _underscore.default.first(getActiveCoupons(coupons)) || _underscore.default.first(getUpfrontSpendingCoupons(coupons));
};
/**
 * Return the upfront spending coupon threshold
 * @param {object} coupon the coupon object
 * @param {object} account the account object
 * @param {array} countries the countries list
 * @returns {number} upfront spending coupon threshold
 */


exports.getFirstAvailableCoupon = getFirstAvailableCoupon;

const getCouponUpfrontSpendThreshold = _ref => {
  let {
    coupon,
    account,
    countries
  } = _ref;

  if (!coupon) {
    return null;
  }

  const {
    CouponType: couponType,
    UpfrontSpendThreshold: upfrontSpendThreshold,
    CurrentUpfrontSpend: currentUpfrontSpend = {}
  } = coupon;

  if (couponType === _coupon.CouponType.Performance && currentUpfrontSpend === 0 && currentUpfrontSpend < upfrontSpendThreshold && (0, _taxUtils.isAccountTaxable)(account, countries)) {
    return upfrontSpendThreshold;
  }

  return null;
};
/**
 * @typedef {object} Coupon
 * @property {string} ExpiryDateFromAssociation - The expiry date from association
 * @property {string} EndDate - The end date
 * @property {string} ExpiryDate - The expiry date
 */

/**
 * Get asssociated coupon expiration date
 * @function
 * @param {Coupon} coupon - The coupon object
 * @returns {Date} the coupon expiration date
 */


exports.getCouponUpfrontSpendThreshold = getCouponUpfrontSpendThreshold;

const getAssociatedCouponExpirationDate = coupon => {
  const {
    ExpiryDateFromAssociation,
    EndDate,
    ExpiryDate
  } = coupon || {};
  return _underscore.default.chain([ExpiryDateFromAssociation, EndDate, ExpiryDate]).compact().map(dateString => new _windowInterface.default.Date(dateString)).sortBy().first().value();
};
/**
 * Whether the coupon is expired
 * @function
 * @param {Coupon} coupon - The coupon object
 * @returns {bool} Whether the coupon is expired
 */


exports.getAssociatedCouponExpirationDate = getAssociatedCouponExpirationDate;

const _isExpired = coupon => {
  const associatedCouponExpirationDate = getAssociatedCouponExpirationDate(coupon);
  return !!associatedCouponExpirationDate && associatedCouponExpirationDate < new _windowInterface.default.Date();
};
/**
 * Extend coupon with some useful functions
 * @function
 * @param {Coupon} coupon - The coupon to extend
 * @returns {Coupon} The extended coupon
 */


exports.isExpired = _isExpired;

const extendCoupon = coupon => _underscore.default.defaults({}, coupon, {
  isExpired: () => _isExpired(coupon),
  associatedCouponExpirationDate: () => getAssociatedCouponExpirationDate(coupon)
});
/**
 * Get PBC offer description
 * @function
 * @param {object} options - The options
 * @param {object} options.i18n - The i18n object
 * @param {string} options.currencyCode - The currency code
 * @param {number} options.performanceCoupon - The performance coupon value
 * @param {number} options.upfrontSpend - The upfront spend threshold
 * @returns {string} The PBC offer description
 */


exports.extendCoupon = extendCoupon;

const getPBCOfferDescription = _ref2 => {
  let {
    i18n,
    currencyCode,
    performanceCoupon,
    upfrontSpend
  } = _ref2;
  return i18n.getString('CouponDetails_PerformanceCombinedValueThresholdLabel_OneLine').replace('{0}', i18n.formatCurrency(performanceCoupon, currencyCode, {
    maximumFractionDigits: 0
  })).replace('{1}', i18n.formatCurrency(upfrontSpend, currencyCode, {
    maximumFractionDigits: 0
  }));
};

exports.getPBCOfferDescription = getPBCOfferDescription;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTaxInformationMatch = exports.serializeTaxInformation = exports.normalizeAttestationValue = exports.normalizeTaxExemptionCertVerifiedResult = exports.defaultsTaxDataWithEmptyValue = exports.getAvailableTaxTypes = exports.getTaxValue = exports.inlineFormatTaxInfos = exports.inlineFormatTaxInfo = exports.isChileVATValid = exports.isCanadaGSTNumberValid = exports.isNigeriaVATValid = exports.isThailandVATValid = exports.isIndiaGSTINValid = exports.isRSLegalNumberValid = exports.isPIBNumberValid = exports.isPANNumberValid = exports.isSGGSTNumberValid = exports.isCOCertExecutionDateValid = exports.isAUGSTNumberValid = exports.isAEVatNumberValid = exports.isCOVatNumberValid = exports.isCNPJIdValid = exports.isCPFIdValid = exports.getVatStatusLocalized = exports.isAccountTaxable = exports.getTaxRate = exports.calculatePreTaxAmount = exports.getTaxAndBalance = exports.getTaxDocumentUrl = exports.getFormattedTaxDocumentStatusKey = exports.areEqual = exports.isBusinessTaxOptionType = exports.isPersonalTaxOptionType = exports.getTaxOptionLabel = exports.mapToLocalizedTaxInfos = exports.mapToLocalizedTaxInfo = exports.getTaxTypeEnumValue = exports.getRequiredForCustomerClaimTaxExemption = exports.getTaxCertLabelDisplay = exports.getTaxTypeLabel = exports.getRequiredForIVAorVATTaxPayerLabel = exports.getRequiredForValueAddedTaxIVARegisteredLabel = exports.getRequiredForVATRegisteredBusinessLabel = exports.getRequiredForBusinessLabel = exports.getRequiredForAllTheEntitiesLabel = exports.getRequiredLabel = exports.getOptionalLabel = exports.getTaxOptionByType = exports.isEMEAVatIdRequiredForB2C = exports.isEMEAVatIdRequired = exports.checkEMEAVatIdRequiredStatus = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _commonUtils = __webpack_require__(37);

var _constants = __webpack_require__(90);

var _countryUtils = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const {
  isStringNotBlank,
  regexTest
} = _commonUtils.StringUtils;
const taxInfoConnector = '-';
const taxInfoSeparator = ', ';

const inlineFormatLocalizedTaxInfo = _ref => {
  let {
    label,
    value
  } = _ref;
  return _underscore.default.isEmpty(label) || _underscore.default.isEmpty(value) ? '' : "".concat(label).concat(taxInfoConnector).concat(value);
};

const indiaEInvoicingStatusKey = status => {
  if (!_underscore.default.isNumber(status)) {
    return null;
  }

  switch (status) {
    case _constants.IndiaEInvoicingStatus.Available:
    case _constants.IndiaEInvoicingStatus.PendingCustomerAction:
    case _constants.IndiaEInvoicingStatus.PendingSupport:
    case _constants.IndiaEInvoicingStatus.PendingCreditAndRebill:
      return 'Available';

    case _constants.IndiaEInvoicingStatus.Failed:
      return 'Failed';

    case _constants.IndiaEInvoicingStatus.NotStarted:
    case _constants.IndiaEInvoicingStatus.PendingIRNGeneration:
    default:
      return 'Pending';
  }
};
/**
 * TaxInfoKeyValue object
 * @typedef {object} TaxInfoKeyValue
 * @property {string} [Key] the Key of the TaxInfoKeyValue corresponding to the TaxInfo type
 * @property {string} [Value] the Value of the TaxInfoKeyValue
 */

/**
 * LocalizedTaxInfo object
 * @typedef {object} LocalizedTaxInfo
 * @property {string} [label] the localized label of the TaxInfo
 * @property {string} [value] the value of the TaxInfo
 */


const TaxTypeToLabelMap = {
  default: {
    [_constants.TaxType.CPF]: 'Account_CPFLabel',
    [_constants.TaxType.CNPJ]: 'Account_CNPJLabel',
    [_constants.TaxType.GSTINNumber]: 'Account_GSTINLabel',
    [_constants.TaxType.PANNumber]: 'Account_PANLabel',
    [_constants.TaxType.VatNumber]: 'Account_VATShortLabel',
    [_constants.TaxType.AUGSTNumber]: 'Account_ABNLabel',
    [_constants.TaxType.NZGSTNumber]: 'Account_NZGSTRegistrationNumberLabel',
    [_constants.TaxType.CCM]: 'Account_CCMLabel',
    [_constants.TaxType.GSTNumber]: 'Account_GSTRegistrationNumberLabel',
    [_constants.TaxType.LegalIdentifier]: 'Account_LegalIdentifierNumber'
  },
  [_constants.CountryCode.CO]: {
    [_constants.TaxType.VatNumber]: 'Account_ColombiaVATLabel'
  },
  [_constants.CountryCode.CL]: {
    [_constants.TaxType.VatNumber]: 'Account_ChileVATLabel'
  },
  [_constants.CountryCode.AE]: {
    [_constants.TaxType.VatNumber]: 'Account_TRNOrVATLabel'
  },
  [_constants.CountryCode.IL]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.NO]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.VN]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.TR]: {
    [_constants.TaxType.VatNumber]: 'Account_VKNLabel'
  },
  [_constants.CountryCode.GE]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.TH]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.BD]: {
    [_constants.TaxType.VatNumber]: 'Account_BINLabel'
  },
  [_constants.CountryCode.ID]: {
    [_constants.TaxType.VatNumber]: 'Account_NPWPLabel'
  },
  [_constants.CountryCode.BY]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.NG]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.IS]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.MD]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.ZW]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.BH]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.KH]: {
    [_constants.TaxType.VatNumber]: 'Account_VAT_TINLabel'
  },
  [_constants.CountryCode.KE]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.SA]: {
    [_constants.TaxType.VatNumber]: 'Account_TINOrVATLabel'
  },
  [_constants.CountryCode.OM]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.GH]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.CM]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.UZ]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.FJ]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.GT]: {
    [_constants.TaxType.VatNumber]: 'Account_NITLabel'
  },
  [_constants.CountryCode.BS]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.PH]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.AM]: {
    [_constants.TaxType.VatNumber]: 'Account_AAHLabel'
  },
  [_constants.CountryCode.BB]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.KZ]: {
    [_constants.TaxType.VatNumber]: 'Account_NDSKKSLabel'
  },
  [_constants.CountryCode.MX]: {
    [_constants.TaxType.VatNumber]: 'Account_RFCLabel'
  },
  [_constants.CountryCode.ZA]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.LA]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.NP]: {
    [_constants.TaxType.VatNumber]: 'Account_VATIdLabel'
  },
  [_constants.CountryCode.RS]: {
    [_constants.TaxType.VatNumber]: 'Account_PIBLabel',
    [_constants.TaxType.LegalIdentifier]: 'Account_LegalNumberLabel'
  },
  [_constants.CountryCode.AR]: {
    [_constants.TaxType.VatNumber]: 'Account_CUITLabel'
  },
  [_constants.CountryCode.AZ]: {
    [_constants.TaxType.VatNumber]: 'Account_VOENLabel'
  },
  [_constants.CountryCode.BJ]: {
    [_constants.TaxType.VatNumber]: 'Account_IFULabel'
  },
  [_constants.CountryCode.CN]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.CI]: {
    [_constants.TaxType.VatNumber]: 'Account_nTVALabel'
  },
  [_constants.CountryCode.JP]: {
    [_constants.TaxType.VatNumber]: 'Account_JCTLabel'
  },
  [_constants.CountryCode.MY]: {
    [_constants.TaxType.VatNumber]: 'Account_SSTLabel'
  },
  [_constants.CountryCode.MM]: {
    [_constants.TaxType.VatNumber]: 'Account_TBCLabel'
  },
  [_constants.CountryCode.SR]: {
    [_constants.TaxType.VatNumber]: 'Account_FINLabel'
  },
  [_constants.CountryCode.TJ]: {
    [_constants.TaxType.VatNumber]: 'Account_TINLabel'
  },
  [_constants.CountryCode.UA]: {
    [_constants.TaxType.VatNumber]: 'Account_VATRegNoLabel'
  },
  [_constants.CountryCode.VE]: {
    [_constants.TaxType.VatNumber]: 'Account_RIFLabel'
  },
  [_constants.CountryCode.ZM]: {
    [_constants.TaxType.VatNumber]: 'Account_TPINLabel'
  }
};
const TaxInfoLabels = {
  [_constants.TaxInfo.IsTaxExemptionCertVerified]: {
    [_constants.TaxExemptionCertVerifiedResult.Accept]: _TL_('VAT Exempted'),
    [_constants.TaxExemptionCertVerifiedResult.Reject]: _TL_('VAT Not Exempted')
  },
  [_constants.TaxInfo.IsIVAOrVATTaxPayer]: {
    [_constants.AttestationValue.True]: _TL_('IVA/VAT Taxpayer'),
    [_constants.AttestationValue.False]: _TL_('Not IVA/VAT Taxpayer')
  },
  [_constants.TaxInfo.IsWithholdingTaxExempted]: {
    [_constants.AttestationValue.True]: _TL_('WHT Exempted'),
    [_constants.AttestationValue.False]: _TL_('WHT Not Exempted')
  },
  [_constants.TaxInfo.ReverseChargeDocumentAttestation]: {
    [_constants.AttestationValue.True]: _TL_('Reverse Charge Document Attested'),
    [_constants.AttestationValue.False]: _TL_('Reverse Charge Document Not Attested')
  }
};
/**
 * Mapping between TaxType to TaxOption
 */

const TaxTypeTaxOptionMap = {
  [_constants.TaxType.CPF]: _constants.TaxOptionType.Personal,
  [_constants.TaxType.CNPJ]: _constants.TaxOptionType.Business,
  [_constants.TaxType.CCM]: _constants.TaxOptionType.Business
};
/**
 * VAT Id required EMEA Countries,
 *  - key: countryCode
 *  - value: pilot name, or boolean if the feature has been GAed
 */

const EMEAVatIdRequiredCountries = {
  [_constants.CountryCode.HU]: 'ABLHungaryTax',
  [_constants.CountryCode.PT]: 'ABLPortugalTax'
};
/**
 * VAT Id required EMEA Countries for B2C
 *  - key: countryCode
 *  - value: pilot name, or boolean if the feature has been GAed
 */

const EMEAVatIdRequiredCountriesForB2C = {
  [_constants.CountryCode.HU]: 'ABLHungaryTaxPayments',
  [_constants.CountryCode.PT]: 'ABLPortugalTaxPayments'
};
/**
 * Check the EMEA VAT ID required status
 * @function
 * @param {object} param param
 * @property {object} param.countryPilotMapping country pilot mapping object
 * @property {string} param.countryCode country code
 * @property {object} param.permissions permissions object
 * @returns {boolean} `true` if the pilot is enabled or feature has been GAed, otherwise `false`.
 */

const checkEMEAVatIdRequiredStatus = _ref2 => {
  let {
    countryPilotMapping,
    countryCode,
    permissions
  } = _ref2;

  if (_underscore.default.has(countryPilotMapping, countryCode)) {
    const pilotId = countryPilotMapping[countryCode];

    if (_underscore.default.isBoolean(pilotId)) {
      return pilotId;
    }

    const {
      dynamic
    } = permissions || {};
    return !!_underscore.default.result(dynamic, pilotId);
  }

  return false;
};
/**
 * Check if the VatId is required for the countryCode
 * @function
 * @param {object} param param
 * @property {string} param.countryCode country code
 * @property {object} param.permissions permissions object
 * @returns {boolean} `true` if VatId is required for this country, otherwise `false`
 */


exports.checkEMEAVatIdRequiredStatus = checkEMEAVatIdRequiredStatus;

const isEMEAVatIdRequired = _ref3 => {
  let {
    countryCode,
    permissions
  } = _ref3;
  return checkEMEAVatIdRequiredStatus({
    countryPilotMapping: EMEAVatIdRequiredCountries,
    countryCode,
    permissions
  });
};
/**
 * Check if the VatId is required for the countryCode for B2C
 * @function
 * @param {object} param param
 * @property {string} param.countryCode country code
 * @property {object} param.permissions permissions object
 * @returns {boolean} `true` if VatId is required for this country for B2C, otherwise `false`
 */


exports.isEMEAVatIdRequired = isEMEAVatIdRequired;

const isEMEAVatIdRequiredForB2C = _ref4 => {
  let {
    countryCode,
    permissions
  } = _ref4;
  return checkEMEAVatIdRequiredStatus({
    countryPilotMapping: EMEAVatIdRequiredCountriesForB2C,
    countryCode,
    permissions
  });
};
/**
 * @param {string} taxOption the tax option
 * @returns {string} the tax type
 */


exports.isEMEAVatIdRequiredForB2C = isEMEAVatIdRequiredForB2C;

const getTaxOptionByType = taxOption => TaxTypeTaxOptionMap[taxOption];
/**
 * Gets the display string with optional label text
 * @param {string} label of the tax
 * @param {*} i18n the i18n object
 * @returns {string} display string of label with optional text
 */


exports.getTaxOptionByType = getTaxOptionByType;

const getOptionalLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_Optional')) : label;
/**
 * Gets the display string with required label text
 * @param {string} label of the tax
 * @param {*} i18n the i18n object
 * @returns {string} display string of label with required text
 */


exports.getOptionalLabel = getOptionalLabel;

const getRequiredLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_Required')) : label;
/**
 * Gets the display string with required for all the entities label text
 * @param {string} label of the tax
 * @param {*} i18n the i18n object
 * @returns {string} display string of label with required text
 */


exports.getRequiredLabel = getRequiredLabel;

const getRequiredForAllTheEntitiesLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_RequiredForAllTheEntities')) : label;
/**
 * Gets the display string with required for business label text
 * @param {string} label of the tax
 * @param {*} i18n the i18n object
 * @returns {string} display string of label with required for business label text
 */


exports.getRequiredForAllTheEntitiesLabel = getRequiredForAllTheEntitiesLabel;

const getRequiredForBusinessLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_RequiredForBusinessCustomers')) : label;
/**
 * Gets the display string with required for VAT registered business customers label text
 * @param {string} label of the tax
 * @param {*} i18n the i18n object
 * @returns {string} display string of label with required for VAT registered business customers label text
 */


exports.getRequiredForBusinessLabel = getRequiredForBusinessLabel;

const getRequiredForVATRegisteredBusinessLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_RequiredForVATRegisteredBusinessCustomers')) : label;

exports.getRequiredForVATRegisteredBusinessLabel = getRequiredForVATRegisteredBusinessLabel;

const getRequiredForValueAddedTaxIVARegisteredLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_RequiredForValueAddedTaxIVARegisteredCustomers')) : label;

exports.getRequiredForValueAddedTaxIVARegisteredLabel = getRequiredForValueAddedTaxIVARegisteredLabel;

const getRequiredForIVAorVATTaxPayerLabel = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_RequiredForIVAorVATTaxPayerCustomers')) : label;
/**
 * Gets the display string of TaxInfo's type from i18n, or empty string if the type is unknown or i18n cannot be found
 * @param {string} taxType the tax type key
 * @param {*} i18n the i18n object
 * @param {string} options options for the label format and country code
 * @returns {string} display string of TaxInfo's type from i18n
 */


exports.getRequiredForIVAorVATTaxPayerLabel = getRequiredForIVAorVATTaxPayerLabel;

const getTaxTypeLabel = function getTaxTypeLabel(taxType, i18n) {
  let {
    labelFormat = _constants.TaxLabelFormat.Default,
    countryCode
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const taxTypeLabelKey = _underscore.default.get(TaxTypeToLabelMap, [countryCode, taxType]) || TaxTypeToLabelMap.default[taxType];
  const taxTypeLabel = taxTypeLabelKey && i18n ? i18n.getString(taxTypeLabelKey) : '';

  if (!taxTypeLabel) {
    return taxTypeLabel;
  }

  switch (labelFormat) {
    case _constants.TaxLabelFormat.Optional:
      return getOptionalLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.Required:
      return getRequiredLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.RequiredForAllTheEntities:
      return getRequiredForAllTheEntitiesLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.RequiredForBusiness:
      return getRequiredForBusinessLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.RequiredForVATRegisteredBusiness:
      return getRequiredForVATRegisteredBusinessLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.RequiredForValueAddedTaxIVARegistered:
      return getRequiredForValueAddedTaxIVARegisteredLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.RequiredForIVAorVATTaxPayer:
      return getRequiredForIVAorVATTaxPayerLabel(taxTypeLabel, i18n);

    case _constants.TaxLabelFormat.Default:
    default:
      return taxTypeLabel;
  }
};
/**
 *
 * @param {string} taxCertLabel - The label for tax cert field
 * @param {bool} taxCertOptional - Indicate whether tax cert is optional
 * @param {object} i18n - the i18n object
 * @returns {string} - Tax cert field label
 */


exports.getTaxTypeLabel = getTaxTypeLabel;

const getTaxCertLabelDisplay = (taxCertLabel, taxCertOptional, i18n) => taxCertOptional ? getOptionalLabel(taxCertLabel, i18n) : taxCertLabel;
/**
 *
 * @param {string} label of tax
 * @param {*} i18n the i18n object
 * @returns {string} display string of label with required for customers claiming a tax exemption
 */


exports.getTaxCertLabelDisplay = getTaxCertLabelDisplay;

const getRequiredForCustomerClaimTaxExemption = (label, i18n) => i18n ? "".concat(label, " ").concat(i18n.getString('Label_RequiredForCustomersClaimingTaxExemption')) : label;
/**
 * @param {string} taxType the tax type
 * @returns {string} the tax type enum value
 */


exports.getRequiredForCustomerClaimTaxExemption = getRequiredForCustomerClaimTaxExemption;

const getTaxTypeEnumValue = taxType => _constants.TaxTypeEnumValue[taxType];
/**
 * Map the TaxInfoKeyValue pair in parameter into a proper TaxInfo object localized ready for use in UI
 * @param {TaxInfoKeyValue} taxInfoKeyValue the TaxInfoKeyValue to map
 * @param {*} i18n the i18n object
 * @param {object} options the option object
 * @returns {LocalizedTaxInfo} returns a proper TaxInfo object localized ready for use in UI
 */


exports.getTaxTypeEnumValue = getTaxTypeEnumValue;

const mapToLocalizedTaxInfo = (taxInfoKeyValue, i18n, options) => {
  const label = getTaxTypeLabel(taxInfoKeyValue && taxInfoKeyValue.Key, i18n, options);
  const value = taxInfoKeyValue && taxInfoKeyValue.Value || '';
  return {
    label,
    value
  };
};
/**
 * Use mapToLocalizedTaxInfo for all TaxInfoKeyValue objects in the taxInfoKeyValues in params
 * @param {TaxInfoKeyValue[]} taxInfoKeyValues the TaxInfoKeyValues array to map
 * @param {*} i18n the i18n object
 * @param {object} options the options object
 * @returns {LocalizedTaxInfo[]} returns a proper TaxInfo object's array localized ready for use in UI
 */


exports.mapToLocalizedTaxInfo = mapToLocalizedTaxInfo;

const mapToLocalizedTaxInfos = (taxInfoKeyValues, i18n, options) => _underscore.default.chain(taxInfoKeyValues).map(_underscore.default.partial(mapToLocalizedTaxInfo, _underscore.default, i18n, options)).filter(localizedTaxInfo => !_underscore.default.isEmpty(localizedTaxInfo.label)).value();
/**
 * Mapping between TaxOption to Label
 */


exports.mapToLocalizedTaxInfos = mapToLocalizedTaxInfos;
const TaxOptionTypeToLabelMap = {
  [_constants.TaxOptionType.Personal]: 'TaxType_1',
  [_constants.TaxOptionType.Business]: 'TaxType_2'
};
/**
 * Gets the display string of TaxOption type from i18n, or empty string if the type is unknown or i18n cannot be found
 * @param {string} taxOption the tax option key
 * @param {*} i18n the i18n object
 * @returns {string} display string of Tax Option from i18n
 */

const getTaxOptionLabel = (taxOption, i18n) => {
  const taxOptionLabelKey = TaxOptionTypeToLabelMap[taxOption];
  return taxOptionLabelKey && i18n ? i18n.getString(taxOptionLabelKey) : '';
};

exports.getTaxOptionLabel = getTaxOptionLabel;

const isPersonalTaxOptionType = taxOption => taxOption === _constants.TaxOptionType.Personal;

exports.isPersonalTaxOptionType = isPersonalTaxOptionType;

const isBusinessTaxOptionType = taxOption => taxOption === _constants.TaxOptionType.Business;
/**
 * Returns true if the 2 TaxInfos object in param have the same set of taxInfos, whatever the order.
 * If both arrays are empty, then we consider them equal.
 * @param {TaxInfoKeyValue[]} taxInfos the tax infos array to test for equality, need to have unique set of key
 * @param {TaxInfoKeyValue[]} otherTaxInfos the other tax infos array to test for equality, need to have unique set of key
 * @returns {boolean} true if the 2 TaxInfos object in param are equal, false otherwise.
 * @throws Will throw an error if the taxInfos in param have duplicate Key or no Key property
 */


exports.isBusinessTaxOptionType = isBusinessTaxOptionType;

const areEqual = (taxInfos, otherTaxInfos) => {
  if (_underscore.default.isEmpty(taxInfos) && _underscore.default.isEmpty(otherTaxInfos)) {
    return true;
  }

  if (_underscore.default.isArray(taxInfos) && _underscore.default.isArray(otherTaxInfos)) {
    if (taxInfos.length !== otherTaxInfos.length) {
      return false;
    }

    const hasPropertyKeys = taxInfoArray => _underscore.default.all(taxInfoArray, taxInfo => _underscore.default.has(taxInfo, 'Key'));

    if (!hasPropertyKeys(taxInfos) || !hasPropertyKeys(otherTaxInfos)) {
      throw new Error('TaxInfos parameters needs to have the property "Key" for comparison');
    }

    const hasUniqueKeys = taxInfoArray => _underscore.default.unique(taxInfoArray, false, taxInfo => taxInfo.Key).length === taxInfoArray.length;

    if (!hasUniqueKeys(taxInfos) || !hasUniqueKeys(otherTaxInfos)) {
      throw new Error('TaxInfos parameters cannot have duplicate Keys');
    }

    return _underscore.default.all(taxInfos, taxInfo => _underscore.default.some(otherTaxInfos, otherTaxInfo => _underscore.default.isEqual(taxInfo, otherTaxInfo)));
  }

  return false;
};
/**
 * Get the formatted tax document status key used by billing grid tax column
 * @param {string} brazilEnfStatus Brzil enf status.
 * @param {boolean} hasRussiaDAF whether has Russia DAF
 * @param {number} billingDocumentId billing document Id
 * @param {number} indiaEInvoicingStatus india e-invoicing status
 * @return {string} Localization key for the tax doc status.
 */


exports.areEqual = areEqual;

const getFormattedTaxDocumentStatusKey = _ref5 => {
  let {
    brazilEnfStatus,
    hasRussiaDAF,
    billingDocumentId,
    indiaEInvoicingStatus
  } = _ref5;
  const status = brazilEnfStatus || indiaEInvoicingStatusKey(indiaEInvoicingStatus) || hasRussiaDAF && billingDocumentId && 'Available';

  if (status) {
    return "Billing_ColumnValue_TaxDocumentStatus_".concat(status);
  }

  return null;
};
/**
 * get the tax document download Url.
 * @param {string} brazilEnfLink the Brazil ENF download link
 * @param {boolean} hasRussiaDAF whether has Russia DAF
 * @param {string} indiaEInvoicingLink the India E-invoicing download link
 * @param {number} billingDocumentId billing document Id
 * @param {number} advertiserCustomerId the advertiser customerId of this BD.
 * @param {number} accountId account id
 * @param {object} urlBuilders the urlBuilders components.
 * @return {string} the download url
 */


exports.getFormattedTaxDocumentStatusKey = getFormattedTaxDocumentStatusKey;

const getTaxDocumentUrl = _ref6 => {
  let {
    brazilEnfLink,
    hasRussiaDAF,
    indiaEInvoicingLink,
    billingDocumentId,
    advertiserCustomerId,
    accountId,
    urlBuilders
  } = _ref6;

  if (brazilEnfLink) {
    return brazilEnfLink;
  }

  if (hasRussiaDAF && billingDocumentId && advertiserCustomerId) {
    return new urlBuilders.BillingUrlBuilder().action('RenderDAFDocument').params({
      aid: accountId,
      id: billingDocumentId,
      advertiserCustomerId
    }).url;
  }

  if (indiaEInvoicingLink) {
    return indiaEInvoicingLink;
  }

  return '';
};
/**
 * Return the tax amount and balance amount
 * @param {number} fundingAmount the amount to fund
 * @param {number} estimatedTaxRate the estimated tax amount
 * @param {number} currentBalance the current balance
 * @returns {object} contains the actual applied funding amount and the tax amount
 */


exports.getTaxDocumentUrl = getTaxDocumentUrl;

const getTaxAndBalance = function getTaxAndBalance() {
  let {
    fundingAmount,
    estimatedTaxRate,
    currentBalance
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!_underscore.default.isFinite(fundingAmount) || !_underscore.default.isFinite(estimatedTaxRate)) {
    return {};
  }

  const actingTaxRate = Math.max(0, estimatedTaxRate);
  const taxAmount = fundingAmount * actingTaxRate;
  const appliedAmount = _underscore.default.isFinite(taxAmount) && fundingAmount - taxAmount;
  return _underscore.default.extend({}, {
    taxAmount,
    appliedAmount
  }, _underscore.default.isFinite(currentBalance) && {
    finalBalance: currentBalance + appliedAmount
  });
};
/**
 * Return the total amount which can get the target post tax amount after paying tax
 * @param {number} postTaxAmount the target gross amount after paying tax
 * @param {number} estimatedTaxRate the estimated tax amount
 * @returns {number} the total amount before paying tax
 */


exports.getTaxAndBalance = getTaxAndBalance;

const calculatePreTaxAmount = function calculatePreTaxAmount() {
  let {
    postTaxAmount,
    estimatedTaxRate
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!_underscore.default.isFinite(postTaxAmount) || !_underscore.default.isFinite(estimatedTaxRate) || postTaxAmount < 0 || estimatedTaxRate < 0 || estimatedTaxRate >= 1) {
    return null;
  }

  return postTaxAmount / (1 - estimatedTaxRate); // postTaxAmount = preTaxAmount - preTaxAmount * estimatedTaxRate
};
/**
 * Return the tax rate according to the taxing amount and the actual tax
 * @param {number} tax the tax amount
 * @param {number} taxingAmount the funding amount which should pay tax
 * @returns {number} the tax rate
 */


exports.calculatePreTaxAmount = calculatePreTaxAmount;

const getTaxRate = function getTaxRate() {
  let {
    tax,
    taxingAmount
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!_underscore.default.isFinite(tax) || !_underscore.default.isFinite(taxingAmount) || taxingAmount <= 0 || tax < 0 || tax > taxingAmount) {
    return null;
  }

  return tax / taxingAmount;
};
/**
 * Return whether the account is taxable
 * @param {object} account the account
 * @param {array} countries an array of the countries list
 * @returns {bool} indicate whether the account is taxable
 */


exports.getTaxRate = getTaxRate;

const isAccountTaxable = (account, countries) => {
  if (!account || !countries || !countries.length) {
    return false;
  }

  const {
    BusinessAddress: {
      Country: countryCode
    } = {}
  } = account;
  const country = (0, _countryUtils.findCountry)({
    countries,
    countryCode
  });
  return (0, _countryUtils.isTaxableCountry)(country) || (0, _countryUtils.isVatApplicable)(country);
};
/**
 * Return localized VAT status and identify if it is active or not
 * @param {number} vatStatus VatStatus from MT
 * @param {object} i18n i18n to format text
 * @returns {object} The localized status text with isActive status (true/false). Return null if not applicable.
 */


exports.isAccountTaxable = isAccountTaxable;

const getVatStatusLocalized = _ref7 => {
  let {
    vatStatus,
    i18n
  } = _ref7;

  if (_underscore.default.contains(_underscore.default.values(_constants.VatStatusEnum), vatStatus)) {
    return {
      isActive: vatStatus === _constants.VatStatusEnum.Valid || vatStatus === _constants.VatStatusEnum.Pending,
      text: i18n.getString("AccountGrid_TaxInformation_VatStatus_".concat(vatStatus))
    };
  }

  return null;
};
/**
 * Return whether the provided CPF id is valid
 * @param {string} cpfId The CPF Id
 * @returns {bool} Indicate whether CPF id is valid format
 */


exports.getVatStatusLocalized = getVatStatusLocalized;

const isCPFIdValid = cpfId => {
  if (!_underscore.default.isString(cpfId) || !isStringNotBlank(cpfId) || cpfId.length < _constants.TaxIdMaxLength.CPF) {
    return false;
  }

  let v1 = 0;
  let v2 = 0;

  const v1Coefficients = _underscore.default.range(10, 1, -1);

  const v2Coefficients = _underscore.default.range(11, 2, -1);

  const getCPFDigit = index => Number(cpfId[index]);

  _underscore.default.each(_underscore.default.range(v1Coefficients.length), index => {
    const value = getCPFDigit(index);
    v1 += v1Coefficients[index] * value;
    v2 += v2Coefficients[index] * value;
  });

  v1 = 11 - v1 % 11;
  v1 = v1 >= 10 ? 0 : v1;
  v2 += 2 * v1;
  v2 = 11 - v2 % 11;
  v2 = v2 >= 10 ? 0 : v2;

  if (v1 !== getCPFDigit(9) || v2 !== getCPFDigit(10)) {
    return false;
  }

  return true;
};
/**
 * Return whether the provided CNPJ id is valid
 * @param {string} cnpjId The CNPJ Id
 * @returns {bool} Indicate whether CNPJ id is valid format
 */


exports.isCPFIdValid = isCPFIdValid;

const isCNPJIdValid = cnpjId => {
  if (!_underscore.default.isString(cnpjId) || !isStringNotBlank(cnpjId) || cnpjId.length < _constants.TaxIdMaxLength.CNPJ) {
    return false;
  }

  let v1 = 0;
  let v2 = 0;
  const v1Coefficients = [..._underscore.default.range(5, 1, -1), ..._underscore.default.range(9, 1, -1)];
  const v2Coefficients = [..._underscore.default.range(6, 1, -1), ..._underscore.default.range(9, 1, -1)];

  const getCNPJDigit = index => Number(cnpjId[index]);

  _underscore.default.each(v1Coefficients, (v1Digit, index) => {
    v1 += v1Digit * getCNPJDigit(index);
  });

  _underscore.default.each(v2Coefficients, (v2Digit, index) => {
    v2 += v2Digit * getCNPJDigit(index);
  });

  v1 = 11 - v1 % 11;
  v1 = v1 >= 10 ? 0 : v1;
  v2 = 11 - v2 % 11;
  v2 = v2 >= 10 ? 0 : v2;

  if (v1 !== getCNPJDigit(12) || v2 !== getCNPJDigit(13)) {
    return false;
  }

  return true;
};
/**
 * Return whether the provided CO Vat Number is valid
 * @param {string} coVatNumber The CO Vat Number
 * @returns {bool} Indicate whether CO Vat Number is valid format
 */


exports.isCNPJIdValid = isCNPJIdValid;

const isCOVatNumberValid = _underscore.default.partial(regexTest, _constants.TaxCOVatNumberRegExp);
/**
 * Return whether the provided AE Vat Number is valid
 * @param {string} aeVatNumber The AE Vat Number
 * @returns {bool} Indicate whether AE Vat Number is valid format
 */


exports.isCOVatNumberValid = isCOVatNumberValid;

const isAEVatNumberValid = _underscore.default.partial(regexTest, _constants.TaxAEVatNumberRegExp);
/**
 * Return whether the provided AUD Vat Number is valid
 * @param {string} AUGSTNumber The AUD Vat Number
 * @returns {bool} Indicate whether AUD Vat Number is valid format
 */


exports.isAEVatNumberValid = isAEVatNumberValid;

const isAUGSTNumberValid = AUGSTNumber => {
  const isAUGSTNumberFormatValid = _underscore.default.partial(regexTest, _constants.TaxAUGSTNumberRegExp);

  if (AUGSTNumber === '') {
    return true;
  }

  if (!isAUGSTNumberFormatValid(AUGSTNumber) || !AUGSTNumber || AUGSTNumber.length !== 11) {
    return false;
  }

  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  let sum = 0;

  for (let i = 0; i < AUGSTNumber.length; i += 1) {
    const digit = parseInt(AUGSTNumber.substring(i, i + 1), 10);

    if (i === 0) {
      sum += (digit - 1) * weights[i];
    } else {
      sum += digit * weights[i];
    }
  }

  if (sum % 89 !== 0) {
    return false;
  }

  return true;
};
/**
 * Return whether the provided CO certification execution date is valid
 * @param {string} coCertExecutionDate The CO certification execution date
 * @returns {bool} Indicate whether CO certification execution date is in valid format
 */


exports.isAUGSTNumberValid = isAUGSTNumberValid;

const isCOCertExecutionDateValid = _underscore.default.partial(regexTest, _constants.TaxCOCertificateExecutionDateRegExp);
/**
 * Return whether the provided SG GST Number is valid
 * @param {string} sggstNumber The SG GST Number
 * @returns {bool} Indicate whether SG GST Number is valid format
 */


exports.isCOCertExecutionDateValid = isCOCertExecutionDateValid;

const isSGGSTNumberValid = _underscore.default.partial(regexTest, _constants.TaxSGGSTNumberRegExp);
/**
 * Return whether the provided India PAN Number is valid
 * @param {string} pan The PAN tax ID number
 * @returns {bool} Indicate whether PAN number is in a valid format
 */


exports.isSGGSTNumberValid = isSGGSTNumberValid;

const isPANNumberValid = _underscore.default.partial(regexTest, _constants.TaxINPANNumberRegExp);
/**
 *  Return whether the provided Serbian PIB number is valid
 * @param {string} pib  The PIB tax ID number
 * @returns {bool} Indicate whether PIB number is in a valid format
 */


exports.isPANNumberValid = isPANNumberValid;

const isPIBNumberValid = _underscore.default.partial(regexTest, _constants.TaxRSPIBNumberRegExp);
/**
 *  Return whether the provided Serbian legal number is valid
 * @param {string} legalNumber  The PIB tax ID number
 * @returns {bool} Indicate whether PIB number is in a valid format
 */


exports.isPIBNumberValid = isPIBNumberValid;

const isRSLegalNumberValid = _underscore.default.partial(regexTest, _constants.TaxRSLegalNumberRegExp);
/**
 *  Return whether the provided India GSTIN is valid
 * @param {string} gstin The GSTIN tax ID number
 * @returns {bool} Indicate whether GSTIN is in a valid format
 */


exports.isRSLegalNumberValid = isRSLegalNumberValid;

const isIndiaGSTINValid = _underscore.default.partial(regexTest, _constants.TaxINGSTINRegExp);
/**
 * Return whether the provided Thailand VAT is valid
 * @param {string} thvat The Thailand VAT
 * @returns {bool} Indicate whether Thailand VAT is valid format
 */


exports.isIndiaGSTINValid = isIndiaGSTINValid;

const isThailandVATValid = _underscore.default.partial(regexTest, _constants.TaxTHVATRegExp);
/**
 * Return whether the provided Nigeria VAT is valid
 * @param {string} ngvat The Nigeria Vat Number
 * @returns {bool} Indicate whether Nigeria Vat Number is valid format
 */


exports.isThailandVATValid = isThailandVATValid;

const isNigeriaVATValid = _underscore.default.partial(regexTest, _constants.TaxNGVATRegExp);
/**
 * Return whether the provided Canada GST Number is valid
 * @param {string} cagst The Canada GST Number
 * @returns {bool} Indicate whether Canada GST Number is valid format
 */


exports.isNigeriaVATValid = isNigeriaVATValid;

const isCanadaGSTNumberValid = _underscore.default.partial(regexTest, _constants.TaxCAGSTNumberRegExp);
/**
 * Return whether the provided Chile VAT Number is valid
 * @param {string} chileVATNumber The Chile VAT Number
 * @returns {bool} Indicate whether Chile VAT Number is valid format
 */


exports.isCanadaGSTNumberValid = isCanadaGSTNumberValid;

const isChileVATValid = chileVATNumber => {
  const isChileVATFormatValid = _underscore.default.partial(regexTest, _constants.TaxChileVATRegExp);

  if (chileVATNumber === '') {
    return true;
  }

  if (!isChileVATFormatValid(chileVATNumber)) {
    return false;
  }

  const weights = [2, 3, 4, 5, 6, 7];
  const strList = chileVATNumber.split('-');
  const num = strList[0];
  const checkDigit = strList[1];
  let sum = 0;
  let j = 0;

  for (let i = num.length - 1; i >= 0; i -= 1) {
    sum += (num[i] - '0') * weights[j % weights.length];
    j += 1;
  }

  const expectedCheckDigit = 11 - sum % 11;

  switch (expectedCheckDigit) {
    case 11:
      return checkDigit === '0';

    case 10:
      return checkDigit === 'K';

    default:
      return checkDigit === expectedCheckDigit.toString();
  }
};
/**
 * Convert the TaxInfoKeyValue pair in parameter to localized inline format
 * @param {TaxInfoKeyValue} taxInfoKeyValue the TaxInfoKeyValue
 * @param {object} i18n the i18n object
 * @returns {string} the localized inline formatted taxInfo
 */


exports.isChileVATValid = isChileVATValid;

const inlineFormatTaxInfo = (taxInfoKeyValue, i18n) => inlineFormatLocalizedTaxInfo(mapToLocalizedTaxInfo(taxInfoKeyValue, i18n));
/**
 * Convert all TaxInfoKeyValue objects in the taxInfoKeyValues in params to localized inline format
 * @param {TaxInfoKeyValue[]} taxInfoKeyValues the TaxInfoKeyValues array
 * @param {object} i18n the i18n object
 * @returns {string} the lozalized inline formatted taxInfos
 */


exports.inlineFormatTaxInfo = inlineFormatTaxInfo;

const inlineFormatTaxInfos = (taxInfoKeyValues, i18n) => _underscore.default.reduce(mapToLocalizedTaxInfos(taxInfoKeyValues, i18n), (memo, localizedTaxInfo) => {
  const separator = _underscore.default.isEmpty(memo) ? '' : taxInfoSeparator;
  const inlineformattedTaxInfo = inlineFormatLocalizedTaxInfo(localizedTaxInfo);
  return _underscore.default.isEmpty(inlineformattedTaxInfo) ? memo : "".concat(memo).concat(separator).concat(inlineformattedTaxInfo);
}, '');
/**
 * Get tax value of a given tax type, returns null if not exists
 * @param {TaxInfoKeyValue[]} taxInfoKeyValues - The TaxInfoKeyValues array of { Key: taxType, Value: taxValue }
 * @param {string} taxType - The tax type to find
 * @returns {string} - The tax value, returns null if not exists
 */


exports.inlineFormatTaxInfos = inlineFormatTaxInfos;

const getTaxValue = (taxInfoKeyValues, taxType) => _underscore.default.chain(taxInfoKeyValues).findWhere({
  Key: taxType
}).result('Value', null).value();
/**
 * Get available tax types from taxSchema by reading taxSchema.properties
 * @param {object} taxSchema - The taxSchema object containing properties of available tax types
 * @returns {string[]} - The available tax types
 */


exports.getTaxValue = getTaxValue;

const getAvailableTaxTypes = _ref8 => {
  let {
    taxSchema
  } = _ref8;
  return _underscore.default.filter(_underscore.default.keys(taxSchema.properties), taxType => _underscore.default.keys(_constants.TaxType).includes(taxType));
};
/**
 * Fill taxData with empty-Value properties of avaiable tax types if not exist
 * @param {object} taxInfoUIObject - The taxInfo UI object. Property is TaxType, value is TaxValue.
 * @param {object} taxSchema - The taxSchema object containing properties of available tax types
 * @returns {object} - The filled taxInfo UI object
 */


exports.getAvailableTaxTypes = getAvailableTaxTypes;

const defaultsTaxDataWithEmptyValue = _ref9 => {
  let {
    taxInfoUIObject,
    taxSchema
  } = _ref9;
  const availableTaxTypes = getAvailableTaxTypes({
    taxSchema
  });
  return _underscore.default.reduce(availableTaxTypes, (memo, taxType) => _objectSpread(_objectSpread({}, memo), {}, {
    [taxType]: _underscore.default.result(taxInfoUIObject, taxType, null)
  }), {});
};
/**
 * Normalize IsTaxExemptionCertVerified value from MT
 * @param {string} MTValue - The MTValue of IsTaxExemptionCertVerified
 * @returns {string} - The valid IsTaxExemptionCertVerified value accepted by MT
 */


exports.defaultsTaxDataWithEmptyValue = defaultsTaxDataWithEmptyValue;

const normalizeTaxExemptionCertVerifiedResult = MTValue => {
  if (_underscore.default.result(MTValue, 'toLowerCase') === _constants.TaxExemptionCertVerifiedResult.Accept.toLowerCase()) {
    return _constants.TaxExemptionCertVerifiedResult.Accept;
  }

  if (_underscore.default.result(MTValue, 'toLowerCase') === _constants.TaxExemptionCertVerifiedResult.Reject.toLowerCase()) {
    return _constants.TaxExemptionCertVerifiedResult.Reject;
  }

  return _constants.TaxExemptionCertVerifiedResult.NotSet;
};
/**
 * Normalize attestation value from MT
 * @param {string} MTValue - The MTValue of attestation value, e.g. IsIVAOrVATTaxPayer
 * @returns {string} - The valid attestation value accepted by MT
 */


exports.normalizeTaxExemptionCertVerifiedResult = normalizeTaxExemptionCertVerifiedResult;

const normalizeAttestationValue = MTValue => {
  if (_underscore.default.result(MTValue, 'toLowerCase') === _constants.AttestationValue.True.toLowerCase()) {
    return _constants.AttestationValue.True;
  }

  if (_underscore.default.result(MTValue, 'toLowerCase') === _constants.AttestationValue.False.toLowerCase()) {
    return _constants.AttestationValue.False;
  }

  return _constants.AttestationValue.NotSet;
};
/**
 * Serialize tax information to string
 * @param {array} taxInformation MT tax information
 * @param {*} countryCode country code
 * @param {*} legacyI18n legacy i18n object
 * @param {*} i18n i18n object
 * @returns {string} serialized tax information
 */


exports.normalizeAttestationValue = normalizeAttestationValue;

const serializeTaxInformation = function serializeTaxInformation() {
  let taxInformation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let countryCode = arguments.length > 1 ? arguments[1] : undefined;
  let legacyI18n = arguments.length > 2 ? arguments[2] : undefined;
  let i18n = arguments.length > 3 ? arguments[3] : undefined;

  if (taxInformation === null) {
    return i18n.getString(_TL_('No tax number'));
  }

  const delimiter = ', ';
  return _underscore.default.reduce(taxInformation, (acc, taxId) => {
    if (Object.keys(_constants.TaxType).includes(taxId.Key)) {
      const taxTypeLabel = getTaxTypeLabel(taxId.Key, legacyI18n, {
        countryCode
      }); // eslint-disable-next-line no-param-reassign

      acc += acc ? "".concat(delimiter).concat(taxTypeLabel, ": ").concat(taxId.Value) : "".concat(taxTypeLabel, ": ").concat(taxId.Value);
    } else if (Object.keys(_constants.TaxInfo).includes(taxId.Key)) {
      const taxInfoLabelMap = TaxInfoLabels[taxId.Key] || {};
      const normalizedValue = normalizeAttestationValue(taxId.Value);
      const taxInfoLabel = i18n.getString(taxInfoLabelMap[normalizedValue]); // eslint-disable-next-line no-param-reassign

      acc += acc ? "".concat(delimiter).concat(taxInfoLabel) : taxInfoLabel;
    }

    return acc;
  }, '');
};

exports.serializeTaxInformation = serializeTaxInformation;

const isTaxInformationMatch = function isTaxInformationMatch() {
  let taxInformation1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let taxInformation2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let {
    includeTaxInfo = false
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const taxInformationMap = {};
  const taxInformationMap2 = {};

  _underscore.default.forEach(taxInformation1, item => {
    if (includeTaxInfo || Object.keys(_constants.TaxType).includes(item.Key)) {
      taxInformationMap[item.Key] = item.Value;
    }
  });

  _underscore.default.forEach(taxInformation2, item => {
    if (includeTaxInfo || Object.keys(_constants.TaxType).includes(item.Key)) {
      taxInformationMap2[item.Key] = item.Value;
    }
  });

  const keysToCompare = Object.keys(taxInformationMap);

  if (keysToCompare.length !== Object.keys(taxInformationMap2).length) {
    return false;
  }

  for (let i = 0; i < keysToCompare.length; i += 1) {
    if (!_underscore.default.find(taxInformation2, {
      Key: keysToCompare[i],
      Value: taxInformationMap[keysToCompare[i]]
    })) {
      return false;
    }
  }

  return true;
};

exports.isTaxInformationMatch = isTaxInformationMatch;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendCustomer = exports.isTSTMissingMasterData = exports.isTSTTrueMatch = exports.isTSTLicR = exports.isTSTInReview = exports.isTSTDataIssueLegalId = exports.isTSTDataIssueAddress = exports.isTSTDataIssueName = exports.isManagedByYahoo = exports.isInAppScope = exports.parseCustomerProfileSingle = exports.parseCustomerProfile = exports.getHierarchyCustomer = exports.isAggregatee = exports.getDisplayName = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _commonUtils = __webpack_require__(37);

var _customer = __webpack_require__(104);

var _linking = __webpack_require__(106);

var _tradeScreeningTransformation = __webpack_require__(113);

var _common = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const {
  hasFlag
} = _commonUtils.NumberUtils;
/**
 * Returns the display string of an customer in the format CustomerName (CustomerNumber)
 * @param {object} customer the customer object
 * @param {*} i18n the i18n object
 * @returns {string} the display string of customer
 */

const getDisplayName = (customer, i18n) => {
  if (!_underscore.default.isObject(customer)) {
    return '';
  }

  const name = customer.name || '';
  return customer.number ? i18n.getString('Customer_DisplayName', {
    name,
    number: customer.number
  }) : name;
};

exports.getDisplayName = getDisplayName;

const _isAggregatee = customer => !!customer.AggregatorName;
/**
 * Returns the hierarchy format of an customer
 * @param {object} customer the customer object
 * @returns {string} the hierarchy format of an customer
 */


exports.isAggregatee = _isAggregatee;

const getHierarchyCustomer = function getHierarchyCustomer() {
  let customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    id: customer.id,
    name: customer.Name,
    number: customer.Number,
    managers: _underscore.default.map(customer.DirectManagers, function () {
      let manager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        name: manager.RelatedToCustomerName,
        number: manager.RelatedToCustomerNumber,
        id: manager.RelatedToCustomerId
      };
    }),
    type: _linking.HierarchyAccountTypeValue.ManagerAccount
  };
};
/**
 * CustomerProfileModel holds a list profile properties for a customer.
 * @typedef {object} CustomerProfileModel
 * @property {number} [numberOfBillToInvoiceAccounts]
 * @property {number} [numberOfBillToPrepayAccounts]
 * @property {number} [numberOfBillToThresholdAccounts]
 * @property {bool} [isOptedInConsolidatedBilling]
 * @property {bool} [isOptedInCampaignDetails]
 * @property {number} [totalNumberOfBillToAccounts]
 */


exports.getHierarchyCustomer = getHierarchyCustomer;

const getCustomerProfileValue = (customerProfile, customerProfilePropertyType) => {
  const profile = _underscore.default.findWhere(customerProfile.CustomerProfilePropertyList, {
    CustomerProfilePropertyType: customerProfilePropertyType
  });

  const value = profile && profile.Value;
  return parseInt(value, 10) || 0;
};
/**
 * Parse a customerProfile's CustomerProfilePropertyList array into a readable CustomerProfileModel's properties
 * @param {object} customerProfile the customerProfile object
 * @returns {CustomerProfileModel} the model of a customer Profile
 */


const parseCustomerProfile = customerProfile => {
  if (!_underscore.default.isObject(customerProfile) || !_underscore.default.isArray(customerProfile.CustomerProfilePropertyList)) {
    return null;
  }

  const numberOfBillToInvoiceAccounts = getCustomerProfileValue(customerProfile, _customer.CustomerProfilePropertyType.NumberOfBillToInvoiceAccountsUnderCustomer);
  const numberOfBillToPrepayAccounts = getCustomerProfileValue(customerProfile, _customer.CustomerProfilePropertyType.NumberOfBillToPrepayAccountsUnderCustomer);
  const numberOfBillToThresholdAccounts = getCustomerProfileValue(customerProfile, _customer.CustomerProfilePropertyType.NumberOfBillToThresholdAccountsUnderCustomer);
  const isOptedInConsolidatedBilling = getCustomerProfileValue(customerProfile, _customer.CustomerProfilePropertyType.IsOptedInForConsolidatedBilling) === 1;
  const isOptedInCampaignDetails = getCustomerProfileValue(customerProfile, _customer.CustomerProfilePropertyType.IsOptedInForCampaignDetailsInInvoices) === 1;
  return {
    numberOfBillToInvoiceAccounts,
    numberOfBillToPrepayAccounts,
    numberOfBillToThresholdAccounts,
    isOptedInConsolidatedBilling,
    isOptedInCampaignDetails,
    totalNumberOfBillToAccounts: numberOfBillToInvoiceAccounts + numberOfBillToPrepayAccounts + numberOfBillToThresholdAccounts
  };
};
/**
 * Parse a customerProfile's CustomerProfilePropertyList array and return the specified property value
 * @param {object} customerProfile the customerProfile object
 * @param {number} propertyType the customerProfilePropertyType enum
 * @returns {number} the customerProfileProperty value
 */


exports.parseCustomerProfile = parseCustomerProfile;

const parseCustomerProfileSingle = (customerProfile, propertyType) => {
  if (!_underscore.default.isObject(customerProfile) || !_underscore.default.isArray(customerProfile.CustomerProfilePropertyList) || _underscore.default.isEmpty(customerProfile.CustomerProfilePropertyList)) {
    return null;
  }

  return getCustomerProfileValue(customerProfile, propertyType);
};
/**
 * Returns true if the customer in param belongs to the appScope given in params
 * @param {object} customer the customer object
 * @param {*} appScope the Applications the Customer is associated with
 * @returns {boolean} true if the customer in param belongs to the appScope given in params
 */


exports.parseCustomerProfileSingle = parseCustomerProfileSingle;

const _isInAppScope = (customer, appScope) => _underscore.default.contains(_underscore.default.values(_customer.AppScope), appScope) && hasFlag(customer.AppScope, appScope);
/**
 * Returns true if the customer is managed by Yahoo
 * @function
 * @param {object} customer the customer object
 * @returns {bool} true if the customer is managed by Yahoo
 */


exports.isInAppScope = _isInAppScope;

const _isManagedByYahoo = customer => _underscore.default.result(customer, 'ManagedBy') === _customer.ManagedByType.Yahoo;
/**
 * Check if customer is in TST data issue missing name status
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether customer is in TST data issue missing name status
 */


exports.isManagedByYahoo = _isManagedByYahoo;

const _isTSTDataIssueName = (customer, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && (_underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueName || _underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueOrg);
/**
 * Check if customer is in TST data issue missing address status
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether customer is in TST data issue missing address status
 */


exports.isTSTDataIssueName = _isTSTDataIssueName;

const _isTSTDataIssueAddress = (customer, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueAddress;
/**
 * Check if customer is in TST data issue missing legal identifier status
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether customer is in TST data issue missing legal identifier status
 */


exports.isTSTDataIssueAddress = _isTSTDataIssueAddress;

const _isTSTDataIssueLegalId = (customer, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.DataIssueLegalId;
/**
 * Check if customer is in TST hit-in-review status
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether customer is in TST hit-in-review status
 */


exports.isTSTDataIssueLegalId = _isTSTDataIssueLegalId;

const _isTSTInReview = (customer, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.HitInReview;
/**
 * Check if customer is in TST LicR status
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether customer is in TST LicR status
 */


exports.isTSTInReview = _isTSTInReview;

const _isTSTLicR = (customer, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.LicR;
/**
 * Check if customer is in TST true-match status
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} isTradeScreeningTransformationEnabled The TST UI pilot
 * @returns {boolean} Result of whether customer is in TST true-match status
 */


exports.isTSTLicR = _isTSTLicR;

const _isTSTTrueMatch = (customer, isTradeScreeningTransformationEnabled) => isTradeScreeningTransformationEnabled && _underscore.default.get(customer, 'TradeScreeningStatus') === _tradeScreeningTransformation.TradeScreeningStatus.TrueMatch;
/**
 * Check if customer is missing master data
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {boolean} pilots.isTradeScreeningTransformationEnabled The TST UI pilot
 * @param {boolean} pilots.isTSTMasterDataMissingNotificationEnabled The TST DB pilot
 * @returns {boolean} Result of whether customer is missing data
 */


exports.isTSTTrueMatch = _isTSTTrueMatch;

const _isTSTMissingMasterData = (customer, _ref) => {
  let {
    isTradeScreeningTransformationEnabled,
    isTSTMasterDataMissingNotificationEnabled
  } = _ref;
  return isTradeScreeningTransformationEnabled && isTSTMasterDataMissingNotificationEnabled && ((0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(customer, ['Address', 'Country'])) || (0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(customer, ['Address', 'City'])) || (0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(customer, ['Address', 'Line1'])) || (0, _common.isStringNullOrWhiteSpace)(_underscore.default.get(customer, ['Name'])));
};
/**
 * Returns a copy of the given customer object with additional utility methods.
 * @param {object} customer The customer object to be extended with additional utility methods.
 * @param {*} i18n the i18n object
 * @returns {object} A copy of the extended customer object.
 */


exports.isTSTMissingMasterData = _isTSTMissingMasterData;

const extendCustomer = function extendCustomer() {
  let customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let i18n = arguments.length > 1 ? arguments[1] : undefined;
  return _underscore.default.defaults({}, customer, {
    isAggregatee: () => _isAggregatee(customer),
    displayName: () => getDisplayName(customer, i18n),
    hierarchyCustomer: () => getHierarchyCustomer(customer),
    isInAppScope: appScope => _isInAppScope(customer, appScope),
    isManagedByYahoo: () => _isManagedByYahoo(customer),
    isTSTDataIssueName: _ref2 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref2;
      return _isTSTDataIssueName(customer, isTradeScreeningTransformationEnabled);
    },
    isTSTDataIssueAddress: _ref3 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref3;
      return _isTSTDataIssueAddress(customer, isTradeScreeningTransformationEnabled);
    },
    isTSTDataIssueLegalId: _ref4 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref4;
      return _isTSTDataIssueLegalId(customer, isTradeScreeningTransformationEnabled);
    },
    isTSTInReview: _ref5 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref5;
      return _isTSTInReview(customer, isTradeScreeningTransformationEnabled);
    },
    isTSTLicR: _ref6 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref6;
      return _isTSTLicR(customer, isTradeScreeningTransformationEnabled);
    },
    isTSTTrueMatch: _ref7 => {
      let {
        isTradeScreeningTransformationEnabled
      } = _ref7;
      return _isTSTTrueMatch(customer, isTradeScreeningTransformationEnabled);
    },
    isTSTMissingMasterData: _ref8 => {
      let {
        isTradeScreeningTransformationEnabled,
        isTSTMasterDataMissingNotificationEnabled
      } = _ref8;
      return _isTSTMissingMasterData(customer, {
        isTradeScreeningTransformationEnabled,
        isTSTMasterDataMissingNotificationEnabled
      });
    }
  });
};

exports.extendCustomer = extendCustomer;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IsFraudAppealPage = IsFraudAppealPage;
exports.IsFraudAppealAIVPage = IsFraudAppealAIVPage;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _urijs = _interopRequireDefault(__webpack_require__(36));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function IsFraudAppealPage(_ref) {
  let {
    urls
  } = _ref;

  if (_underscore.default.isFunction(urls && urls.current) && _underscore.default.isFunction(urls && urls.fraudAppeal)) {
    const currentUrl = (0, _urijs.default)(urls.current());
    const fraudAppealUrl = (0, _urijs.default)(urls.fraudAppeal());
    return currentUrl.path() === fraudAppealUrl.path();
  }

  return false;
}

function IsFraudAppealAIVPage(_ref2) {
  let {
    urls
  } = _ref2;

  if (_underscore.default.isFunction(urls && urls.current) && _underscore.default.isFunction(urls && urls.fraudAppealAIV)) {
    const currentUrl = (0, _urijs.default)(urls.current());
    const fraudAppealAIVUrl = (0, _urijs.default)(urls.fraudAppealAIV());
    return currentUrl.path() === fraudAppealAIVUrl.path();
  }

  return false;
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDecimal = getDecimal;
exports.getIOAlertInGrid = exports.formatEndlessIOEndDateInGrid = exports.formatUnlimitedIOBudgetInGrid = exports.getSpendCapAmountNumber = exports.isImmediateStartDate = exports.isEndlessIOEndDate = exports.isUnlimitedIOBudget = exports.isAllIOsValid = exports.isIOValid = exports.convertGridIOToSingleIOFormIO = exports.extendInsertionOrder = exports.isPendingTakeoverBillingIO = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _commonUtils = __webpack_require__(37);

var _insertionOrder = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const {
  isDateWithoutTimeEqual
} = _commonUtils.DateUtils;
/**
 * Get whether this insertion order is pending under takeover billing linked accounts
 * @param {object} insertionOrder Value object of insertion order
 * @returns {bool} Returns true if this insertion order is pending under takeover billing linked accounts.
 */

const _isPendingTakeoverBillingIO = insertionOrder => _underscore.default.isObject(insertionOrder) && insertionOrder.IOCreationSource === _insertionOrder.IOCreationSource.BillingTakeOver && (insertionOrder.Status === _insertionOrder.InsertionOrderStatus.PendingBillToPartyChange || insertionOrder.Status === _insertionOrder.InsertionOrderStatus.PendingBillToPartyChangeAndUserReview);
/**
 * Returns a copy of the given in object with additional utility methods.
 * @param {object} insertionOrder The insertion order object to be extended with additional utility methods.
 * @returns {object} A copy of the extended insertion order object.
 */


exports.isPendingTakeoverBillingIO = _isPendingTakeoverBillingIO;

const extendInsertionOrder = function extendInsertionOrder() {
  let insertionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.defaults({}, insertionOrder, {
    isPendingTakeoverBillingIO: () => _isPendingTakeoverBillingIO(insertionOrder)
  });
};
/**
 * Returns an insertion order which matches singleIOForm' format.
 * @param {object} selectedIO The insertion order from IO grid.
 * @param {object} i18n The i18n object.
 * @returns {object} An insertion order which matches singleIOForm' format.
 */


exports.extendInsertionOrder = extendInsertionOrder;

const convertGridIOToSingleIOFormIO = (selectedIO, i18n) => {
  if (!_underscore.default.isObject(selectedIO) || !_underscore.default.isObject(i18n) || !_underscore.default.isFunction(i18n.parseDate)) {
    return {};
  }

  return {
    account: {
      AccountId: selectedIO.AccountId,
      DisplayAccountName: "".concat(selectedIO.AccountName, "(").concat(selectedIO.AccountNumber, ")")
    },
    defaultIO: _objectSpread(_objectSpread({}, selectedIO), {}, {
      FriendlyName: _underscore.default.isString(selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.InsertionOrderName]) ? selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.InsertionOrderName].trim() : null,
      FromDate: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.StartDateText] && i18n.parseDate(selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.StartDateText]),
      ThruDate: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.EndDateText] && i18n.parseDate(selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.EndDateText]),
      Status: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.StatusValue]
    }),
    mtIOEditableMap: {
      FriendlyName: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsInsertionOrderNameEditable],
      FromDate: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsStartDateEditable],
      ThruDate: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsEndDateEditable],
      SpendCapAmount: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsSpendCapAmountEditable],
      AgencyIdOrPo: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsAgencyIdOrPoEditable],
      DealPointId: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsDealPointIdEditable],
      RecordCenterId: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsRecordCenterIdEditable],
      Comment: selectedIO[_insertionOrder.InsertionOrdersGridFieldNames.IsCommentEditable]
    }
  };
};
/**
 * Returns an insertion order whether is valid.
 * @param {object} ioValidationFields The insertion order validation result object from IO grid.
 * @param {object} isIOItemNeedValidation The object of which IO items should be verified.
 * @returns {bool} Whether is a valid IO.
 */


exports.convertGridIOToSingleIOFormIO = convertGridIOToSingleIOFormIO;

const isIOValid = _ref => {
  let {
    ioValidationFields,
    isIOItemNeedValidation
  } = _ref;
  return (// when isIOItemNeedValidation[key] === false, it means we don't need this io item
    // and it does not need validation
    _underscore.default.every(isIOItemNeedValidation, (value, key) => !value || ioValidationFields && ioValidationFields[key])
  );
};
/**
 * Returns insertion orders whether are all valid.
 * @param {object} insertionOrders The insertion orders.
 * @param {object} isIOItemNeedValidation The object of which IO items should be verified.
 * @returns {bool} Whether are valid IOs.
 */


exports.isIOValid = isIOValid;

const isAllIOsValid = _ref2 => {
  let {
    insertionOrders,
    isIOItemNeedValidation
  } = _ref2;
  return _underscore.default.every(insertionOrders, insertionOrder => isIOValid({
    ioValidationFields: insertionOrder.ioValidationFields,
    isIOItemNeedValidation
  }));
};
/**
 * Returns insertion orders budget whether is unlimited.
 * @param {number} spendCapAmountValue The insertion orders budget.
 * @returns {bool} Insertion orders budget whether is unlimited.
 */


exports.isAllIOsValid = isAllIOsValid;

const isUnlimitedIOBudget = spendCapAmountValue => spendCapAmountValue === _insertionOrder.UnlimitedBudget;
/**
 * Returns insertion orders endDate whether is endless.
 * @param {object} endDateValue The insertion orders endDate.
 * @returns {bool} Whether insertion orders end date  is endless.
 */


exports.isUnlimitedIOBudget = isUnlimitedIOBudget;

const isEndlessIOEndDate = endDateValue => isDateWithoutTimeEqual(endDateValue, _insertionOrder.EndlessDate);
/**
 * Returns whether insertion orders startDate is immediate.
 * @param {object} startDateValue The insertion orders startDate.
 * @returns {bool} Whether insertion orders start date is immediate.
 */


exports.isEndlessIOEndDate = isEndlessIOEndDate;

const isImmediateStartDate = startDateValue => isDateWithoutTimeEqual(startDateValue, _insertionOrder.ImmediateDate);
/**
 * Returns insertion orders budget number.
 * @param {string} spendCapAmountValue The insertion orders budget string or budget number.
 * @param {object} i18n The i18n object.
 * @returns {number} Insertion orders budget number.
 */


exports.isImmediateStartDate = isImmediateStartDate;

const getSpendCapAmountNumber = _ref3 => {
  let {
    spendCapAmountValue,
    i18n
  } = _ref3;

  if (_underscore.default.isString(spendCapAmountValue)) {
    return i18n.parseDecimal(spendCapAmountValue);
  } else if (_underscore.default.isNumber(spendCapAmountValue)) {
    return spendCapAmountValue;
  }

  return null;
};
/**
 * Returns insertion orders budget string in grid.
 * @param {number} spendCapAmountValue The insertion orders budget.
 * @param {object} i18n The i18n object.
 * @returns {bool} Insertion orders budget string.
 */


exports.getSpendCapAmountNumber = getSpendCapAmountNumber;

const formatUnlimitedIOBudgetInGrid = _ref4 => {
  let {
    spendCapAmountValue,
    i18n
  } = _ref4;
  const spendCapAmountNumber = getSpendCapAmountNumber({
    spendCapAmountValue,
    i18n
  });

  if (isUnlimitedIOBudget(spendCapAmountNumber)) {
    return i18n.getString('InsertionOrder_Unlimited');
  }

  return _underscore.default.isNull(spendCapAmountNumber) ? null : i18n.formatDecimalToFixed(spendCapAmountNumber);
};
/**
 * Returns insertion orders endDate string in grid.
 * @param {object} endDateValue The insertion orders endDate.
 * @param {object} i18n The i18n object.
 * @returns {bool} Insertion orders endDate string.
 */


exports.formatUnlimitedIOBudgetInGrid = formatUnlimitedIOBudgetInGrid;

const formatEndlessIOEndDateInGrid = _ref5 => {
  let {
    endDateValue,
    i18n
  } = _ref5;

  if (isEndlessIOEndDate(endDateValue)) {
    return i18n.getString('InsertionOrder_NoEndDate');
  }

  return _underscore.default.isDate(endDateValue) ? i18n.formatDate(endDateValue) : null;
};
/**
 * Returns insertion orders endDate string in grid.
 * @param {object} i18n The i18n  object.
 * @param {object} iolabel The insertion orders alert label.
 * * @param {object} column The insertion orders column name.
 * @returns {object} Insertion orders alert status.
 */


exports.formatEndlessIOEndDateInGrid = formatEndlessIOEndDateInGrid;

const getIOAlertInGrid = _ref6 => {
  let {
    i18n,
    column,
    iolabel
  } = _ref6;
  const alert = {
    EndDate: {
      [_insertionOrder.InsertionOrderLabel.Expiring]: {
        alertStatus: i18n.getString('InsertionOrder_Alert_Expiring'),
        alertColor: 'status-warning',
        alertIcon: 'Warning'
      },
      [_insertionOrder.InsertionOrderLabel.Expired]: {
        alertStatus: i18n.getString('InsertionOrder_Alert_Expired'),
        alertColor: 'status-error',
        alertIcon: 'Blocked2'
      }
    },
    BalanceAmount: {
      [_insertionOrder.InsertionOrderLabel.Exhausting]: {
        alertStatus: i18n.getString('InsertionOrder_Alert_Exhausting'),
        alertColor: 'status-warning',
        alertIcon: 'Warning'
      },
      [_insertionOrder.InsertionOrderLabel.NoBudget]: {
        alertStatus: i18n.getString('InsertionOrder_Alert_NoBudget'),
        alertColor: 'status-error',
        alertIcon: 'Blocked2'
      }
    }
  };
  return (column === _insertionOrder.InsertionOrdersGridFieldNames.EndDate || column === _insertionOrder.InsertionOrdersGridFieldNames.BalanceAmount) && iolabel ? alert[column][iolabel] : undefined;
};
/**
 * parse decimal from number or string or others.
 * @param {object} i18n The i18n  object.
 * @param {object} value The value to parse.
 * @returns {number} a number parsed from value.
 */


exports.getIOAlertInGrid = getIOAlertInGrid;

function getDecimal(_ref7) {
  let {
    i18n,
    value
  } = _ref7;

  if (_underscore.default.isNumber(value)) {
    return value;
  }

  if (_underscore.default.isString(value)) {
    return i18n.parseDecimal(value);
  }

  return NaN;
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findLanguage = exports.extendLanguage = exports.getLanguageName = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get language name property
 * @param {object} languageValue Value object of language
 * @param {number} languageValue.Code Code of language
 * @param {string} languageValue.Name Name of language
 * @returns {object} language name, and empty string if name is not found
 */
const getLanguageName = languageValue => _underscore.default.result(languageValue, 'Name', '');
/**
 * Get extendLanguage object
 * @param {object} languageValue Value object of language
 * @param {number} languageValue.Code Code of language
 * @param {string} languageValue.Name Name of language
 * @returns {object} extendLanguage object
 */


exports.getLanguageName = getLanguageName;

const extendLanguage = function extendLanguage() {
  let languageValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.defaults({}, languageValue, {
    name: getLanguageName(languageValue)
  });
};
/**
 * Get language value object by code
 * @param {number} code Code of language
 * @param {bool} getExtendedObject It indicates if this function will return extended language value object
 * @param {object[]} languages List of languages
 * @param {number} languages[].code Code of language
 * @param {object} languages[].value Value object of language
 * @param {number} languages[].value.Code Code of language
 * @param {string} languages[].value.Name Name of language
 * @returns {object} Language value object, and null or default extendLanguage object if language code is not found
 */


exports.extendLanguage = extendLanguage;

const findLanguage = _ref => {
  let {
    languages,
    code,
    getExtendedObject = false
  } = _ref;

  const language = _underscore.default.findWhere(languages, {
    code
  });

  const languageValue = _underscore.default.result(language, 'value', null);

  return getExtendedObject ? extendLanguage(languageValue) : languageValue;
};

exports.findLanguage = findLanguage;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterPaymentOptionsByAccountMode = exports.getPaymentReason = exports.filterPaymentInstrumentsByAccountMode = exports.filterPisByPaymentOption = exports.filterPendingSAPApplicationsOfNewSAP = exports.getPaymentTransactionStatus = exports.getPaymentTypeForPaymentOption = exports.convertPaymentOptionToId = exports.convertPaymentOptionToString = exports.convertPaymentTypeToInt = exports.convertPaymentTypeToString = exports.sortPiList = exports.extendPi = exports.isValidBackup = exports.isPaypal = exports.isSepa = exports.isOfflinePaymentMethod = exports.isBoleto = exports.isInvoice = exports.isCreditCard = exports.isPiValidated = exports.sapCreditDaysRemaining = exports.sapCreditRemaining = exports.getPaymentMethodFormatted = exports.getPaymentOptionTextById = exports.getCardStatusDisplay = exports.getDisplayName = exports.formatExpDate = exports.isIndiaPI = exports.isPurged = exports.isDeleted = exports.isOnHold = exports.isExpired = exports.getCardNumberLast4Digits = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _constants = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getCardNumberLast4Digits = number => _underscore.default.isString(number) ? number.substr(-4) : '';

exports.getCardNumberLast4Digits = getCardNumberLast4Digits;

const getCreditCardDisplayName = (pi, i18n) => {
  const displayNameKey = pi.Address ? 'PaymentMethod_CreditCardDisplayFormat' : 'PaymentMethod_CreditCardNoCountryDisplayFormat';
  const cardTypeKey = pi.CardTypeId ? "CreditCardTypeID_".concat(pi.CardTypeId) : "CreditCardTypeID_".concat(_constants.CreditCardType[pi.CardType]);
  return i18n.getString(displayNameKey, {
    cardType: i18n.getString(cardTypeKey),
    cardCategory: pi.CardCategory === _constants.CardCategory.Prepaid ? i18n.getString('CreditCard_Prepaid') : '',
    last4: getCardNumberLast4Digits(pi.Number),
    country: pi.Address ? pi.Address.CountryName : ''
  });
};

const getInvoiceDisplayName = (pi, i18n) => {
  const stringFormat = pi.SAPCustomerName ? 'PaymentMethod_SAPDisplayFormat' : 'PaymentMethod_SAPNoCustomerNameDisplayFormat';
  return i18n.getString(stringFormat, {
    customerName: pi.SAPCustomerName,
    invoiceId: pi.InvoiceId
  });
};

const getCheckDisplayName = (pi, i18n) => i18n.getString('PaymentMethod_CheckDisplayFormat', {
  friendlyName: pi.FriendlyName
});

const getEFTDisplayName = (pi, i18n) => i18n.getString('PaymentMethod_EFTDisplayFormat', {
  friendlyName: pi.FriendlyName
});

const getPayPalDisplayName = (pi, i18n) => pi.Email ? i18n.getString('PaymentMethod_PayPalDisplayFormat', {
  email: pi.Email
}) : i18n.getString('PaymentInstrTypeId_PayPal');

const getSepaDisplayName = (pi, i18n) => i18n.getString('PaymentMethod_SEPADisplayFormat', {
  friendlyName: pi.FriendlyName
});

const getOfflineDisplayName = (pi, i18n) => {
  const stringFormat = pi.Address ? 'PaymentMethod_OfflinePaymentDisplayFormat' : 'PaymentInstrument_OfflinePaymentSimpleDisplayFormat';
  return i18n.getString(stringFormat, {
    country: pi.Address ? pi.Address.CountryName : ''
  });
};

const getBoletoDisplayName = (pi, i18n) => i18n.getString('PaymentMethod_BoletoDisplayFormat', {
  friendlyName: pi.FriendlyName
});

const getVBADisplayName = (pi, i18n) => i18n.getString('PaymentMethod_VBADisplayFormat', {
  friendlyName: pi.FriendlyName
});

const getDisplayNameDict = {
  [_constants.PaymentInstrumentType.CreditCard]: getCreditCardDisplayName,
  [_constants.PaymentInstrumentType.Invoice]: getInvoiceDisplayName,
  [_constants.PaymentInstrumentType.Check]: getCheckDisplayName,
  [_constants.PaymentInstrumentType.ElectronicFundsTransfer]: getEFTDisplayName,
  [_constants.PaymentInstrumentType.PayPal]: getPayPalDisplayName,
  [_constants.PaymentInstrumentType.ELV]: getSepaDisplayName,
  [_constants.PaymentInstrumentType.OfflinePaymentMethod]: getOfflineDisplayName,
  [_constants.PaymentInstrumentType.Boleto]: getBoletoDisplayName,
  [_constants.PaymentInstrumentType.VBA]: getVBADisplayName
};

const isExpired = pi => {
  if (!(pi && Date.parse(pi.ExpirationDate))) {
    return false;
  }

  const date = new Date(pi.ExpirationDate);
  return date.setMonth(date.getMonth() + 1) <= new Date();
};

exports.isExpired = isExpired;

const isOnHold = pi => _underscore.default.isObject(pi) && pi.FinancialStatus !== null && pi.FinancialStatus !== undefined && pi.FinancialStatus !== _constants.PaymentInstrFinancialStatus.NoHold;

exports.isOnHold = isOnHold;

const isDeleted = pi => _underscore.default.isObject(pi) && pi.LifecycleStatusId === _constants.PaymentInstrLifecycleStatus.Deleted;

exports.isDeleted = isDeleted;

const isPurged = pi => _underscore.default.isObject(pi) && pi.IsPurged === true;

exports.isPurged = isPurged;

const isIndiaPI = pi => _underscore.default.isObject(pi) && pi.Address && pi.Address.Country === _constants.CountryCode.IN;
/**
 * Gets a string representation of the expiration date in 'mm/yy' format
 * @param {string} dateString The date string
 * @returns {string} the string 'mm/yy' format of the date
*/


exports.isIndiaPI = isIndiaPI;

const formatExpDate = dateString => {
  if (!Date.parse(dateString)) {
    return '';
  }

  const date = new Date(dateString);
  const yearString = date.getFullYear().toString().substr(-2);
  const monthString = "0".concat(date.getMonth() + 1).substr(-2);
  return "".concat(monthString, "/").concat(yearString);
};

exports.formatExpDate = formatExpDate;

const getDisplayName = (pi, i18n) => {
  if (!(pi && pi.Id && i18n && i18n.getString)) {
    return '';
  }

  const getDisplayNameFunc = getDisplayNameDict[pi.Type];

  if (getDisplayNameFunc) {
    return getDisplayNameFunc(pi, i18n);
  }

  return i18n.getString('PaymentMethod_DefaultFormat', {
    id: pi.Id
  });
};
/**
 * Gets the display string of card status, whether it's on hold, expired or active
 * @param {object} pi the payment instrument
 * @param {object} i18n the i18n object
 * @param {object} permissions the permissions object
 * @returns {string} display string of the payment instrument of type CreditCard
 */


exports.getDisplayName = getDisplayName;

const getCardStatusDisplay = function getCardStatusDisplay(pi, i18n) {
  let permissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!(pi && i18n && i18n.getString && i18n.formatDate)) {
    return '';
  }

  if (isOnHold(pi)) {
    const date = Date.parse(pi.OnHoldDate) ? i18n.formatDate(new Date(pi.OnHoldDate)) : '';
    return i18n.getString('PaymentMethod_CreditCardOnHoldFormat', {
      date
    });
  }

  if (_underscore.default.get(permissions, ['dynamic', 'IndiaCardExpireDate'])) {
    return i18n.getString(isExpired(pi) ? 'PaymentMethod_CreditCardExpiredFormat' : 'PaymentMethod_CreditCardExpiresFormat', {
      date: isIndiaPI(pi) ? i18n.getString('IndiaCardStorage_ExpiryDate') : formatExpDate(pi.ExpirationDate)
    });
  }

  return i18n.getString(isExpired(pi) ? 'PaymentMethod_CreditCardExpiredFormat' : 'PaymentMethod_CreditCardExpiresFormat', {
    date: formatExpDate(pi.ExpirationDate)
  });
};
/**
 * Get the payment option text by the given paymentOptionId
 * @param {number} paymentOptionId the payment option Id
 * @param {*} i18n the i18n object
 * @returns {string} display text of the payment option
 */


exports.getCardStatusDisplay = getCardStatusDisplay;

const getPaymentOptionTextById = (paymentOptionId, i18n) => {
  const paymentOptionIds = _underscore.default.values(_constants.PaymentOptionId);

  return _underscore.default.contains(paymentOptionIds, paymentOptionId) ? i18n.getString("Billing_PaymentOption_".concat(paymentOptionId)) : undefined;
};
/**
 * Get the payment method formatted display string based on MT returned fields
 * This is the same function of server side 'BillingHelper.GetPaymentMethodFormatted'
 * @param {object} piInformation contains below properties:
 *  paymentInstrumentTypeId indicate this PI's type Id
 *  paymentInstrAccountNumber contains this payment's account information, for different payment type this value is different.
 *  paymentInstrFriendlyName this holds the PI friendly named used by Paypal, VBA and Boleto.
 *  paymentInstrCardTypeId this holds the Credit Card Type Id if the PI type is Credit Card.
* @param {*} i18n the i18n object
 * @returns {string} display text of the formatted payment method
 */


exports.getPaymentOptionTextById = getPaymentOptionTextById;

const getPaymentMethodFormatted = (_ref, i18n) => {
  let {
    paymentInstrumentTypeId,
    paymentInstrAccountNumber,
    paymentInstrFriendlyName,
    paymentInstrCardTypeId
  } = _ref;
  let paymentMethodText;

  if (paymentInstrumentTypeId && paymentInstrumentTypeId !== _constants.PaymentInstrumentType.Unset) {
    switch (paymentInstrumentTypeId) {
      case _constants.PaymentInstrumentType.CreditCard:
        {
          if (paymentInstrCardTypeId) {
            paymentMethodText = getCreditCardDisplayName({
              CardTypeId: paymentInstrCardTypeId,
              Number: paymentInstrAccountNumber
            }, i18n);
          }

          break;
        }

      case _constants.PaymentInstrumentType.Invoice:
        {
          paymentMethodText = getInvoiceDisplayName({
            InvoiceId: paymentInstrAccountNumber
          }, i18n);
          break;
        }

      case _constants.PaymentInstrumentType.PayPal:
        {
          paymentMethodText = getPayPalDisplayName({
            Email: paymentInstrFriendlyName
          }, i18n);
          break;
        }

      case _constants.PaymentInstrumentType.ELV:
        {
          paymentMethodText = getSepaDisplayName({
            FriendlyName: paymentInstrAccountNumber
          }, i18n);
          break;
        }

      case _constants.PaymentInstrumentType.OfflinePaymentMethod:
        {
          paymentMethodText = getOfflineDisplayName({}, i18n);
          break;
        }

      case _constants.PaymentInstrumentType.VBA:
        {
          paymentMethodText = getVBADisplayName({
            FriendlyName: paymentInstrFriendlyName
          }, i18n);
          break;
        }

      case _constants.PaymentInstrumentType.Boleto:
        {
          paymentMethodText = getBoletoDisplayName({
            FriendlyName: paymentInstrFriendlyName
          }, i18n);
          break;
        }

      default:
        break;
    }
  }

  return paymentMethodText;
};
/**
 * Calculates the remaining credit for a given SAP, returning null if there is no applicable limit.
 * @param {object} sap the Invoice object to check
 * @param {object} options Some optional parameter to pass, like matchCurrencyCode to ensure that the SAP object matches the given currency code
 * @returns {number} the remaining credit for the given SAP or null if not applicable
 */


exports.getPaymentMethodFormatted = getPaymentMethodFormatted;

const sapCreditRemaining = function sapCreditRemaining(sap) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    matchCurrencyCode
  } = options;
  const hasValidCreditLimit = _underscore.default.isObject(sap) && sap.Type === _constants.PaymentInstrumentType.Invoice && sap.IsCLEOn === true && sap.CreditLimit > 0 && (!matchCurrencyCode || (sap.CurrencyCode || '').toLowerCase() === matchCurrencyCode.toLowerCase());
  return hasValidCreditLimit ? sap.CreditLimit - (sap.SAPBalance || 0) : null;
};
/**
 * Calculates the projected number of days remaining before the given SAP runs out of credit,
 * returning null if there is no valid estimate.
 * @param {object} sap the Invoice object to check
 * @returns {number} the number of days remaining before the given SAP runs out of credit or null
 *                   if there is no valid estimate
 */


exports.sapCreditRemaining = sapCreditRemaining;

const sapCreditDaysRemaining = sap => {
  const creditRemaining = sapCreditRemaining(sap);
  return creditRemaining != null && sap.SAPSpendRunRate > 0 ? Math.ceil(creditRemaining / sap.SAPSpendRunRate) : null;
};
/**
 * Returns the status whether the passed pi was validated
 * @param {object} pi the payment instrument
 * @returns {bool} indicate whether the pi had already validated
 */


exports.sapCreditDaysRemaining = sapCreditDaysRemaining;

const isPiValidated = pi => _underscore.default.isObject(pi) && Number(pi.LifecycleStatusId) > 0 && pi.LifecycleStatusId !== _constants.PaymentInstrLifecycleStatus.PendingValidation;

exports.isPiValidated = isPiValidated;

const isPiType = (pi, piType) => _underscore.default.isObject(pi) && piType && pi.Type === piType;
/**
 * Return whether the payment instrument is the indicated type of pi.
 * @param {object} pi the PaymentInstrument object
 * @returns {bool} indicate whether the provided Pi is the indicated type of pi.
 */


const isCreditCard = pi => isPiType(pi, _constants.PaymentInstrumentType.CreditCard);

exports.isCreditCard = isCreditCard;

const isInvoice = pi => isPiType(pi, _constants.PaymentInstrumentType.Invoice);

exports.isInvoice = isInvoice;

const isBoleto = pi => isPiType(pi, _constants.PaymentInstrumentType.Boleto);

exports.isBoleto = isBoleto;

const isOfflinePaymentMethod = pi => isPiType(pi, _constants.PaymentInstrumentType.OfflinePaymentMethod);

exports.isOfflinePaymentMethod = isOfflinePaymentMethod;

const isSepa = pi => isPiType(pi, _constants.PaymentInstrumentType.ELV);

exports.isSepa = isSepa;

const isPaypal = pi => isPiType(pi, _constants.PaymentInstrumentType.PayPal);

exports.isPaypal = isPaypal;

const getPiCountry = pi => pi.Address ? pi.Address.Country : null;
/**
 * Check whether the given backup PI can be set as a backup for the given primary PI.
 * @param {Object} obj.backupPi - PI to check whether it can be set as backup
 * @param {Object} obj.primaryPi - PI set currently set as primary PI
 * @returns {Boolean} - A value indicating whether the PI can be set as backup
 */


const isValidBackup = _ref2 => {
  let {
    backupPi,
    primaryPi
  } = _ref2;
  return backupPi.SupportsRecurringPayment && backupPi.Id !== primaryPi.Id && backupPi.IsTaxable === primaryPi.IsTaxable && (!primaryPi.IsTaxable || getPiCountry(backupPi) === getPiCountry(primaryPi));
};
/**
 * Returns a copy of the given PaymentInstrument object with additional utility methods.
 * @param {object} pi The PaymentInstrument object to be extended with additional utility methods
 * @param {object} i18n The i18n object
 * @param {object} permissions The permissions object
 * @returns {object} A copy of the extended PaymentInstrument object.
 */


exports.isValidBackup = isValidBackup;

const extendPi = function extendPi() {
  let pi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let i18n = arguments.length > 1 ? arguments[1] : undefined;
  let permissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _underscore.default.defaults({}, pi, {
    id: pi && pi.Id,
    // react DropdownSelector expects an id property
    displayName: getDisplayName(pi, i18n),
    cardStatus: (pi && pi.Type) === _constants.PaymentInstrumentType.CreditCard ? getCardStatusDisplay(pi, i18n, permissions) : '',
    isDeleted: isDeleted(pi),
    isOnHold: isOnHold(pi),
    isPurged: isPurged(pi),
    isExpired: isExpired(pi),
    isValidated: isPiValidated(pi),
    isInvoice: isInvoice(pi),
    isBoleto: isBoleto(pi),
    isOfflinePaymentMethod: isOfflinePaymentMethod(pi),
    isCreditCard: isCreditCard(pi),
    isSepa: isSepa(pi),
    isPaypal: isPaypal(pi)
  });
};
/**
 * Returns a sorted list of PaymentInstrument ordered by Active > Expired > OnHold, then by Type, then by name.
 * @param {object[]} piList A list of PaymentInstrument object to be extended and sorted.
 * @param {object} i18n The i18n object
 * @param {object} permissions The permissions object
 * @returns {object[]} The sorted list of extended PaymentInstrument object.
 */


exports.extendPi = extendPi;

const sortPiList = function sortPiList() {
  let piList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let i18n = arguments.length > 1 ? arguments[1] : undefined;
  let permissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (_underscore.default.isEmpty(piList)) {
    return [];
  }

  const piListExtended = _underscore.default.map(piList, pi => extendPi(pi, i18n, permissions));

  const activePis = _underscore.default.chain(piListExtended).reject(pi => pi.isOnHold || pi.isExpired).sortBy('displayName').sortBy('Type').value();

  const expiredPis = _underscore.default.chain(piListExtended).filter(pi => pi.isExpired && !pi.isOnHold).sortBy('displayName').value();

  const onHoldPis = _underscore.default.chain(piListExtended).filter(pi => pi.isOnHold).sortBy('displayName').value();

  return _underscore.default.union(activePis, expiredPis, onHoldPis);
};
/**
 * Returns a string enum value for Payment Type
 * @param {PaymentTypeId} piTypeId The payment type Id.
 * @returns {PaymentType} The payment type.
 */


exports.sortPiList = sortPiList;

const convertPaymentTypeToString = piTypeId => {
  const key = _underscore.default.findKey(_constants.PaymentTypeId, val => val === piTypeId);

  return _constants.PaymentType[key];
};
/**
 * Returns a string enum value for Payment Type
 * @param {PaymentType} piType The payment type.
 * @returns {PaymentTypeId} The payment type id.
 */


exports.convertPaymentTypeToString = convertPaymentTypeToString;

const convertPaymentTypeToInt = piType => {
  const key = _underscore.default.findKey(_constants.PaymentType, val => val === piType);

  return _constants.PaymentTypeId[key];
};
/**
 * Returns a string enum value for Payment Option
 * @function
 * @param {PaymentOptionId} paymentOptionId The payment option Id.
 * @returns {string} The payment option as a string value.
 */


exports.convertPaymentTypeToInt = convertPaymentTypeToInt;

const convertPaymentOptionToString = paymentOptionId => _underscore.default.result(_constants.PaymentOption, _underscore.default.findKey(_constants.PaymentOptionId, val => val === paymentOptionId), null);
/**
 * Returns a number enum value for Payment Option
 * @function
 * @param {PaymentOption} paymentOptionString The payment option string.
 * @returns {number} The payment option as a number value.
 */


exports.convertPaymentOptionToString = convertPaymentOptionToString;

const convertPaymentOptionToId = paymentOptionString => _underscore.default.result(_constants.PaymentOptionId, _underscore.default.findKey(_constants.PaymentOption, val => val === paymentOptionString), null);
/**
 * Returns the payment type corresponding to the given payment option ID.
 * @param {Number} paymentOptionId - payment option ID to lookup
 * @returns {string} - payment type corresponding to the given payment option ID
 */


exports.convertPaymentOptionToId = convertPaymentOptionToId;

const getPaymentTypeForPaymentOption = paymentOptionId => _underscore.default.findKey(_constants.PaymentSettingsMap, p => _underscore.default.contains(p, paymentOptionId)) || null;
/**
 * Return the text key of the payment transaction status used by billing grid.
 * @param {PaymentTransactionStatus} paymentTransactionStatus the input payment transaction status
 * @param {bool} hasPaymodError whether has paymod error
 * @returns {string} the text key of the payment transaction status used by billing grid.
 */


exports.getPaymentTypeForPaymentOption = getPaymentTypeForPaymentOption;

const getPaymentTransactionStatus = (paymentTransactionStatus, hasPaymodError) => {
  if (paymentTransactionStatus && paymentTransactionStatus !== _constants.PaymentTransactionStatus.Unknown && paymentTransactionStatus !== _constants.PaymentTransactionStatus.Success && !hasPaymodError) {
    return "Billing_PaymentStatus_".concat(paymentTransactionStatus);
  }

  return null;
};
/**
 * Return a filtered list of newly added pending SAPApplications
 * @param {object[]} [sapApplications=[]] the original SAPApplication list to filter
 * @returns {object[]} the filtered SAPApplication list
 */


exports.getPaymentTransactionStatus = getPaymentTransactionStatus;

const filterPendingSAPApplicationsOfNewSAP = function filterPendingSAPApplicationsOfNewSAP() {
  let sapApplications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!_underscore.default.isArray(sapApplications)) {
    return [];
  }

  const types = [_constants.SAPApplicationType.ApplyNewBilltoSAP, _constants.SAPApplicationType.ApplyNewSoldtoSAP, _constants.SAPApplicationType.AddingExistingSAP];
  const statuses = [_constants.SAPApplicationStatus.UnderReview, _constants.SAPApplicationStatus.ActionRequired];
  return _underscore.default.filter(sapApplications, _ref3 => {
    let {
      SAPApplicationType: sapApplicationType,
      SAPApplicationStatus: sapApplicationStatus
    } = _ref3;
    return _underscore.default.contains(types, sapApplicationType) && _underscore.default.contains(statuses, sapApplicationStatus);
  });
};

exports.filterPendingSAPApplicationsOfNewSAP = filterPendingSAPApplicationsOfNewSAP;
const onlinePiTypes = [_constants.PaymentInstrumentType.CreditCard, _constants.PaymentInstrumentType.PayPal];
const offlinePiTypes = [_constants.PaymentInstrumentType.Boleto, _constants.PaymentInstrumentType.ELV, _constants.PaymentInstrumentType.OfflinePaymentMethod];
/**
 * Return a list of payment instruments filtered by payment option
 * @param {object[]} paymentInstruments the list of PI's to filter
 * @param {number} paymentOptionId The type of payment option to use as filter criteria
 * @returns {object[]} the filtered list
 */

const filterPisByPaymentOption = (paymentInstruments, paymentOptionId) => {
  switch (paymentOptionId) {
    case _constants.PaymentOptionId.Invoice:
      return _underscore.default.filter(paymentInstruments, paymentInstrument => paymentInstrument.Type === _constants.PaymentInstrumentType.Invoice);

    case _constants.PaymentOptionId.Prepay:
      return _underscore.default.filter(paymentInstruments, paymentInstrument => _underscore.default.contains([...onlinePiTypes, ...offlinePiTypes], paymentInstrument.Type));

    case _constants.PaymentOptionId.Threshold:
      return _underscore.default.filter(paymentInstruments, paymentInstrument => _underscore.default.contains(onlinePiTypes, paymentInstrument.Type) && paymentInstrument.SupportsPostpay);

    default:
      return [];
  }
};
/**
 * Filters the specified payment instruments,
 * based on their compatibility with the specified account mode.
 * @param {object[]} paymentInstruments the list of payment instruments to be checked for compatibility
 * @param {number} paymentInstruments[].Type the type of payment instrument, e.g. credit card, etc.
 * @param {number|null} accountMode the account mode which all specified payment instruments need to be compatible with
 * @returns {object[]} the filtered list of payment instruments
 */


exports.filterPisByPaymentOption = filterPisByPaymentOption;

const filterPaymentInstrumentsByAccountMode = (paymentInstruments, accountMode) => accountMode !== _constants.AccountMode.UnifiedSmart ? paymentInstruments : _underscore.default.filter(paymentInstruments, pi => !_underscore.default.contains(_constants.ESCPrepayUnsupportedPITypes, pi.Type));

exports.filterPaymentInstrumentsByAccountMode = filterPaymentInstrumentsByAccountMode;

const getPaymentReason = documentType => {
  if (documentType === _constants.DocumentType.WriteOffCreditMemo) {
    return "Billing_ColumnValue_AmountPaid_DocumentType_".concat(documentType);
  }

  return null;
};
/**
 * Filter payment options by user's account mode
 * @param {Object[]} paymentOptions Payment options returned by backend
 * @param {string | null} accountMode account mode
 * @param {Object} pilots Permissions/Features
 * @param {function} poKeySelector An optional function that selects
 * the payment option ID from elements of {@link paymentOptions} collection.
 * By default the elements are assumed to be the IDs.
 * @returns {Object[]} Filtered payment options, share the same type with paymentOptions param
 */


exports.getPaymentReason = getPaymentReason;

const filterPaymentOptionsByAccountMode = (paymentOptions, accountMode, pilots, poKeySelector) => {
  const keySelector = poKeySelector || _underscore.default.identity;
  const {
    UnifiedProductMonthlyInvoice: isUnifiedProductMonthlyInvoiceEnabled,
    ESCPrepay: isEscPrepayEnabled
  } = pilots || {};
  return accountMode !== _constants.AccountMode.UnifiedSmart ? paymentOptions : _underscore.default.filter(paymentOptions, option => {
    switch ("".concat(keySelector(option))) {
      case "".concat(_constants.PaymentOptionId.Invoice):
        return isUnifiedProductMonthlyInvoiceEnabled;

      case "".concat(_constants.PaymentOptionId.Prepay):
        return isEscPrepayEnabled;

      case "".concat(_constants.PaymentOptionId.Threshold):
        return true;

      default:
        return false;
    }
  });
};

exports.filterPaymentOptionsByAccountMode = filterPaymentOptionsByAccountMode;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPermissionMap = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get permission map from domaindata
 * @param {object[]} permissions List of permissions
 * @param {string} permissions[].id Id of permission
 * @param {string} permissions[].action Action name of permission
 * @param {boolean} permissions[].hasPermission Value that indicates if it has permission
 * @returns {object[]} An object with { action : hasPermission }
 */
const getPermissionMap = permissions => {
  const permissionMap = {};

  _underscore.default.each(permissions, permission => _underscore.default.extend(permissionMap, {
    [permission.action]: permission.hasPermission
  }));

  return permissionMap;
};

exports.getPermissionMap = getPermissionMap;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomainsToMT = exports.MTDomainDataToUI = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _constants = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MTDomainDataToUI = _ref => {
  let {
    CleansedDomain,
    Status
  } = _ref;
  return {
    cleansedDomain: CleansedDomain,
    status: Status
  };
};

exports.MTDomainDataToUI = MTDomainDataToUI;

const getDomainsToMT = domainData => _underscore.default.map(domainData, d => ({
  CleansedDomain: d.cleansedDomain,
  Status: d.status || _constants.FCAAccountDomainStatus.Create
}));

exports.getDomainsToMT = getDomainsToMT;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userRoleCanBeSwitchedOut = exports.isAccountScopeUserRole = exports.getAccessibleAccountIds = exports.hasCustomerLevelRoleEntities = exports.UIExternalRoles = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

var _common = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const UIExternalRoles = {
  ApiUser: {
    RoleId: 27,
    IsAccountScope: true,
    CanBeSwitchedOut: true
  },
  AdvertiserManager: {
    RoleId: 16,
    IsAccountScope: true,
    CanBeSwitchedOut: false
  },
  SuperAdmin: {
    RoleId: 41,
    IsAccountScope: false,
    CanBeSwitchedOut: false
  },
  ClientViewer: {
    RoleId: 100,
    IsAccountScope: true,
    CanBeSwitchedOut: false
  },
  StandardUser: {
    RoleId: 203,
    IsAccountScope: true,
    CanBeSwitchedOut: false
  }
};
exports.UIExternalRoles = UIExternalRoles;

const hasCustomerLevelRoleEntities = roles => _underscore.default.any(roles, role => role.EntityType === _common.EntityType.Customer);

exports.hasCustomerLevelRoleEntities = hasCustomerLevelRoleEntities;

const getAccessibleAccountIds = roles => _underscore.default.chain(roles).where({
  EntityType: _common.EntityType.Account
}).pluck('EntityId').value();

exports.getAccessibleAccountIds = getAccessibleAccountIds;

const isAccountScopeUserRole = roleId => _underscore.default.findWhere(UIExternalRoles, {
  RoleId: roleId
}).IsAccountScope;

exports.isAccountScopeUserRole = isAccountScopeUserRole;

const userRoleCanBeSwitchedOut = roleId => _underscore.default.findWhere(UIExternalRoles, {
  RoleId: roleId
}).CanBeSwitchedOut;

exports.userRoleCanBeSwitchedOut = userRoleCanBeSwitchedOut;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMissingMasterData = exports.extendUser = exports.getUserDisplayById = exports.getUserDisplayByUser = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Display format for user email and name
 * @param {object} user User object
 * @param {string} user.Email User email
 * @param {object} user.Name User name object
 * @param {string} user.Name.FirstName User firstName
 * @param {string} user.Name.LastName User lastName
 * @returns {string} The display format for given user
 */
const getUserDisplayByUser = function getUserDisplayByUser() {
  let user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const names = [_underscore.default.result(user.Name, 'FirstName'), _underscore.default.result(user.Name, 'LastName')];

  const nameString = _underscore.default.compact(names).join(' ');

  const emailString = user.Email || '';
  return _underscore.default.compact([emailString, nameString]).join(' - ');
};
/**
 * Find user by id and get display format
 * @param {object[]} users List of users
 * @param {string} id User id string
 * @param {string} users[].Email User email
 * @param {object} users[].Name User name object
 * @param {string} users[].Name.FirstName User firstName
 * @param {string} users[].Name.LastName User lastName
 * @returns {array} The display format of user for given id
 */


exports.getUserDisplayByUser = getUserDisplayByUser;

const getUserDisplayById = (users, id) => {
  const user = _underscore.default.findWhere(users, {
    id
  });

  return getUserDisplayByUser(user);
};
/**
 * Returns a copy of the given user object with additional utility methods.
 * @param {object} user The user object to be extended with additional utility methods.
 * @returns {object} A copy of the extended user object.
 */


exports.getUserDisplayById = getUserDisplayById;

const extendUser = function extendUser() {
  let user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _underscore.default.defaults({}, user, {
    userDisplay: () => getUserDisplayByUser(user)
  });
};
/**
 * Check if user is missing master data in TST scope
 * @param {object} user The user object to be extended with additional utility methods
 * @param {object} user.Name The user Name object containing first and last name
 * @param {object} user.Address The user Address object
 * @param {bool} checkName Flag to check if user name is missing
 * @returns {bool} Value indicating if user is missing master data
 */


exports.extendUser = extendUser;

const isMissingMasterData = function isMissingMasterData() {
  let {
    Name = {},
    Address = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let checkName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return checkName && (_underscore.default.isEmpty(Name.FirstName) || _underscore.default.isEmpty(Name.LastName)) || _underscore.default.isEmpty(Address.Line1) || _underscore.default.isEmpty(Address.City) || _underscore.default.isEmpty(Address.Country);
};

exports.isMissingMasterData = isMissingMasterData;

/***/ })
/******/ ])});;
